var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 914,
    height: 727,
    viewBox: "0 0 914 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_23473_20656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.523 312.737H321.273L318.648 308.237L321.273 303.737H326.523L329.073 308.237L326.523 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 318.437H311.523L308.898 313.862L311.523 309.362H316.698L319.323 313.862L316.698 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 324.062H321.273L318.648 319.562L321.273 314.987H326.523L329.073 319.562L326.523 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 318.437H331.102L328.477 313.862L331.102 309.362H336.277L338.902 313.862L336.277 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 307.112H331.102L328.477 302.612L331.102 298.037H336.277L338.902 302.612L336.277 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 301.487H321.273L318.648 296.912L321.273 292.412H326.523L329.073 296.912L326.523 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 307.112H311.523L308.898 302.612L311.523 298.037H316.698L319.323 302.612L316.698 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 324.062H301.699L299.074 319.562L301.699 314.987H306.949L309.499 319.562L306.949 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 329.688H311.523L308.898 325.188L311.523 320.688H316.698L319.323 325.188L316.698 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 335.388H321.273L318.648 330.812L321.273 326.312H326.523L329.073 330.812L326.523 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 329.688H331.102L328.477 325.188L331.102 320.688H336.277L338.902 325.188L336.277 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 324.062H340.852L338.227 319.562L340.852 314.987H346.102L348.727 319.562L346.102 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 312.737H340.852L338.227 308.237L340.852 303.737H346.102L348.727 308.237L346.102 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 301.487H340.852L338.227 296.912L340.852 292.412H346.102L348.727 296.912L346.102 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 295.787H331.102L328.477 291.287L331.102 286.787H336.277L338.902 291.287L336.277 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 290.162H321.273L318.648 285.662L321.273 281.087H326.523L329.073 285.662L326.523 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 295.787H311.523L308.898 291.287L311.523 286.787H316.698L319.323 291.287L316.698 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 301.487H301.699L299.074 296.912L301.699 292.412H306.949L309.499 296.912L306.949 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 312.737H301.699L299.074 308.237L301.699 303.737H306.949L309.499 308.237L306.949 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 329.688H291.949L289.324 325.188L291.949 320.688H297.124L299.749 325.188L297.124 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 335.388H301.699L299.074 330.812L301.699 326.312H306.949L309.499 330.812L306.949 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 341.012H311.523L308.898 336.512L311.523 332.012H316.698L319.323 336.512L316.698 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 346.637H321.273L318.648 342.137L321.273 337.637H326.523L329.073 342.137L326.523 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 341.012H331.102L328.477 336.512L331.102 332.012H336.277L338.902 336.512L336.277 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 335.388H340.852L338.227 330.812L340.852 326.312H346.102L348.727 330.812L346.102 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 329.688H350.676L348.051 325.188L350.676 320.688H355.851L358.476 325.188L355.851 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 318.437H350.676L348.051 313.862L350.676 309.362H355.851L358.476 313.862L355.851 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 307.112H350.676L348.051 302.612L350.676 298.037H355.851L358.476 302.612L355.851 307.112Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 295.787H350.676L348.051 291.287L350.676 286.787H355.851L358.476 291.287L355.851 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 290.162H340.852L338.227 285.662L340.852 281.087H346.102L348.727 285.662L346.102 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 284.537H331.102L328.477 279.962L331.102 275.462H336.277L338.902 279.962L336.277 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 278.837H321.273L318.648 274.337L321.273 269.837H326.523L329.073 274.337L326.523 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 284.537H311.523L308.898 279.962L311.523 275.462H316.698L319.323 279.962L316.698 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 290.162H301.699L299.074 285.662L301.699 281.087H306.949L309.499 285.662L306.949 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 295.787H291.949L289.324 291.287L291.949 286.787H297.124L299.749 291.287L297.124 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 307.112H291.949L289.324 302.612L291.949 298.037H297.124L299.749 302.612L297.124 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 318.437H291.949L289.324 313.862L291.949 309.362H297.124L299.749 313.862L297.124 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 335.388H282.125L279.5 330.812L282.125 326.312H287.375L289.925 330.812L287.375 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 341.012H291.949L289.324 336.512L291.949 332.012H297.124L299.749 336.512L297.124 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 346.637H301.699L299.074 342.137L301.699 337.637H306.949L309.499 342.137L306.949 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 352.337H311.523L308.898 347.837L311.523 343.262H316.698L319.323 347.837L316.698 352.337Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 357.962H321.273L318.648 353.462L321.273 348.962H326.523L329.073 353.462L326.523 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 352.337H331.102L328.477 347.837L331.102 343.262H336.277L338.902 347.837L336.277 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 346.637H340.852L338.227 342.137L340.852 337.637H346.102L348.727 342.137L346.102 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 341.012H350.676L348.051 336.512L350.676 332.012H355.851L358.476 336.512L355.851 341.012Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 335.388H360.426L357.801 330.812L360.426 326.312H365.676L368.301 330.812L365.676 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 324.062H360.426L357.801 319.562L360.426 314.987H365.676L368.301 319.562L365.676 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 312.737H360.426L357.801 308.237L360.426 303.737H365.676L368.301 308.237L365.676 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 301.487H360.426L357.801 296.912L360.426 292.412H365.676L368.301 296.912L365.676 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 290.162H360.426L357.801 285.662L360.426 281.087H365.676L368.301 285.662L365.676 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 284.537H350.676L348.051 279.962L350.676 275.462H355.851L358.476 279.962L355.851 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.101 278.837H340.851L338.301 274.337L340.851 269.837H346.101L348.651 274.337L346.101 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.276 273.137H331.101L328.551 268.712L331.101 264.212H336.276L338.826 268.712L336.276 273.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 267.512H321.273L318.648 263.012L321.273 258.512H326.523L329.073 263.012L326.523 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 273.212H311.523L308.898 268.712L311.523 264.137H316.698L319.323 268.712L316.698 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 278.837H301.699L299.074 274.337L301.699 269.837H306.949L309.499 274.337L306.949 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 284.537H291.949L289.324 279.962L291.949 275.462H297.124L299.749 279.962L297.124 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 290.163H282.125L279.5 285.663L282.125 281.088H287.375L289.925 285.663L287.375 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 301.487H282.125L279.5 296.912L282.125 292.412H287.375L289.925 296.912L287.375 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 312.737H282.125L279.5 308.237L282.125 303.737H287.375L289.925 308.237L287.375 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 324.062H282.125L279.5 319.562L282.125 314.987H287.375L289.925 319.562L287.375 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 341.012H272.3L269.75 336.512L272.3 332.012H277.55L280.175 336.512L277.55 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 346.637H282.125L279.5 342.137L282.125 337.637H287.375L289.925 342.137L287.375 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 352.337H291.949L289.324 347.837L291.949 343.262H297.124L299.749 347.837L297.124 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 357.962H301.699L299.074 353.462L301.699 348.962H306.949L309.499 353.462L306.949 357.962Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 363.662H311.523L308.898 359.087L311.523 354.587H316.698L319.323 359.087L316.698 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 369.287H321.273L318.648 364.787L321.273 360.212H326.523L329.073 364.787L326.523 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 363.662H331.102L328.477 359.087L331.102 354.587H336.277L338.902 359.087L336.277 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 357.962H340.852L338.227 353.462L340.852 348.962H346.102L348.727 353.462L346.102 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 352.337H350.676L348.051 347.837L350.676 343.262H355.851L358.476 347.837L355.851 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 346.637H360.426L357.801 342.137L360.426 337.637H365.676L368.301 342.137L365.676 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 341.012H370.25L367.625 336.512L370.25 332.012H375.425L378.05 336.512L375.425 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 329.688H370.25L367.625 325.188L370.25 320.688H375.425L378.05 325.188L375.425 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 318.437H370.25L367.625 313.862L370.25 309.362H375.425L378.05 313.862L375.425 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 307.112H370.25L367.625 302.612L370.25 298.037H375.425L378.05 302.612L375.425 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 295.787H370.25L367.625 291.287L370.25 286.787H375.425L378.05 291.287L375.425 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 284.538H370.25L367.625 279.963L370.25 275.463H375.425L378.05 279.963L375.425 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.374 278.462H360.649L358.324 274.337L360.649 270.212H365.374L367.774 274.337L365.374 278.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.402 258.662H332.977L332.227 257.387L332.977 256.112H334.402L335.152 257.387L334.402 258.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.476 254.537H322.251L320.676 251.762L322.251 248.912H325.476L327.126 251.762L325.476 254.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.626 261.737H311.601L309.051 257.387L311.601 253.037H316.626L319.101 257.387L316.626 261.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 267.512H301.699L299.074 263.012L301.699 258.512H306.949L309.499 263.012L306.949 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 273.212H291.949L289.324 268.712L291.949 264.137H297.124L299.749 268.712L297.124 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 278.838H282.125L279.5 274.338L282.125 269.838H287.375L289.925 274.338L287.375 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 284.538H272.3L269.75 279.963L272.3 275.463H277.55L280.175 279.963L277.55 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 295.787H272.3L269.75 291.287L272.3 286.787H277.55L280.175 291.287L277.55 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 307.112H272.3L269.75 302.612L272.3 298.037H277.55L280.175 302.612L277.55 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 318.437H272.3L269.75 313.862L272.3 309.362H277.55L280.175 313.862L277.55 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 329.688H272.3L269.75 325.188L272.3 320.688H277.55L280.175 325.188L277.55 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 346.637H262.551L259.926 342.137L262.551 337.637H267.801L270.351 342.137L267.801 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 352.337H272.3L269.75 347.837L272.3 343.262H277.55L280.175 347.837L277.55 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 357.963H282.125L279.5 353.463L282.125 348.963H287.375L289.925 353.463L287.375 357.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 363.662H291.949L289.324 359.087L291.949 354.587H297.124L299.749 359.087L297.124 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 369.287H301.699L299.074 364.787L301.699 360.212H306.949L309.499 364.787L306.949 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 374.912H311.523L308.898 370.412L311.523 365.912H316.698L319.323 370.412L316.698 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1 378.138H322.7L321.5 376.038L322.7 373.938H325.1L326.3 376.038L325.1 378.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 374.912H331.102L328.477 370.412L331.102 365.912H336.277L338.902 370.412L336.277 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 369.287H340.852L338.227 364.787L340.852 360.212H346.102L348.727 364.787L346.102 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 363.662H350.676L348.051 359.087L350.676 354.587H355.851L358.476 359.087L355.851 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 357.962H360.426L357.801 353.462L360.426 348.962H365.676L368.301 353.462L365.676 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 352.337H370.25L367.625 347.837L370.25 343.262H375.425L378.05 347.837L375.425 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 346.637H380L377.375 342.137L380 337.637H385.25L387.875 342.137L385.25 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 335.388H380L377.375 330.812L380 326.312H385.25L387.875 330.812L385.25 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 324.062H380L377.375 319.562L380 314.987H385.25L387.875 319.562L385.25 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 312.737H380L377.375 308.237L380 303.737H385.25L387.875 308.237L385.25 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 301.487H380L377.375 296.912L380 292.412H385.25L387.875 296.912L385.25 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 290.163H380L377.375 285.663L380 281.088H385.25L387.875 285.663L385.25 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.101 278.612H380.151L377.676 274.337L380.151 269.987H385.101L387.576 274.337L385.101 278.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.002 270.737H371.677L370.477 268.712L371.677 266.612H374.002L375.202 268.712L374.002 270.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.151 252.962H342.801L342.051 251.762L342.801 250.487H344.151L344.826 251.762L344.151 252.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.326 242.912H322.476L321.051 240.437L322.476 237.962H325.326L326.751 240.437L325.326 242.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.676 261.062H292.401L290.301 257.387L292.401 253.712H296.676L298.776 257.387L296.676 261.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.299 267.512H282.124L279.574 263.012L282.124 258.587H287.299L289.924 263.012L287.299 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 273.212H272.3L269.75 268.712L272.3 264.137H277.55L280.175 268.712L277.55 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.748 277.037H263.598L262.023 274.337L263.598 271.637H266.748L268.248 274.337L266.748 277.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.724 290.012H262.624L260.074 285.662L262.624 281.237H267.724L270.199 285.662L267.724 290.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 301.487H262.551L259.926 296.912L262.551 292.412H267.801L270.351 296.912L267.801 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 312.737H262.551L259.926 308.237L262.551 303.737H267.801L270.351 308.237L267.801 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 324.062H262.551L259.926 319.562L262.551 314.987H267.801L270.351 319.562L267.801 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 335.388H262.551L259.926 330.812L262.551 326.312H267.801L270.351 330.812L267.801 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.976 352.337H252.726L250.176 347.837L252.726 343.262H257.976L260.601 347.837L257.976 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 357.962H262.551L259.926 353.462L262.551 348.962H267.801L270.351 353.462L267.801 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 363.663H272.3L269.75 359.088L272.3 354.588H277.55L280.175 359.088L277.55 363.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 369.288H282.125L279.5 364.788L282.125 360.213H287.375L289.925 364.788L287.375 369.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.826 374.388H292.176L289.926 370.413L292.176 366.438H296.826L299.151 370.413L296.826 374.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.074 377.387H303.574L302.824 376.037L303.574 374.762H305.074L305.824 376.037L305.074 377.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.874 389.012H322.924L321.949 387.362L322.924 385.712H324.874L325.849 387.362L324.874 389.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 386.237H331.102L328.477 381.737L331.102 377.162H336.277L338.902 381.737L336.277 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 380.612H340.852L338.227 376.037L340.852 371.537H346.102L348.727 376.037L346.102 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 374.912H350.676L348.051 370.412L350.676 365.912H355.851L358.476 370.412L355.851 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 369.287H360.426L357.801 364.787L360.426 360.212H365.676L368.301 364.787L365.676 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 363.663H370.25L367.625 359.088L370.25 354.588H375.425L378.05 359.088L375.425 363.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 357.963H380L377.375 353.463L380 348.963H385.25L387.875 353.463L385.25 357.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 352.337H389.824L387.199 347.837L389.824 343.262H394.999L397.624 347.837L394.999 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 341.012H389.824L387.199 336.512L389.824 332.012H394.999L397.624 336.512L394.999 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 329.688H389.824L387.199 325.188L389.824 320.688H394.999L397.624 325.188L394.999 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 318.437H389.824L387.199 313.862L389.824 309.362H394.999L397.624 313.862L394.999 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 307.112H389.824L387.199 302.612L389.824 298.037H394.999L397.624 302.612L394.999 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 295.787H389.824L387.199 291.287L389.824 286.787H394.999L397.624 291.287L394.999 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 284.537H389.824L387.199 279.962L389.824 275.462H394.999L397.624 279.962L394.999 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.449 260.237H371.224L369.574 257.387L371.224 254.537H374.449L376.099 257.387L374.449 260.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.624 254.537H361.474L359.824 251.762L361.474 248.912H364.624L366.274 251.762L364.624 254.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.298 241.787H342.648L341.898 240.437L342.648 239.012H344.298L345.048 240.437L344.298 241.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.398 236.087H332.898L332.148 234.737L332.898 233.462H334.398L335.223 234.737L334.398 236.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.773 232.337H322.023L320.148 229.112L322.023 225.887H325.773L327.648 229.112L325.773 232.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.975 250.337H292.1L289.625 246.062L292.1 241.862H296.975L299.45 246.062L296.975 250.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.698 255.138H282.723L280.773 251.763L282.723 248.312H286.698L288.723 251.763L286.698 255.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.449 258.287H274.399L273.949 257.387L274.399 256.487H275.449L275.974 257.387L275.449 258.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.851 293.837H253.926L252.426 291.287L253.926 288.737H256.851L258.276 291.287L256.851 293.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.976 307.112H252.726L250.176 302.612L252.726 298.037H257.976L260.601 302.612L257.976 307.112Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.976 318.437H252.726L250.176 313.862L252.726 309.362H257.976L260.601 313.862L257.976 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.976 329.688H252.726L250.176 325.188L252.726 320.688H257.976L260.601 325.188L257.976 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.976 341.012H252.726L250.176 336.512L252.726 332.012H257.976L260.601 336.512L257.976 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.126 354.363H245.076L244.551 353.463L245.076 352.562H246.126L246.576 353.463L246.126 354.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.975 363.587H252.8L250.25 359.087L252.8 354.662H257.975L260.525 359.087L257.975 363.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.801 369.287H262.551L259.926 364.787L262.551 360.212H267.801L270.351 364.787L267.801 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 374.912H272.3L269.75 370.412L272.3 365.912H277.55L280.175 370.412L277.55 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.549 379.187H282.949L281.074 376.037L282.949 372.887H286.549L288.349 376.037L286.549 379.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.076 402.437H321.726L319.551 398.687L321.726 394.937H326.076L328.251 398.687L326.076 402.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 397.562H331.102L328.477 392.987L331.102 388.487H336.277L338.902 392.987L336.277 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 391.862H340.852L338.227 387.362L340.852 382.862H346.102L348.727 387.362L346.102 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 386.237H350.676L348.051 381.737L350.676 377.162H355.851L358.476 381.737L355.851 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 380.612H360.426L357.801 376.037L360.426 371.537H365.676L368.301 376.037L365.676 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 374.912H370.25L367.625 370.412L370.25 365.912H375.425L378.05 370.412L375.425 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 369.288H380L377.375 364.788L380 360.213H385.25L387.875 364.788L385.25 369.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 363.662H389.824L387.199 359.087L389.824 354.587H394.999L397.624 359.087L394.999 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 357.962H399.574L396.949 353.462L399.574 348.962H404.824L407.449 353.462L404.824 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 346.637H399.574L396.949 342.137L399.574 337.637H404.824L407.449 342.137L404.824 346.637Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 335.388H399.574L396.949 330.812L399.574 326.312H404.824L407.449 330.812L404.824 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 324.062H399.574L396.949 319.562L399.574 314.987H404.824L407.449 319.562L404.824 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 312.737H399.574L396.949 308.237L399.574 303.737H404.824L407.449 308.237L404.824 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 301.487H399.574L396.949 296.912L399.574 292.412H404.824L407.449 296.912L404.824 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 290.162H399.574L396.949 285.662L399.574 281.087H404.824L407.449 285.662L404.824 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.998 277.488H400.398L398.523 274.338L400.398 271.188H403.998L405.873 274.338L403.998 277.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.65 263.762H401.75L401.375 263.012L401.75 262.262H402.65L403.025 263.012L402.65 263.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.801 259.712H391.026L389.676 257.387L391.026 254.987H393.801L395.151 257.387L393.801 259.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.101 256.037H380.151L377.676 251.762L380.151 247.412H385.101L387.576 251.762L385.101 256.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.776 247.712H371.901L370.926 246.062L371.901 244.412H373.776L374.751 246.062L373.776 247.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.598 244.787H360.498L358.023 240.437L360.498 236.012H365.598L368.073 240.437L365.598 244.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.798 237.437H351.723L350.148 234.737L351.723 232.112H354.798L356.298 234.737L354.798 237.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.751 231.288H342.201L340.926 229.113L342.201 226.938H344.751L345.951 229.113L344.751 231.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 227.987H331.102L328.477 223.487L331.102 218.912H336.277L338.902 223.487L336.277 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 222.362H321.273L318.648 217.787L321.273 213.287H326.523L329.073 217.787L326.523 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.25 227.163H311.975L309.875 223.488L311.975 219.812H316.25L318.35 223.488L316.25 227.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.276 232.487H302.376L300.426 229.112L302.376 225.737H306.276L308.151 229.112L306.276 232.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 239.312H291.949L289.324 234.737L291.949 230.237H297.124L299.749 234.737L297.124 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 244.938H282.125L279.5 240.438L282.125 235.938H287.375L289.925 240.438L287.375 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 250.562H272.3L269.75 246.062L272.3 241.562H277.55L280.175 246.062L277.55 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.651 310.112H244.476L243.426 308.237L244.476 306.362H246.651L247.776 308.237L246.651 310.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.926 323.688H243.201L240.801 319.562L243.201 315.438H247.926L250.326 319.562L247.926 323.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.926 334.937H243.201L240.801 330.812L243.201 326.762H247.926L250.326 330.812L247.926 334.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.926 346.262H243.201L240.801 342.137L243.201 338.012H247.926L250.326 342.137L247.926 346.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.798 371.162H254.973L254.523 370.412L254.973 369.662H255.798L256.248 370.412L255.798 371.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.075 377.613H264.275L263.375 376.038L264.275 374.463H266.075L266.975 376.038L266.075 377.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 408.812H331.102L328.477 404.312L331.102 399.812H336.277L338.902 404.312L336.277 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 403.187H340.852L338.227 398.687L340.852 394.112H346.102L348.727 398.687L346.102 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 397.562H350.676L348.051 392.987L350.676 388.487H355.851L358.476 392.987L355.851 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 391.862H360.426L357.801 387.362L360.426 382.862H365.676L368.301 387.362L365.676 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 386.237H370.25L367.625 381.737L370.25 377.162H375.425L378.05 381.737L375.425 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 380.612H380L377.375 376.037L380 371.537H385.25L387.875 376.037L385.25 380.612Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 374.912H389.824L387.199 370.412L389.824 365.912H394.999L397.624 370.412L394.999 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 369.287H399.574L396.949 364.787L399.574 360.212H404.824L407.449 364.787L404.824 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 363.662H409.398L406.773 359.087L409.398 354.587H414.573L417.198 359.087L414.573 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 352.337H409.398L406.773 347.837L409.398 343.262H414.573L417.198 347.837L414.573 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 341.012H409.398L406.773 336.512L409.398 332.012H414.573L417.198 336.512L414.573 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 329.688H409.398L406.773 325.188L409.398 320.688H414.573L417.198 325.188L414.573 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.577 318.288H409.402L406.852 313.863L409.402 309.438H414.577L417.127 313.863L414.577 318.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.851 304.037H411.126L410.301 302.612L411.126 301.112H412.851L413.676 302.612L412.851 304.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 295.787H409.398L406.773 291.287L409.398 286.787H414.573L417.198 291.287L414.573 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 284.537H409.398L406.773 279.962L409.398 275.462H414.573L417.198 279.962L414.573 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 273.212H409.398L406.773 268.712L409.398 264.137H414.573L417.198 268.712L414.573 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 261.887H409.398L406.773 257.387L409.398 252.887H414.573L417.198 257.387L414.573 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.752 256.187H399.652L397.102 251.762L399.652 247.262H404.752L407.302 251.762L404.752 256.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 250.562H389.824L387.199 246.062L389.824 241.562H394.999L397.624 246.062L394.999 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 244.938H380L377.375 240.438L380 235.938H385.25L387.875 240.438L385.25 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.348 239.162H370.323L367.773 234.737L370.323 230.387H375.348L377.898 234.737L375.348 239.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 233.612H360.426L357.801 229.112L360.426 224.612H365.676L368.301 229.112L365.676 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 227.987H350.676L348.051 223.487L350.676 218.912H355.851L358.476 223.487L355.851 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.949 222.138H340.924L338.449 217.788L340.924 213.438H345.949L348.499 217.788L345.949 222.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 216.662H331.102L328.477 212.162L331.102 207.662H336.277L338.902 212.162L336.277 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 211.037H321.273L318.648 206.537L321.273 201.962H326.523L329.073 206.537L326.523 211.037Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 216.662H311.523L308.898 212.162L311.523 207.662H316.698L319.323 212.162L316.698 216.662Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 222.362H301.699L299.074 217.787L301.699 213.287H306.949L309.499 217.787L306.949 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.899 227.612H292.099L289.699 223.487L292.099 219.287H296.899L299.299 223.487L296.899 227.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 233.612H282.125L279.5 229.112L282.125 224.612H287.375L289.925 229.112L287.375 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55 239.312H272.3L269.75 234.737L272.3 230.237H277.55L280.175 234.737L277.55 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.051 419.763H331.326L328.926 415.638L331.326 411.513H336.051L338.451 415.638L336.051 419.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 414.512H340.852L338.227 409.937L340.852 405.437H346.102L348.727 409.937L346.102 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 408.812H350.676L348.051 404.312L350.676 399.812H355.851L358.476 404.312L355.851 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 403.187H360.426L357.801 398.687L360.426 394.112H365.676L368.301 398.687L365.676 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 397.562H370.25L367.625 392.987L370.25 388.487H375.425L378.05 392.987L375.425 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 391.862H380L377.375 387.362L380 382.862H385.25L387.875 387.362L385.25 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 386.237H389.824L387.199 381.737L389.824 377.162H394.999L397.624 381.737L394.999 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 380.612H399.574L396.949 376.037L399.574 371.537H404.824L407.449 376.037L404.824 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 374.912H409.398L406.773 370.412L409.398 365.912H414.573L417.198 370.412L414.573 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 369.287H419.148L416.523 364.787L419.148 360.212H424.398L427.023 364.787L424.398 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 357.962H419.148L416.523 353.462L419.148 348.962H424.398L427.023 353.462L424.398 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 346.637H419.148L416.523 342.137L419.148 337.637H424.398L427.023 342.137L424.398 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.576 333.962H419.976L418.176 330.812L419.976 327.737H423.576L425.376 330.812L423.576 333.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.301 320.387H421.251L420.801 319.562L421.251 318.662H422.301L422.751 319.562L422.301 320.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.402 312.737H419.152L416.602 308.237L419.152 303.737H424.402L426.952 308.237L424.402 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 301.487H419.148L416.523 296.912L419.148 292.412H424.398L427.023 296.912L424.398 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 290.162H419.148L416.523 285.662L419.148 281.087H424.398L427.023 285.662L424.398 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 278.837H419.148L416.523 274.337L419.148 269.837H424.398L427.023 274.337L424.398 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 267.512H419.148L416.523 263.012L419.148 258.512H424.398L427.023 263.012L424.398 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 256.263H419.148L416.523 251.763L419.148 247.188H424.398L427.023 251.763L424.398 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 250.562H409.398L406.773 246.062L409.398 241.562H414.573L417.198 246.062L414.573 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 244.938H399.574L396.949 240.438L399.574 235.938H404.824L407.449 240.438L404.824 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 239.312H389.824L387.199 234.737L389.824 230.237H394.999L397.624 234.737L394.999 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 233.612H380L377.375 229.112L380 224.612H385.25L387.875 229.112L385.25 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 227.987H370.25L367.625 223.487L370.25 218.912H375.425L378.05 223.487L375.425 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 222.362H360.426L357.801 217.787L360.426 213.287H365.676L368.301 217.787L365.676 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 216.662H350.676L348.051 212.162L350.676 207.662H355.851L358.476 212.162L355.851 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 211.037H340.852L338.227 206.537L340.852 201.962H346.102L348.727 206.537L346.102 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 205.412H331.102L328.477 200.837L331.102 196.337H336.277L338.902 200.837L336.277 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 199.712H321.273L318.648 195.212L321.273 190.712H326.523L329.073 195.212L326.523 199.712Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 205.412H311.523L308.898 200.837L311.523 196.337H316.698L319.323 200.837L316.698 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 211.037H301.699L299.074 206.537L301.699 201.962H306.949L309.499 206.537L306.949 211.037Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.052 216.513H292.027L289.477 212.163L292.027 207.812H297.052L299.527 212.163L297.052 216.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.675 224.688H274.25L273.5 223.488L274.25 222.213H275.675L276.35 223.488L275.675 224.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.475 331.638H225.575L225.125 330.812L225.575 330.062H226.475L226.925 330.812L226.475 331.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.373 429.888H331.998L330.273 426.888L331.998 423.963H335.373L337.098 426.888L335.373 429.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 425.763H340.852L338.227 421.263L340.852 416.763H346.102L348.727 421.263L346.102 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 420.137H350.676L348.051 415.637L350.676 411.062H355.851L358.476 415.637L355.851 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 414.512H360.426L357.801 409.937L360.426 405.437H365.676L368.301 409.937L365.676 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 408.812H370.25L367.625 404.312L370.25 399.812H375.425L378.05 404.312L375.425 408.812Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 403.187H380L377.375 398.687L380 394.112H385.25L387.875 398.687L385.25 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 397.562H389.824L387.199 392.987L389.824 388.487H394.999L397.624 392.987L394.999 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 391.862H399.574L396.949 387.362L399.574 382.862H404.824L407.449 387.362L404.824 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 386.237H409.398L406.773 381.737L409.398 377.162H414.573L417.198 381.737L414.573 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 380.612H419.148L416.523 376.037L419.148 371.537H424.398L427.023 376.037L424.398 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 374.912H428.977L426.352 370.412L428.977 365.912H434.152L436.777 370.412L434.152 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 363.662H428.977L426.352 359.087L428.977 354.587H434.152L436.777 359.087L434.152 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.151 352.262H428.976L426.426 347.837L428.976 343.337H434.151L436.701 347.837L434.151 352.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.426 338.013H430.701L429.801 336.513L430.701 334.938H432.426L433.326 336.513L432.426 338.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.924 329.237H429.274L426.949 325.187L429.274 321.137H433.924L436.249 325.187L433.924 329.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 318.437H428.977L426.352 313.862L428.977 309.362H434.152L436.777 313.862L434.152 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 307.112H428.977L426.352 302.612L428.977 298.037H434.152L436.777 302.612L434.152 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 295.787H428.977L426.352 291.287L428.977 286.787H434.152L436.777 291.287L434.152 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 284.537H428.977L426.352 279.962L428.977 275.462H434.152L436.777 279.962L434.152 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 273.212H428.977L426.352 268.712L428.977 264.137H434.152L436.777 268.712L434.152 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 261.887H428.977L426.352 257.387L428.977 252.887H434.152L436.777 257.387L434.152 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 250.562H428.977L426.352 246.062L428.977 241.562H434.152L436.777 246.062L434.152 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 244.938H419.148L416.523 240.438L419.148 235.938H424.398L427.023 240.438L424.398 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 239.312H409.398L406.773 234.737L409.398 230.237H414.573L417.198 234.737L414.573 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 233.612H399.574L396.949 229.112L399.574 224.612H404.824L407.449 229.112L404.824 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 227.987H389.824L387.199 223.487L389.824 218.912H394.999L397.624 223.487L394.999 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 222.362H380L377.375 217.787L380 213.287H385.25L387.875 217.787L385.25 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 216.662H370.25L367.625 212.162L370.25 207.662H375.425L378.05 212.162L375.425 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 211.037H360.426L357.801 206.537L360.426 201.962H365.676L368.301 206.537L365.676 211.037Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 205.412H350.676L348.051 200.837L350.676 196.337H355.851L358.476 200.837L355.851 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 199.712H340.852L338.227 195.212L340.852 190.712H346.102L348.727 195.212L346.102 199.712Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 194.087H331.102L328.477 189.587L331.102 185.012H336.277L338.902 189.587L336.277 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 188.462H321.273L318.648 183.887L321.273 179.387H326.523L329.073 183.887L326.523 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.698 194.087H311.523L308.898 189.587L311.523 185.012H316.698L319.323 189.587L316.698 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.949 199.712H301.699L299.074 195.212L301.699 190.712H306.949L309.499 195.212L306.949 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 205.337H291.949L289.324 200.837L291.949 196.412H297.124L299.674 200.837L297.124 205.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 210.437H282.5L280.25 206.537L282.5 202.637H287L289.25 206.537L287 210.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 437.088H340.852L338.227 432.588L340.852 428.088H346.102L348.727 432.588L346.102 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 431.462H350.676L348.051 426.888L350.676 422.388H355.851L358.476 426.888L355.851 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 425.763H360.426L357.801 421.263L360.426 416.763H365.676L368.301 421.263L365.676 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 420.138H370.25L367.625 415.638L370.25 411.062H375.425L378.05 415.638L375.425 420.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 414.513H380L377.375 409.938L380 405.438H385.25L387.875 409.938L385.25 414.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 408.812H389.824L387.199 404.312L389.824 399.812H394.999L397.624 404.312L394.999 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 403.187H399.574L396.949 398.687L399.574 394.112H404.824L407.449 398.687L404.824 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 397.562H409.398L406.773 392.987L409.398 388.487H414.573L417.198 392.987L414.573 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 391.862H419.148L416.523 387.362L419.148 382.862H424.398L427.023 387.362L424.398 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 386.237H428.977L426.352 381.737L428.977 377.162H434.152L436.777 381.737L434.152 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 380.612H438.727L436.102 376.037L438.727 371.537H443.977L446.602 376.037L443.977 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 369.287H438.727L436.102 364.787L438.727 360.212H443.977L446.602 364.787L443.977 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.976 357.962H438.726L436.176 353.462L438.726 348.962H443.976L446.526 353.462L443.976 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.752 346.338H438.952L436.477 342.138L438.952 337.938H443.752L446.227 342.138L443.752 346.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 335.388H438.727L436.102 330.812L438.727 326.312H443.977L446.602 330.812L443.977 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 324.062H438.727L436.102 319.562L438.727 314.987H443.977L446.602 319.562L443.977 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 312.737H438.727L436.102 308.237L438.727 303.737H443.977L446.602 308.237L443.977 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 301.487H438.727L436.102 296.912L438.727 292.412H443.977L446.602 296.912L443.977 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 290.162H438.727L436.102 285.662L438.727 281.087H443.977L446.602 285.662L443.977 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 278.837H438.727L436.102 274.337L438.727 269.837H443.977L446.602 274.337L443.977 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 267.512H438.727L436.102 263.012L438.727 258.512H443.977L446.602 263.012L443.977 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 256.263H438.727L436.102 251.763L438.727 247.188H443.977L446.602 251.763L443.977 256.263Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 244.938H438.727L436.102 240.438L438.727 235.938H443.977L446.602 240.438L443.977 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 239.312H428.977L426.352 234.737L428.977 230.237H434.152L436.777 234.737L434.152 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 233.612H419.148L416.523 229.112L419.148 224.612H424.398L427.023 229.112L424.398 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 227.987H409.398L406.773 223.487L409.398 218.912H414.573L417.198 223.487L414.573 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 222.362H399.574L396.949 217.787L399.574 213.287H404.824L407.449 217.787L404.824 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 216.662H389.824L387.199 212.162L389.824 207.662H394.999L397.624 212.162L394.999 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 211.038H380L377.375 206.538L380 201.963H385.25L387.875 206.538L385.25 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 205.413H370.25L367.625 200.838L370.25 196.338H375.425L378.05 200.838L375.425 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 199.712H360.426L357.801 195.212L360.426 190.712H365.676L368.301 195.212L365.676 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 194.087H350.676L348.051 189.587L350.676 185.012H355.851L358.476 189.587L355.851 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 188.462H340.852L338.227 183.887L340.852 179.387H346.102L348.727 183.887L346.102 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 182.762H331.102L328.477 178.262L331.102 173.762H336.277L338.902 178.262L336.277 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.298 176.762H321.498L319.023 172.637L321.498 168.438H326.298L328.698 172.637L326.298 176.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.501 180.737H312.726L311.301 178.262L312.726 175.787H315.501L316.926 178.262L315.501 180.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7 184.638H303.875L303.5 183.888L303.875 183.213H304.7L305.15 183.888L304.7 184.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 194.012H291.949L289.324 189.587L291.949 185.087H297.124L299.674 189.587L297.124 194.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.275 196.113H284.225L283.625 195.213L284.225 194.238H285.275L285.8 195.213L285.275 196.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.224 452.238H332.149L330.574 449.538L332.149 446.838H335.224L336.799 449.538L335.224 452.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 448.413H340.852L338.227 443.913L340.852 439.338H346.102L348.727 443.913L346.102 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 442.713H350.676L348.051 438.213L350.676 433.713H355.851L358.476 438.213L355.851 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 437.088H360.426L357.801 432.588L360.426 428.088H365.676L368.301 432.588L365.676 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 431.462H370.25L367.625 426.888L370.25 422.388H375.425L378.05 426.888L375.425 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 425.763H380L377.375 421.263L380 416.763H385.25L387.875 421.263L385.25 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 420.137H389.824L387.199 415.637L389.824 411.062H394.999L397.624 415.637L394.999 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 414.512H399.574L396.949 409.937L399.574 405.437H404.824L407.449 409.937L404.824 414.512Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 408.812H409.398L406.773 404.312L409.398 399.812H414.573L417.198 404.312L414.573 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 403.187H419.148L416.523 398.687L419.148 394.112H424.398L427.023 398.687L424.398 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.002 397.262H429.127L426.727 392.987L429.127 388.787H434.002L436.477 392.987L434.002 397.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.776 389.913H439.926L438.426 387.363L439.926 384.812H442.776L444.276 387.363L442.776 389.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.426 374.312H448.926L446.676 370.412L448.926 366.512H453.426L455.676 370.412L453.426 374.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 363.662H448.551L445.926 359.087L448.551 354.587H453.726L456.351 359.087L453.726 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.302 349.788H449.977L448.852 347.838L449.977 345.812H452.302L453.427 347.838L452.302 349.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.725 341.012H448.55L446 336.512L448.55 332.012H453.725L456.35 336.512L453.725 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 329.688H448.551L445.926 325.188L448.551 320.688H453.726L456.351 325.188L453.726 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 318.437H448.551L445.926 313.862L448.551 309.362H453.726L456.351 313.862L453.726 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 307.112H448.551L445.926 302.612L448.551 298.037H453.726L456.351 302.612L453.726 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 295.787H448.551L445.926 291.287L448.551 286.787H453.726L456.351 291.287L453.726 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 284.537H448.551L445.926 279.962L448.551 275.462H453.726L456.351 279.962L453.726 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 273.212H448.551L445.926 268.712L448.551 264.137H453.726L456.351 268.712L453.726 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 261.887H448.551L445.926 257.387L448.551 252.887H453.726L456.351 257.387L453.726 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 250.562H448.551L445.926 246.062L448.551 241.562H453.726L456.351 246.062L453.726 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 239.312H448.551L445.926 234.737L448.551 230.237H453.726L456.351 234.737L453.726 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 233.612H438.727L436.102 229.112L438.727 224.612H443.977L446.602 229.112L443.977 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 227.987H428.977L426.352 223.487L428.977 218.912H434.152L436.777 223.487L434.152 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 222.362H419.148L416.523 217.787L419.148 213.287H424.398L427.023 217.787L424.398 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 216.662H409.398L406.773 212.162L409.398 207.662H414.573L417.198 212.162L414.573 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 211.037H399.574L396.949 206.537L399.574 201.962H404.824L407.449 206.537L404.824 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 205.412H389.824L387.199 200.837L389.824 196.337H394.999L397.624 200.837L394.999 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 199.713H380L377.375 195.213L380 190.713H385.25L387.875 195.213L385.25 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 194.087H370.25L367.625 189.587L370.25 185.012H375.425L378.05 189.587L375.425 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 188.462H360.426L357.801 183.887L360.426 179.387H365.676L368.301 183.887L365.676 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 182.762H350.676L348.051 178.262L350.676 173.762H355.851L358.476 178.262L355.851 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.199 175.637H341.749L339.949 172.637L341.749 169.562H345.199L346.999 172.637L345.199 175.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.999 169.262H332.299L330.949 166.937L332.299 164.612H334.999L336.349 166.937L334.999 169.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.552 164.087H322.252L320.602 161.312L322.252 158.462H325.552L327.127 161.312L325.552 164.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.124 182.762H291.949L289.324 178.262L291.949 173.762H297.124L299.749 178.262L297.124 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.375 188.462H282.125L279.5 183.887L282.125 179.387H287.375L289.925 183.887L287.375 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.05 464.912H331.325L329 460.863L331.325 456.812H336.05L338.375 460.863L336.05 464.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 459.738H340.852L338.227 455.162L340.852 450.662H346.102L348.727 455.162L346.102 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 454.037H350.676L348.051 449.537L350.676 445.037H355.851L358.476 449.537L355.851 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 448.413H360.426L357.801 443.913L360.426 439.338H365.676L368.301 443.913L365.676 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 442.713H370.25L367.625 438.213L370.25 433.713H375.425L378.05 438.213L375.425 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 437.088H380L377.375 432.588L380 428.088H385.25L387.875 432.588L385.25 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 431.462H389.824L387.199 426.888L389.824 422.388H394.999L397.624 426.888L394.999 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 425.763H399.574L396.949 421.263L399.574 416.763H404.824L407.449 421.263L404.824 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 420.137H409.398L406.773 415.637L409.398 411.062H414.573L417.198 415.637L414.573 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.326 414.437H419.226L416.676 409.937L419.226 405.513H424.326L426.951 409.937L424.326 414.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.199 355.637H459.649L458.449 353.462L459.649 351.287H462.199L463.474 353.462L462.199 355.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 335.388H458.3L455.75 330.812L458.3 326.312H463.55L466.175 330.812L463.55 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 324.062H458.3L455.75 319.562L458.3 314.987H463.55L466.175 319.562L463.55 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 312.737H458.3L455.75 308.237L458.3 303.737H463.55L466.175 308.237L463.55 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 301.412H458.3L455.75 296.912L458.3 292.412H463.55L466.1 296.912L463.55 301.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.675 286.862H460.25L459.5 285.662L460.25 284.387H461.675L462.35 285.662L461.675 286.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 278.838H458.3L455.75 274.338L458.3 269.838H463.55L466.175 274.338L463.55 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 267.512H458.3L455.75 263.012L458.3 258.512H463.55L466.175 263.012L463.55 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 256.263H458.3L455.75 251.763L458.3 247.188H463.55L466.175 251.763L463.55 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 244.938H458.3L455.75 240.438L458.3 235.938H463.55L466.175 240.438L463.55 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 233.612H458.3L455.75 229.112L458.3 224.612H463.55L466.175 229.112L463.55 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 227.987H448.551L445.926 223.487L448.551 218.912H453.726L456.351 223.487L453.726 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 222.362H438.727L436.102 217.787L438.727 213.287H443.977L446.602 217.787L443.977 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 216.662H428.977L426.352 212.162L428.977 207.662H434.152L436.777 212.162L434.152 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 211.037H419.148L416.523 206.537L419.148 201.962H424.398L427.023 206.537L424.398 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 205.412H409.398L406.773 200.837L409.398 196.337H414.573L417.198 200.837L414.573 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 199.712H399.574L396.949 195.212L399.574 190.712H404.824L407.449 195.212L404.824 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 194.087H389.824L387.199 189.587L389.824 185.012H394.999L397.624 189.587L394.999 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 188.462H380L377.375 183.887L380 179.387H385.25L387.875 183.887L385.25 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 182.762H370.25L367.625 178.262L370.25 173.762H375.425L378.05 178.262L375.425 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 177.137H360.426L357.801 172.637L360.426 168.062H365.676L368.301 172.637L365.676 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.101 165.812H340.851L338.301 161.312L340.851 156.812H346.101L348.651 161.312L346.101 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.276 160.112H331.101L328.551 155.612L331.101 151.188H336.276L338.826 155.612L336.276 160.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 154.487H321.273L318.648 149.987L321.273 145.487H326.523L329.073 149.987L326.523 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.048 157.262H313.173L312.273 155.612L313.173 154.037H315.048L315.948 155.612L315.048 157.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.077 169.712H292.927L291.352 166.937L292.927 164.237H296.077L297.652 166.937L296.077 169.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.174 175.112H283.324L281.824 172.637L283.324 170.087H286.174L287.599 172.637L286.174 175.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.174 182.087H272.749L270.574 178.262L272.749 174.438H277.174L279.349 178.262L277.174 182.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.224 185.762H264.124L263.074 183.887L264.124 182.087H266.224L267.274 183.887L266.224 185.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 470.987H340.852L338.227 466.487L340.852 461.987H346.102L348.727 466.487L346.102 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 465.363H350.676L348.051 460.863L350.676 456.287H355.851L358.476 460.863L355.851 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 459.738H360.426L357.801 455.162L360.426 450.662H365.676L368.301 455.162L365.676 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 454.037H370.25L367.625 449.537L370.25 445.037H375.425L378.05 449.537L375.425 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 448.413H380L377.375 443.913L380 439.338H385.25L387.875 443.913L385.25 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 442.713H389.824L387.199 438.213L389.824 433.713H394.999L397.624 438.213L394.999 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 437.088H399.574L396.949 432.588L399.574 428.088H404.824L407.449 432.588L404.824 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 431.462H409.398L406.773 426.888L409.398 422.388H414.573L417.198 426.888L414.573 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.327 425.763H419.227L416.602 421.263L419.227 416.838H424.327L426.952 421.263L424.327 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.223 329.612H468.198L465.648 325.187L468.198 320.762H473.223L475.773 325.187L473.223 329.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 318.437H468.125L465.5 313.862L468.125 309.362H473.3L475.925 313.862L473.3 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.223 306.963H468.198L465.648 302.613L468.198 298.188H473.223L475.773 302.613L473.223 306.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.852 294.962H468.577L466.477 291.287L468.577 287.612H472.852L474.952 291.287L472.852 294.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 284.538H468.125L465.5 279.963L468.125 275.463H473.3L475.925 279.963L473.3 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 273.212H468.125L465.5 268.712L468.125 264.137H473.3L475.925 268.712L473.3 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 261.887H468.125L465.5 257.387L468.125 252.887H473.3L475.925 257.387L473.3 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 250.562H468.125L465.5 246.062L468.125 241.562H473.3L475.925 246.062L473.3 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 239.312H468.125L465.5 234.737L468.125 230.237H473.3L475.925 234.737L473.3 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 227.987H468.125L465.5 223.487L468.125 218.912H473.3L475.925 223.487L473.3 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 222.362H458.3L455.75 217.787L458.3 213.287H463.55L466.175 217.787L463.55 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 216.662H448.551L445.926 212.162L448.551 207.662H453.726L456.351 212.162L453.726 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 211.037H438.727L436.102 206.537L438.727 201.962H443.977L446.602 206.537L443.977 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 205.412H428.977L426.352 200.837L428.977 196.337H434.152L436.777 200.837L434.152 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 199.712H419.148L416.523 195.212L419.148 190.712H424.398L427.023 195.212L424.398 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 194.087H409.398L406.773 189.587L409.398 185.012H414.573L417.198 189.587L414.573 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 188.462H399.574L396.949 183.887L399.574 179.387H404.824L407.449 183.887L404.824 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 182.762H389.824L387.199 178.262L389.824 173.762H394.999L397.624 178.262L394.999 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 177.137H380L377.375 172.637L380 168.062H385.25L387.875 172.637L385.25 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 171.438H370.25L367.625 166.938L370.25 162.438H375.425L378.05 166.938L375.425 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.527 165.587H360.577L358.102 161.312L360.577 157.037H365.527L368.002 161.312L365.527 165.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.75 156.512H352.775L352.25 155.612L352.775 154.787H353.75L354.275 155.612L353.75 156.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 154.487H340.852L338.227 149.987L340.852 145.487H346.102L348.727 149.987L346.102 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 148.862H331.102L328.477 144.362L331.102 139.787H336.277L338.902 144.362L336.277 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 143.237H321.273L318.648 138.662L321.273 134.162H326.523L329.073 138.662L326.523 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.323 148.187H311.898L309.648 144.362L311.898 140.537H316.323L318.498 144.362L316.323 148.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.299 165.737H282.124L279.574 161.312L282.124 156.812H287.299L289.924 161.312L287.299 165.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.026 405.962H176.076L175.176 404.312L176.076 402.662H178.026L179.001 404.312L178.026 405.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.025 482.238H340.925L338.375 477.812L340.925 473.388H346.025L348.575 477.812L346.025 482.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 476.687H350.676L348.051 472.112L350.676 467.612H355.851L358.476 472.112L355.851 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 470.987H360.426L357.801 466.487L360.426 461.987H365.676L368.301 466.487L365.676 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 465.363H370.25L367.625 460.863L370.25 456.287H375.425L378.05 460.863L375.425 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 459.738H380L377.375 455.162L380 450.662H385.25L387.875 455.162L385.25 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 454.037H389.824L387.199 449.537L389.824 445.037H394.999L397.624 449.537L394.999 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 448.413H399.574L396.949 443.913L399.574 439.338H404.824L407.449 443.913L404.824 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 442.713H409.398L406.773 438.213L409.398 433.713H414.573L417.198 438.213L414.573 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 437.088H419.148L416.523 432.588L419.148 428.088H424.398L427.023 432.588L424.398 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.898 323.613H478.173L475.773 319.562L478.173 315.438H482.898L485.223 319.562L482.898 323.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.827 312.288H478.177L475.852 308.238L478.177 304.188H482.827L485.152 308.238L482.827 312.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.601 300.588H478.401L476.301 296.913L478.401 293.312H482.601L484.701 296.913L482.601 300.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 290.162H477.874L475.324 285.662L477.874 281.087H483.124L485.749 285.662L483.124 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 278.837H477.874L475.324 274.337L477.874 269.837H483.124L485.749 274.337L483.124 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 267.512H477.874L475.324 263.012L477.874 258.512H483.124L485.749 263.012L483.124 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 256.263H477.874L475.324 251.763L477.874 247.188H483.124L485.749 251.763L483.124 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 244.938H477.874L475.324 240.438L477.874 235.938H483.124L485.749 240.438L483.124 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 233.612H477.874L475.324 229.112L477.874 224.612H483.124L485.749 229.112L483.124 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 222.362H477.874L475.324 217.787L477.874 213.287H483.124L485.749 217.787L483.124 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 216.662H468.125L465.5 212.162L468.125 207.662H473.3L475.925 212.162L473.3 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 211.038H458.3L455.75 206.538L458.3 201.963H463.55L466.175 206.538L463.55 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 205.412H448.551L445.926 200.837L448.551 196.337H453.726L456.351 200.837L453.726 205.412Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 199.712H438.727L436.102 195.212L438.727 190.712H443.977L446.602 195.212L443.977 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 194.087H428.977L426.352 189.587L428.977 185.012H434.152L436.777 189.587L434.152 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 188.462H419.148L416.523 183.887L419.148 179.387H424.398L427.023 183.887L424.398 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 182.762H409.398L406.773 178.262L409.398 173.762H414.573L417.198 178.262L414.573 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 177.137H399.574L396.949 172.637L399.574 168.062H404.824L407.449 172.637L404.824 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 171.438H389.824L387.199 166.938L389.824 162.438H394.999L397.624 166.938L394.999 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 165.812H380L377.375 161.312L380 156.812H385.25L387.875 161.312L385.25 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 160.188H370.25L367.625 155.613L370.25 151.113H375.425L378.05 155.613L375.425 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 143.237H340.852L338.227 138.662L340.852 134.162H346.102L348.727 138.662L346.102 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 137.537H331.102L328.477 133.037L331.102 128.537H336.277L338.902 133.037L336.277 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.774 130.712H321.949L320.074 127.412L321.949 124.112H325.774L327.724 127.412L325.774 130.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.602 133.937H313.627L313.102 133.037L313.627 132.137H314.602L315.127 133.037L314.602 133.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.274 150.887H284.224L283.699 149.987L284.224 149.087H285.274L285.724 149.987L285.274 150.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 408.812H154.852L152.227 404.312L154.852 399.812H160.102L162.727 404.312L160.102 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 414.512H164.676L162.051 409.937L164.676 405.437H169.851L172.476 409.937L169.851 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 420.138H174.425L171.875 415.638L174.425 411.062H179.675L182.3 415.638L179.675 420.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.502 492.662H341.377L339.352 489.062L341.377 485.537H345.502L347.602 489.062L345.502 492.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 487.937H350.676L348.051 483.437L350.676 478.937H355.851L358.476 483.437L355.851 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 482.312H360.426L357.801 477.812L360.426 473.237H365.676L368.301 477.812L365.676 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 476.687H370.25L367.625 472.112L370.25 467.612H375.425L378.05 472.112L375.425 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 470.987H380L377.375 466.487L380 461.987H385.25L387.875 466.487L385.25 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 465.363H389.824L387.199 460.863L389.824 456.287H394.999L397.624 460.863L394.999 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 459.738H399.574L396.949 455.162L399.574 450.662H404.824L407.449 455.162L404.824 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 454.037H409.398L406.773 449.537L409.398 445.037H414.573L417.198 449.537L414.573 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.402 448.337H419.227L416.602 443.912L419.227 439.412H424.402L426.952 443.912L424.402 448.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.075 303.887H489.575L488.75 302.612L489.575 301.262H491.075L491.825 302.612L491.075 303.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 295.787H487.699L485.074 291.287L487.699 286.787H492.874L495.499 291.287L492.874 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 284.537H487.699L485.074 279.962L487.699 275.462H492.874L495.499 279.962L492.874 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 273.212H487.699L485.074 268.712L487.699 264.137H492.874L495.499 268.712L492.874 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 261.887H487.699L485.074 257.387L487.699 252.887H492.874L495.499 257.387L492.874 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 250.562H487.699L485.074 246.062L487.699 241.562H492.874L495.499 246.062L492.874 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 239.312H487.699L485.074 234.737L487.699 230.237H492.874L495.499 234.737L492.874 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 227.987H487.699L485.074 223.487L487.699 218.912H492.874L495.499 223.487L492.874 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 216.662H487.699L485.074 212.162L487.699 207.662H492.874L495.499 212.162L492.874 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 211.037H477.874L475.324 206.537L477.874 201.962H483.124L485.749 206.537L483.124 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 205.413H468.125L465.5 200.838L468.125 196.338H473.3L475.925 200.838L473.3 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 199.713H458.3L455.75 195.213L458.3 190.713H463.55L466.175 195.213L463.55 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 194.087H448.551L445.926 189.587L448.551 185.012H453.726L456.351 189.587L453.726 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 188.462H438.727L436.102 183.887L438.727 179.387H443.977L446.602 183.887L443.977 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 182.762H428.977L426.352 178.262L428.977 173.762H434.152L436.777 178.262L434.152 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 177.137H419.148L416.523 172.637L419.148 168.062H424.398L427.023 172.637L424.398 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 171.438H409.398L406.773 166.938L409.398 162.438H414.573L417.198 166.938L414.573 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 165.812H399.574L396.949 161.312L399.574 156.812H404.824L407.449 161.312L404.824 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 160.187H389.824L387.199 155.612L389.824 151.112H394.999L397.624 155.612L394.999 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.174 154.413H380.074L377.449 149.987L380.074 145.562H385.174L387.724 149.987L385.174 154.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.424 148.787H370.249L367.699 144.362L370.249 139.862H375.424L377.974 144.362L375.424 148.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 143.237H360.426L357.801 138.662L360.426 134.162H365.676L368.301 138.662L365.676 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.726 135.587H351.801L350.301 133.037L351.801 130.487H354.726L356.226 133.037L354.726 135.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 131.913H340.852L338.227 127.413L340.852 122.838H346.102L348.727 127.413L346.102 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.124 126.062H331.174L328.699 121.712L331.174 117.438H336.124L338.599 121.712L336.124 126.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 414.512H145.102L142.477 409.937L145.102 405.437H150.277L152.902 409.937L150.277 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 420.137H154.852L152.227 415.637L154.852 411.062H160.102L162.727 415.637L160.102 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 425.763H164.676L162.051 421.263L164.676 416.763H169.851L172.476 421.263L169.851 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.451 431.162H174.651L172.176 426.887L174.651 422.687H179.451L181.926 426.887L179.451 431.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.377 502.037H342.502L341.602 500.387L342.502 498.812H344.377L345.352 500.387L344.377 502.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 499.262H350.676L348.051 494.762L350.676 490.187H355.851L358.476 494.762L355.851 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 493.637H360.426L357.801 489.062L360.426 484.562H365.676L368.301 489.062L365.676 493.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 487.938H370.25L367.625 483.438L370.25 478.938H375.425L378.05 483.438L375.425 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 482.312H380L377.375 477.812L380 473.237H385.25L387.875 477.812L385.25 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 476.687H389.824L387.199 472.112L389.824 467.612H394.999L397.624 472.112L394.999 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 470.987H399.574L396.949 466.487L399.574 461.987H404.824L407.449 466.487L404.824 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.124 464.462H409.924L407.824 460.862L409.924 457.187H414.124L416.149 460.862L414.124 464.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.523 456.437H421.023L420.273 455.162L421.023 453.888H422.523L423.273 455.162L422.523 456.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.351 442.037H448.926L446.676 438.212L448.926 434.388H453.351L455.601 438.212L453.351 442.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 301.412H497.523L494.898 296.912L497.523 292.412H502.698L505.323 296.912L502.698 301.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 290.162H497.448L494.898 285.662L497.448 281.087H502.698L505.323 285.662L502.698 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 278.837H497.448L494.898 274.337L497.448 269.837H502.698L505.323 274.337L502.698 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 267.512H497.448L494.898 263.012L497.448 258.512H502.698L505.323 263.012L502.698 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 256.263H497.448L494.898 251.763L497.448 247.188H502.698L505.323 251.763L502.698 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 244.938H497.448L494.898 240.438L497.448 235.938H502.698L505.323 240.438L502.698 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 233.612H497.448L494.898 229.112L497.448 224.612H502.698L505.323 229.112L502.698 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 222.362H497.448L494.898 217.787L497.448 213.287H502.698L505.323 217.787L502.698 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 211.037H497.448L494.898 206.537L497.448 201.962H502.698L505.323 206.537L502.698 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 205.412H487.699L485.074 200.837L487.699 196.337H492.874L495.499 200.837L492.874 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 199.712H477.874L475.324 195.212L477.874 190.712H483.124L485.749 195.212L483.124 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 194.087H468.125L465.5 189.587L468.125 185.012H473.3L475.925 189.587L473.3 194.087Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 188.462H458.3L455.75 183.887L458.3 179.387H463.55L466.175 183.887L463.55 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 182.762H448.551L445.926 178.262L448.551 173.762H453.726L456.351 178.262L453.726 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 177.137H438.727L436.102 172.637L438.727 168.062H443.977L446.602 172.637L443.977 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 171.438H428.977L426.352 166.938L428.977 162.438H434.152L436.777 166.938L434.152 171.438Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 165.812H419.148L416.523 161.312L419.148 156.812H424.398L427.023 161.312L424.398 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 160.187H409.398L406.773 155.612L409.398 151.112H414.573L417.198 155.612L414.573 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 154.487H399.574L396.949 149.987L399.574 145.487H404.824L407.449 149.987L404.824 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 148.862H389.824L387.199 144.362L389.824 139.787H394.999L397.624 144.362L394.999 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 143.237H380L377.375 138.662L380 134.162H385.25L387.875 138.662L385.25 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 137.537H370.25L367.625 133.037L370.25 128.537H375.425L378.05 133.037L375.425 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.326 129.663H361.701L360.426 127.413L361.701 125.088H364.326L365.676 127.413L364.326 129.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 126.288H350.676L348.051 121.713L350.676 117.213H355.851L358.476 121.713L355.851 126.288Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 120.588H340.852L338.227 116.088L340.852 111.588H346.102L348.727 116.088L346.102 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.824 402.363H145.549L143.449 398.687L145.549 395.013H149.824L151.924 398.687L149.824 402.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 420.137H135.273L132.648 415.637L135.273 411.062H140.523L143.148 415.637L140.523 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 425.763H145.102L142.477 421.263L145.102 416.763H150.277L152.902 421.263L150.277 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 431.462H154.852L152.227 426.888L154.852 422.388H160.102L162.727 426.888L160.102 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 437.088H164.676L162.051 432.588L164.676 428.088H169.851L172.476 432.588L169.851 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 510.587H350.676L348.051 506.013L350.676 501.513H355.851L358.476 506.013L355.851 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 504.888H360.426L357.801 500.388L360.426 495.888H365.676L368.301 500.388L365.676 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 499.263H370.25L367.625 494.763L370.25 490.188H375.425L378.05 494.763L375.425 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 493.638H380L377.375 489.062L380 484.562H385.25L387.875 489.062L385.25 493.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 487.937H389.824L387.199 483.437L389.824 478.937H394.999L397.624 483.437L394.999 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 482.312H399.574L396.949 477.812L399.574 473.237H404.824L407.449 477.812L404.824 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.399 472.862H411.574L411.199 472.112L411.574 471.437H412.399L412.774 472.112L412.399 472.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 459.738H438.727L436.102 455.162L438.727 450.662H443.977L446.602 455.162L443.977 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 454.037H448.551L445.926 449.537L448.551 445.037H453.726L456.351 449.537L453.726 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.549 305.537H508.174L506.449 302.612L508.174 299.612H511.549L513.274 302.612L511.549 305.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 295.787H507.273L504.648 291.287L507.273 286.787H512.523L515.073 291.287L512.523 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 284.537H507.273L504.648 279.962L507.273 275.462H512.523L515.073 279.962L512.523 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 273.212H507.273L504.648 268.712L507.273 264.137H512.523L515.073 268.712L512.523 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 261.887H507.273L504.648 257.387L507.273 252.887H512.523L515.073 257.387L512.523 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 250.562H507.273L504.648 246.062L507.273 241.562H512.523L515.073 246.062L512.523 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 239.312H507.273L504.648 234.737L507.273 230.237H512.523L515.073 234.737L512.523 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 227.987H507.273L504.648 223.487L507.273 218.912H512.523L515.073 223.487L512.523 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 216.662H507.273L504.648 212.162L507.273 207.662H512.523L515.073 212.162L512.523 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 205.412H507.273L504.648 200.837L507.273 196.337H512.523L515.073 200.837L512.523 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 199.712H497.448L494.898 195.212L497.448 190.712H502.698L505.323 195.212L502.698 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 194.087H487.699L485.074 189.587L487.699 185.012H492.874L495.499 189.587L492.874 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 188.462H477.874L475.324 183.887L477.874 179.387H483.124L485.749 183.887L483.124 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 182.762H468.125L465.5 178.262L468.125 173.762H473.3L475.925 178.262L473.3 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 177.137H458.3L455.75 172.637L458.3 168.062H463.55L466.175 172.637L463.55 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 171.438H448.551L445.926 166.938L448.551 162.438H453.726L456.351 166.938L453.726 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 165.812H438.727L436.102 161.312L438.727 156.812H443.977L446.602 161.312L443.977 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 160.187H428.977L426.352 155.612L428.977 151.112H434.152L436.777 155.612L434.152 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 154.487H419.148L416.523 149.987L419.148 145.487H424.398L427.023 149.987L424.398 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 148.862H409.398L406.773 144.362L409.398 139.787H414.573L417.198 144.362L414.573 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.824 143.237H399.574L396.949 138.662L399.574 134.162H404.824L407.449 138.662L404.824 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 137.537H389.824L387.199 133.037L389.824 128.537H394.999L397.624 133.037L394.999 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 131.913H380L377.375 127.413L380 122.838H385.25L387.875 127.413L385.25 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 126.288H370.25L367.625 121.713L370.25 117.213H375.425L378.05 121.713L375.425 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.6 120.588H360.5L357.875 116.088L360.5 111.588H365.6L368.225 116.088L365.6 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851 114.962H350.676L348.051 110.462L350.676 105.887H355.851L358.476 110.462L355.851 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 108.212H341.45L339.5 104.762L341.45 101.312H345.5L347.45 104.762L345.5 108.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.475 395.762H136.325L134.75 392.987L136.325 390.287H139.475L141.05 392.987L139.475 395.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 408.812H135.273L132.648 404.312L135.273 399.812H140.523L143.148 404.312L140.523 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 425.763H125.523L122.898 421.263L125.523 416.763H130.698L133.323 421.263L130.698 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 431.462H135.273L132.648 426.888L135.273 422.388H140.523L143.148 426.888L140.523 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 437.088H145.102L142.477 432.588L145.102 428.088H150.277L152.902 432.588L150.277 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 442.713H154.852L152.227 438.213L154.852 433.713H160.102L162.727 438.213L160.102 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.399 447.587H165.124L162.949 443.912L165.124 440.162H169.399L171.574 443.912L169.399 447.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.552 521.237H350.977L348.727 517.337L350.977 513.437H355.552L357.802 517.337L355.552 521.237Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 516.213H360.426L357.801 511.713L360.426 507.213H365.676L368.301 511.713L365.676 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 510.587H370.25L367.625 506.013L370.25 501.513H375.425L378.05 506.013L375.425 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 504.888H380L377.375 500.388L380 495.888H385.25L387.875 500.388L385.25 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 499.262H389.824L387.199 494.762L389.824 490.187H394.999L397.624 494.762L394.999 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.652 489.887H401.752L401.227 489.062L401.752 488.237H402.652L403.177 489.062L402.652 489.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.574 473.838H430.549L429.574 472.113L430.549 470.463H432.574L433.549 472.113L432.574 473.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 470.987H438.727L436.102 466.487L438.727 461.987H443.977L446.602 466.487L443.977 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.576 465.063H448.701L446.301 460.863L448.701 456.588H453.576L456.051 460.863L453.576 465.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.124 312.512H517.174L514.699 308.237L517.174 303.962H522.124L524.599 308.237L522.124 312.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 301.487H517.027L514.477 296.912L517.027 292.412H522.277L524.902 296.912L522.277 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 290.162H517.027L514.477 285.662L517.027 281.087H522.277L524.902 285.662L522.277 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 278.837H517.027L514.477 274.337L517.027 269.837H522.277L524.902 274.337L522.277 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 267.512H517.027L514.477 263.012L517.027 258.512H522.277L524.902 263.012L522.277 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 256.263H517.027L514.477 251.763L517.027 247.188H522.277L524.902 251.763L522.277 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 244.938H517.027L514.477 240.438L517.027 235.938H522.277L524.902 240.438L522.277 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 233.612H517.027L514.477 229.112L517.027 224.612H522.277L524.902 229.112L522.277 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 222.362H517.027L514.477 217.787L517.027 213.287H522.277L524.902 217.787L522.277 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 211.037H517.027L514.477 206.537L517.027 201.962H522.277L524.902 206.537L522.277 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 199.712H517.027L514.477 195.212L517.027 190.712H522.277L524.902 195.212L522.277 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 194.087H507.273L504.648 189.587L507.273 185.012H512.523L515.073 189.587L512.523 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 188.462H497.448L494.898 183.887L497.448 179.387H502.698L505.323 183.887L502.698 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 182.762H487.699L485.074 178.262L487.699 173.762H492.874L495.499 178.262L492.874 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 177.137H477.874L475.324 172.637L477.874 168.062H483.124L485.749 172.637L483.124 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 171.438H468.125L465.5 166.938L468.125 162.438H473.3L475.925 166.938L473.3 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 165.812H458.3L455.75 161.312L458.3 156.812H463.55L466.175 161.312L463.55 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 160.187H448.551L445.926 155.612L448.551 151.112H453.726L456.351 155.612L453.726 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 154.487H438.727L436.102 149.987L438.727 145.487H443.977L446.602 149.987L443.977 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 148.862H428.977L426.352 144.362L428.977 139.787H434.152L436.777 144.362L434.152 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 143.237H419.148L416.523 138.662L419.148 134.162H424.398L427.023 138.662L424.398 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.573 137.537H409.398L406.773 133.037L409.398 128.537H414.573L417.198 133.037L414.573 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.224 130.938H400.174L398.074 127.413L400.174 123.812H404.224L406.324 127.413L404.224 130.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 126.288H389.824L387.199 121.713L389.824 117.213H394.999L397.624 121.713L394.999 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 120.588H380L377.375 116.088L380 111.588H385.25L387.875 116.088L385.25 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 114.962H370.25L367.625 110.462L370.25 105.887H375.425L378.05 110.462L375.425 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.676 109.337H360.426L357.801 104.762L360.426 100.262H365.676L368.301 104.762L365.676 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.548 103.112H350.973L348.648 99.1375L350.973 95.1625H355.548L357.873 99.1375L355.548 103.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6 125.538H253.175L251 121.713L253.175 117.963H257.6L259.775 121.713L257.6 125.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.925 131.462H243.2L240.875 127.412L243.2 123.287H247.925L250.325 127.412L247.925 131.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.626 210.887H125.601L123.051 206.537L125.601 202.112H130.626L133.176 206.537L130.626 210.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.799 378.962H126.424L124.699 376.037L126.424 373.112H129.799L131.524 376.037L129.799 378.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.626 391.712H125.601L123.051 387.362L125.601 383.012H130.626L133.176 387.362L130.626 391.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 403.187H125.523L122.898 398.687L125.523 394.112H130.698L133.323 398.687L130.698 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 414.512H125.523L122.898 409.937L125.523 405.437H130.698L133.323 409.937L130.698 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 431.462H115.699L113.074 426.888L115.699 422.388H120.949L123.574 426.888L120.949 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 437.088H125.523L122.898 432.588L125.523 428.088H130.698L133.323 432.588L130.698 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 442.713H135.273L132.648 438.213L135.273 433.713H140.523L143.148 438.213L140.523 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 448.413H145.102L142.477 443.913L145.102 439.338H150.277L152.902 443.913L150.277 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 454.037H154.852L152.227 449.537L154.852 445.037H160.102L162.727 449.537L160.102 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.902 456.212H166.702L166.102 455.162L166.702 454.187H167.902L168.427 455.162L167.902 456.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.474 525.437H361.624L360.199 522.962L361.624 520.562H364.474L365.899 522.962L364.474 525.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.9 520.863H370.775L368.75 517.338L370.775 513.812H374.9L376.925 517.338L374.9 520.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.173 516.062H380.073L377.523 511.712L380.073 507.287H385.173L387.723 511.712L385.173 516.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.902 506.837H391.927L391.477 506.013L391.927 505.263H392.902L393.352 506.013L392.902 506.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.498 485.087H430.623L429.648 483.437L430.623 481.787H432.498L433.473 483.437L432.498 485.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 482.312H438.727L436.102 477.812L438.727 473.237H443.977L446.602 477.812L443.977 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.75 474.963H449.525L447.875 472.113L449.525 469.338H452.75L454.4 472.113L452.75 474.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.224 337.862H528.649L527.824 336.512L528.649 335.087H530.224L531.049 336.512L530.224 337.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.948 329.462H526.998L524.523 325.187L526.998 320.912H531.948L534.423 325.187L531.948 329.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 318.437H526.852L524.227 313.862L526.852 309.362H532.102L534.652 313.862L532.102 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 307.112H526.852L524.227 302.612L526.852 298.037H532.102L534.652 302.612L532.102 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 295.787H526.852L524.227 291.287L526.852 286.787H532.102L534.652 291.287L532.102 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 284.537H526.852L524.227 279.962L526.852 275.462H532.102L534.652 279.962L532.102 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 273.212H526.852L524.227 268.712L526.852 264.137H532.102L534.652 268.712L532.102 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 261.887H526.852L524.227 257.387L526.852 252.887H532.102L534.652 257.387L532.102 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 250.562H526.852L524.227 246.062L526.852 241.562H532.102L534.652 246.062L532.102 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 239.312H526.852L524.227 234.737L526.852 230.237H532.102L534.652 234.737L532.102 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 227.987H526.852L524.227 223.487L526.852 218.912H532.102L534.652 223.487L532.102 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 216.662H526.852L524.227 212.162L526.852 207.662H532.102L534.652 212.162L532.102 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 205.412H526.852L524.227 200.837L526.852 196.337H532.102L534.652 200.837L532.102 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 194.087H526.852L524.227 189.587L526.852 185.012H532.102L534.652 189.587L532.102 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 188.462H517.027L514.477 183.887L517.027 179.387H522.277L524.902 183.887L522.277 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 182.762H507.273L504.648 178.262L507.273 173.762H512.523L515.073 178.262L512.523 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 177.137H497.448L494.898 172.637L497.448 168.062H502.698L505.323 172.637L502.698 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 171.438H487.699L485.074 166.938L487.699 162.438H492.874L495.499 166.938L492.874 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 165.812H477.874L475.324 161.312L477.874 156.812H483.124L485.749 161.312L483.124 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 160.188H468.125L465.5 155.613L468.125 151.113H473.3L475.925 155.613L473.3 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 154.488H458.3L455.75 149.988L458.3 145.488H463.55L466.175 149.988L463.55 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 148.862H448.551L445.926 144.362L448.551 139.787H453.726L456.351 144.362L453.726 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 143.237H438.727L436.102 138.662L438.727 134.162H443.977L446.602 138.662L443.977 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 137.537H428.977L426.352 133.037L428.977 128.537H434.152L436.777 133.037L434.152 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.398 131.913H419.148L416.523 127.413L419.148 122.838H424.398L427.023 127.413L424.398 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.423 125.987H409.548L407.148 121.712L409.548 117.512H414.423L416.898 121.712L414.423 125.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.999 114.963H389.824L387.199 110.463L389.824 105.963H394.999L397.624 110.463L394.999 114.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.25 109.337H380L377.375 104.762L380 100.262H385.25L387.875 104.762L385.25 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.425 103.637H370.25L367.625 99.1375L370.25 94.6375H375.425L378.05 99.1375L375.425 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.301 97.4125H360.801L358.551 93.5125L360.801 89.5375H365.301L367.551 93.5125L365.301 97.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.852 119.987H243.352L241.102 116.087L243.352 112.188H247.852L250.102 116.087L247.852 119.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.326 126.212H233.226L230.676 121.712L233.226 117.287H238.326L240.951 121.712L238.326 126.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.651 193.562H116.001L113.676 189.587L116.001 185.537H120.651L122.976 189.587L120.651 193.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.199 204.137H116.449L114.574 200.837L116.449 197.612H120.199L122.074 200.837L120.199 204.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.751 372.812H116.901L115.551 370.412L116.901 368.012H119.751L121.101 370.412L119.751 372.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 386.237H115.699L113.074 381.737L115.699 377.162H120.949L123.574 381.737L120.949 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 397.562H115.699L113.074 392.987L115.699 388.487H120.949L123.574 392.987L120.949 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 408.812H115.699L113.074 404.312L115.699 399.812H120.949L123.574 404.312L120.949 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 420.137H115.699L113.074 415.637L115.699 411.062H120.949L123.574 415.637L120.949 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 437.088H105.949L103.324 432.588L105.949 428.088H111.124L113.749 432.588L111.124 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 442.713H115.699L113.074 438.213L115.699 433.713H120.949L123.574 438.213L120.949 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 448.413H125.523L122.898 443.913L125.523 439.338H130.698L133.323 443.913L130.698 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 454.037H135.273L132.648 449.537L135.273 445.037H140.523L143.148 449.537L140.523 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 459.738H145.102L142.477 455.162L145.102 450.662H150.277L152.902 455.162L150.277 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 465.363H154.852L152.227 460.863L154.852 456.287H160.102L162.727 460.863L160.102 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.548 491.087H440.223L439.023 489.062L440.223 487.112H442.548L443.673 489.062L442.548 491.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.351 355.337H538.176L537.051 353.462L538.176 351.587H540.351L541.401 353.462L540.351 355.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 346.637H536.676L534.051 342.137L536.676 337.637H541.851L544.476 342.137L541.851 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 335.388H536.601L534.051 330.812L536.601 326.312H541.851L544.476 330.812L541.851 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 324.062H536.601L534.051 319.562L536.601 314.987H541.851L544.476 319.562L541.851 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 312.737H536.601L534.051 308.237L536.601 303.737H541.851L544.476 308.237L541.851 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 301.487H536.601L534.051 296.912L536.601 292.412H541.851L544.476 296.912L541.851 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 290.162H536.601L534.051 285.662L536.601 281.087H541.851L544.476 285.662L541.851 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 278.837H536.601L534.051 274.337L536.601 269.837H541.851L544.476 274.337L541.851 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 267.512H536.601L534.051 263.012L536.601 258.512H541.851L544.476 263.012L541.851 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 256.263H536.601L534.051 251.763L536.601 247.188H541.851L544.476 251.763L541.851 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 244.938H536.601L534.051 240.438L536.601 235.938H541.851L544.476 240.438L541.851 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 233.612H536.601L534.051 229.112L536.601 224.612H541.851L544.476 229.112L541.851 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 222.362H536.601L534.051 217.787L536.601 213.287H541.851L544.476 217.787L541.851 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 211.037H536.601L534.051 206.537L536.601 201.962H541.851L544.476 206.537L541.851 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 199.712H536.601L534.051 195.212L536.601 190.712H541.851L544.476 195.212L541.851 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 188.462H536.601L534.051 183.887L536.601 179.387H541.851L544.476 183.887L541.851 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 182.762H526.852L524.227 178.262L526.852 173.762H532.102L534.652 178.262L532.102 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 177.137H517.027L514.477 172.637L517.027 168.062H522.277L524.902 172.637L522.277 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 171.438H507.273L504.648 166.938L507.273 162.438H512.523L515.073 166.938L512.523 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 165.812H497.448L494.898 161.312L497.448 156.812H502.698L505.323 161.312L502.698 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 160.187H487.699L485.074 155.612L487.699 151.112H492.874L495.499 155.612L492.874 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 154.487H477.874L475.324 149.987L477.874 145.487H483.124L485.749 149.987L483.124 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 148.862H468.125L465.5 144.362L468.125 139.787H473.3L475.925 144.362L473.3 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 143.237H458.3L455.75 138.662L458.3 134.162H463.55L466.175 138.662L463.55 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 137.537H448.551L445.926 133.037L448.551 128.537H453.726L456.351 133.037L453.726 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 131.913H438.727L436.102 127.413L438.727 122.838H443.977L446.602 127.413L443.977 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.152 126.288H428.977L426.352 121.713L428.977 117.213H434.152L436.777 121.713L434.152 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.326 120.512H419.226L416.676 116.087L419.226 111.662H424.326L426.876 116.087L424.326 120.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.424 114.663H409.549L407.074 110.462L409.549 106.188H414.424L416.899 110.462L414.424 114.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.675 109.113H399.725L397.25 104.763L399.725 100.488H404.675L407.15 104.763L404.675 109.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.475 102.738H390.35L388.25 99.1375L390.35 95.4625H394.475L396.575 99.1375L394.475 102.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.726 97.1125H380.526L378.426 93.5125L380.526 89.8375H384.726L386.826 93.5125L384.726 97.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.377 90.5124H371.302L369.727 87.8124L371.302 85.1124H374.377L375.952 87.8124L374.377 90.5124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.051 112.637H234.501L233.301 110.462L234.501 108.287H237.051L238.326 110.462L237.051 112.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.426 151.937H166.176L165.051 149.987L166.176 148.037H168.426L169.551 149.987L168.426 151.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.051 181.337H116.601L114.801 178.262L116.601 175.188H120.051L121.851 178.262L120.051 181.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 188.462H105.949L103.324 183.887L105.949 179.387H111.124L113.749 183.887L111.124 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.998 197.762H107.073L105.648 195.212L107.073 192.662H109.998L111.423 195.212L109.998 197.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.474 366.362H107.599L106.699 364.787L107.599 363.137H109.474L110.374 364.787L109.474 366.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 380.612H105.949L103.324 376.037L105.949 371.537H111.124L113.749 376.037L111.124 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 391.862H105.949L103.324 387.362L105.949 382.862H111.124L113.749 387.362L111.124 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 403.187H105.949L103.324 398.687L105.949 394.112H111.124L113.749 398.687L111.124 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 414.512H105.949L103.324 409.937L105.949 405.437H111.124L113.749 409.937L111.124 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 425.763H105.949L103.324 421.263L105.949 416.763H111.124L113.749 421.263L111.124 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 442.713H96.125L93.5 438.213L96.125 433.713H101.375L104 438.213L101.375 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 448.413H105.949L103.324 443.913L105.949 439.338H111.124L113.749 443.913L111.124 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 454.037H115.699L113.074 449.537L115.699 445.037H120.949L123.574 449.537L120.949 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 459.738H125.523L122.898 455.162L125.523 450.662H130.698L133.323 455.162L130.698 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 465.363H135.273L132.648 460.863L135.273 456.287H140.523L143.148 460.863L140.523 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 470.987H145.102L142.477 466.487L145.102 461.987H150.277L152.902 466.487L150.277 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 476.687H154.852L152.227 472.112L154.852 467.612H160.102L162.727 472.112L160.102 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.927 362.387H547.102L545.227 359.087L547.102 355.787H550.927L552.877 359.087L550.927 362.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 352.337H546.426L543.801 347.837L546.426 343.262H551.676L554.226 347.837L551.676 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 341.012H546.426L543.801 336.512L546.426 332.012H551.676L554.226 336.512L551.676 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 329.688H546.426L543.801 325.188L546.426 320.688H551.676L554.226 325.188L551.676 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 318.437H546.426L543.801 313.862L546.426 309.362H551.676L554.226 313.862L551.676 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 307.112H546.426L543.801 302.612L546.426 298.037H551.676L554.226 302.612L551.676 307.112Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 295.787H546.426L543.801 291.287L546.426 286.787H551.676L554.226 291.287L551.676 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 284.537H546.426L543.801 279.962L546.426 275.462H551.676L554.226 279.962L551.676 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 273.212H546.426L543.801 268.712L546.426 264.137H551.676L554.226 268.712L551.676 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 261.887H546.426L543.801 257.387L546.426 252.887H551.676L554.226 257.387L551.676 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 250.562H546.426L543.801 246.062L546.426 241.562H551.676L554.226 246.062L551.676 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 239.312H546.426L543.801 234.737L546.426 230.237H551.676L554.226 234.737L551.676 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 227.987H546.426L543.801 223.487L546.426 218.912H551.676L554.226 223.487L551.676 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 216.662H546.426L543.801 212.162L546.426 207.662H551.676L554.226 212.162L551.676 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 205.412H546.426L543.801 200.837L546.426 196.337H551.676L554.226 200.837L551.676 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 194.087H546.426L543.801 189.587L546.426 185.012H551.676L554.226 189.587L551.676 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 182.762H546.426L543.801 178.262L546.426 173.762H551.676L554.226 178.262L551.676 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 177.137H536.601L534.051 172.637L536.601 168.062H541.851L544.476 172.637L541.851 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 171.438H526.852L524.227 166.938L526.852 162.438H532.102L534.652 166.938L532.102 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 165.812H517.027L514.477 161.312L517.027 156.812H522.277L524.902 161.312L522.277 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 160.187H507.273L504.648 155.612L507.273 151.112H512.523L515.073 155.612L512.523 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 154.487H497.448L494.898 149.987L497.448 145.487H502.698L505.323 149.987L502.698 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 148.862H487.699L485.074 144.362L487.699 139.787H492.874L495.499 144.362L492.874 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 143.237H477.874L475.324 138.662L477.874 134.162H483.124L485.749 138.662L483.124 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 137.537H468.125L465.5 133.037L468.125 128.537H473.3L475.925 133.037L473.3 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 131.913H458.3L455.75 127.413L458.3 122.838H463.55L466.175 127.413L463.55 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 126.288H448.551L445.926 121.713L448.551 117.213H453.726L456.351 121.713L453.726 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.977 120.588H438.727L436.102 116.088L438.727 111.588H443.977L446.602 116.088L443.977 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.252 113.312H429.877L428.227 110.462L429.877 107.537H433.252L434.902 110.462L433.252 113.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.027 108.663H419.527L417.352 104.762L419.527 100.938H424.027L426.277 104.762L424.027 108.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.101 64.1125H340.851L338.301 59.5375L340.851 55.0375H346.101L348.651 59.5375L346.101 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.301 56.6874H332.076L330.426 53.9124L332.076 51.1375H335.301L336.951 53.9124L335.301 56.6874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.023 50.2375H322.773L321.648 48.2875L322.773 46.3375H325.023L326.148 48.2875L325.023 50.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.651 134.087H176.451L175.926 133.038L176.451 132.062H177.651L178.251 133.038L177.651 134.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 143.237H164.676L162.051 138.662L164.676 134.162H169.851L172.476 138.662L169.851 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.799 148.337H155.149L152.824 144.362L155.149 140.312H159.799L162.124 144.362L159.799 148.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 177.137H105.949L103.324 172.637L105.949 168.062H111.124L113.749 172.637L111.124 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 182.762H96.125L93.5 178.262L96.125 173.762H101.375L104 178.262L101.375 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 194.087H96.125L93.5 189.587L96.125 185.012H101.375L104 189.587L101.375 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.299 205.337H96.1992L93.5742 200.837L96.1992 196.412H101.299L103.924 200.837L101.299 205.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 216.062H96.5L94.25 212.162L96.5 208.262H101L103.175 212.162L101 216.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.226 363.363H96.2758L93.8008 359.088L96.2758 354.812H101.226L103.701 359.088L101.226 363.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 374.912H96.125L93.5 370.412L96.125 365.912H101.375L104 370.412L101.375 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 386.237H96.125L93.5 381.737L96.125 377.162H101.375L104 381.737L101.375 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 397.562H96.125L93.5 392.987L96.125 388.487H101.375L104 392.987L101.375 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 408.812H96.125L93.5 404.312L96.125 399.812H101.375L104 404.312L101.375 408.812Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 420.138H96.125L93.5 415.638L96.125 411.062H101.375L104 415.638L101.375 420.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 431.462H96.125L93.5 426.888L96.125 422.388H101.375L104 426.888L101.375 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 448.413H86.375L83.75 443.913L86.375 439.338H91.55L94.175 443.913L91.55 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 454.037H96.125L93.5 449.537L96.125 445.037H101.375L104 449.537L101.375 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 459.738H105.949L103.324 455.162L105.949 450.662H111.124L113.749 455.162L111.124 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 465.363H115.699L113.074 460.863L115.699 456.287H120.949L123.574 460.863L120.949 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 470.987H125.523L122.898 466.487L125.523 461.987H130.698L133.323 466.487L130.698 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 476.687H135.273L132.648 472.112L135.273 467.612H140.523L143.148 472.112L140.523 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 482.312H145.102L142.477 477.812L145.102 473.312H150.277L152.902 477.812L150.277 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.675 367.938H557L555.125 364.788L557 361.562H560.675L562.55 364.788L560.675 367.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.05 334.712H556.55L554.375 330.812L556.55 326.987H561.05L563.3 330.812L561.05 334.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 324.062H556.175L553.625 319.562L556.175 314.987H561.425L564.05 319.562L561.425 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 312.737H556.175L553.625 308.237L556.175 303.737H561.425L564.05 308.237L561.425 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 301.487H556.175L553.625 296.912L556.175 292.412H561.425L564.05 296.912L561.425 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 290.163H556.175L553.625 285.663L556.175 281.088H561.425L564.05 285.663L561.425 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 278.838H556.175L553.625 274.338L556.175 269.838H561.425L564.05 274.338L561.425 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 267.512H556.175L553.625 263.012L556.175 258.512H561.425L564.05 263.012L561.425 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 256.263H556.175L553.625 251.763L556.175 247.188H561.425L564.05 251.763L561.425 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 244.938H556.175L553.625 240.438L556.175 235.938H561.425L564.05 240.438L561.425 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 233.612H556.175L553.625 229.112L556.175 224.612H561.425L564.05 229.112L561.425 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 222.362H556.175L553.625 217.787L556.175 213.287H561.425L564.05 217.787L561.425 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 211.038H556.175L553.625 206.538L556.175 201.963H561.425L564.05 206.538L561.425 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 199.713H556.175L553.625 195.213L556.175 190.713H561.425L564.05 195.213L561.425 199.713Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 188.462H556.175L553.625 183.887L556.175 179.387H561.425L564.05 183.887L561.425 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 177.137H556.175L553.625 172.637L556.175 168.062H561.425L564.05 172.637L561.425 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 171.438H546.426L543.801 166.938L546.426 162.438H551.676L554.226 166.938L551.676 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 165.812H536.601L534.051 161.312L536.601 156.812H541.851L544.476 161.312L541.851 165.812Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 160.187H526.852L524.227 155.612L526.852 151.112H532.102L534.652 155.612L532.102 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 154.487H517.027L514.477 149.987L517.027 145.487H522.277L524.902 149.987L522.277 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 148.862H507.273L504.648 144.362L507.273 139.787H512.523L515.073 144.362L512.523 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 143.237H497.448L494.898 138.662L497.448 134.162H502.698L505.323 138.662L502.698 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 137.537H487.699L485.074 133.037L487.699 128.537H492.874L495.499 133.037L492.874 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 131.913H477.874L475.324 127.413L477.874 122.838H483.124L485.749 127.413L483.124 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 126.288H468.125L465.5 121.713L468.125 117.213H473.3L475.925 121.713L473.3 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 120.588H458.3L455.75 116.088L458.3 111.588H463.55L466.175 116.088L463.55 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.726 114.962H448.551L445.926 110.462L448.551 105.887H453.726L456.351 110.462L453.726 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.149 107.837H439.624L437.824 104.762L439.624 101.762H443.149L444.874 104.762L443.149 107.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.575 60.4375H362.525L362 59.5375L362.525 58.7125H363.575L364.1 59.5375L363.575 60.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.275 55.7125H352.175L351.125 53.9125L352.175 52.1125H354.275L355.4 53.9125L354.275 55.7125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.102 52.7875H340.852L338.227 48.2875L340.852 43.7125H346.102L348.727 48.2875L346.102 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.277 47.1625H331.102L328.477 42.5875L331.102 38.0875H336.277L338.902 42.5875L336.277 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.523 41.4625H321.273L318.648 36.9625L321.273 32.4625H326.523L329.073 36.9625L326.523 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.748 89.4625H234.873L233.898 87.8125L234.873 86.1625H236.748L237.648 87.8125L236.748 89.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.601 96.2124H224.451L222.801 93.5124L224.451 90.7374H227.601L229.176 93.5124L227.601 96.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 103.637H213.648L211.023 99.1375L213.648 94.6375H218.823L221.373 99.1375L218.823 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 109.337H203.824L201.199 104.762L203.824 100.262H208.999L211.624 104.762L208.999 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 114.963H193.999L191.449 110.463L193.999 105.963H199.249L201.799 110.463L199.249 114.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.275 120.287H184.475L182 116.087L184.475 111.887H189.275L191.675 116.087L189.275 120.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.373 125.762H174.723L172.398 121.712L174.723 117.662H179.373L181.773 121.712L179.373 125.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 131.913H164.676L162.051 127.413L164.676 122.838H169.851L172.476 127.413L169.851 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 137.537H154.852L152.227 133.037L154.852 128.537H160.102L162.727 133.037L160.102 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.675 142.112H145.7L143.75 138.662L145.7 135.287H149.675L151.625 138.662L149.675 142.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.052 165.662H106.027L103.477 161.312L106.027 156.962H111.052L113.602 161.312L111.052 165.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 171.438H96.125L93.5 166.938L96.125 162.438H101.375L104 166.938L101.375 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 177.137H86.375L83.75 172.637L86.375 168.062H91.55L94.175 172.637L91.55 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 188.462H86.375L83.75 183.887L86.375 179.387H91.55L94.175 183.887L91.55 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 199.713H86.375L83.75 195.213L86.375 190.713H91.55L94.175 195.213L91.55 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 211.038H86.375L83.75 206.538L86.375 201.963H91.55L94.175 206.538L91.55 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65 220.713H87.275L85.625 217.788L87.275 214.938H90.65L92.3 217.788L90.65 220.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0984 357.212H86.8234L84.6484 353.462L86.8234 349.712H91.0984L93.2734 353.462L91.0984 357.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 369.288H86.375L83.75 364.788L86.375 360.213H91.55L94.175 364.788L91.55 369.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 380.612H86.375L83.75 376.037L86.375 371.537H91.55L94.175 376.037L91.55 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 391.862H86.375L83.75 387.362L86.375 382.862H91.55L94.175 387.362L91.55 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 403.187H86.375L83.75 398.687L86.375 394.112H91.55L94.175 398.687L91.55 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 414.513H86.375L83.75 409.938L86.375 405.438H91.55L94.175 409.938L91.55 414.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 425.763H86.375L83.75 421.263L86.375 416.763H91.55L94.175 421.263L91.55 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 437.088H86.375L83.75 432.588L86.375 428.088H91.55L94.175 432.588L91.55 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 454.037H76.5508L73.9258 449.537L76.5508 445.037H81.8008L84.4258 449.537L81.8008 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 459.738H86.375L83.75 455.162L86.375 450.662H91.55L94.175 455.162L91.55 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 465.363H96.125L93.5 460.863L96.125 456.287H101.375L104 460.863L101.375 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 470.987H105.949L103.324 466.487L105.949 461.987H111.124L113.749 466.487L111.124 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 476.687H115.699L113.074 472.112L115.699 467.612H120.949L123.574 472.112L120.949 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 482.312H125.523L122.898 477.812L125.523 473.237H130.698L133.323 477.812L130.698 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 487.937H135.273L132.648 483.437L135.273 478.937H140.523L143.148 483.437L140.523 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.524 326.762H567.724L566.824 325.187L567.724 323.612H569.524L570.424 325.187L569.524 326.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 318.437H566L563.375 313.862L566 309.362H571.25L573.8 313.862L571.25 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 307.112H566L563.375 302.612L566 298.037H571.25L573.8 302.612L571.25 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 295.787H566L563.375 291.287L566 286.787H571.25L573.8 291.287L571.25 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 284.538H566L563.375 279.963L566 275.463H571.25L573.8 279.963L571.25 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 273.212H566L563.375 268.712L566 264.137H571.25L573.8 268.712L571.25 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 261.887H566L563.375 257.387L566 252.887H571.25L573.8 257.387L571.25 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 250.562H566L563.375 246.062L566 241.562H571.25L573.8 246.062L571.25 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 239.312H566L563.375 234.737L566 230.237H571.25L573.8 234.737L571.25 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 227.987H566L563.375 223.487L566 218.912H571.25L573.8 223.487L571.25 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 216.662H566L563.375 212.162L566 207.662H571.25L573.8 212.162L571.25 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 205.413H566L563.375 200.838L566 196.338H571.25L573.8 200.838L571.25 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 194.087H566L563.375 189.587L566 185.012H571.25L573.8 189.587L571.25 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 182.762H566L563.375 178.262L566 173.762H571.25L573.8 178.262L571.25 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 171.438H566L563.375 166.938L566 162.438H571.25L573.8 166.938L571.25 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 165.812H556.175L553.625 161.312L556.175 156.812H561.425L564.05 161.312L561.425 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 160.187H546.426L543.801 155.612L546.426 151.112H551.676L554.226 155.612L551.676 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 154.487H536.601L534.051 149.987L536.601 145.487H541.851L544.476 149.987L541.851 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 148.862H526.852L524.227 144.362L526.852 139.787H532.102L534.652 144.362L532.102 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 143.237H517.027L514.477 138.662L517.027 134.162H522.277L524.902 138.662L522.277 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 137.537H507.273L504.648 133.037L507.273 128.537H512.523L515.073 133.037L512.523 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 131.913H497.448L494.898 127.413L497.448 122.838H502.698L505.323 127.413L502.698 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 126.288H487.699L485.074 121.713L487.699 117.213H492.874L495.499 121.713L492.874 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 120.588H477.874L475.324 116.088L477.874 111.588H483.124L485.749 116.088L483.124 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 114.962H468.125L465.5 110.462L468.125 105.887H473.3L475.925 110.462L473.3 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.55 109.337H458.3L455.75 104.762L458.3 100.262H463.55L466.175 104.762L463.55 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.923 100.563H450.348L449.523 99.1375L450.348 97.7125H451.923L452.748 99.1375L451.923 100.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.026 49.9374H362.076L361.176 48.2874L362.076 46.6375H364.026L364.926 48.2874L364.026 49.9374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.023 45.6625H351.498L349.773 42.5875L351.498 39.5875H355.023L356.748 42.5875L355.023 45.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.752 39.2125H342.127L340.852 36.9625L342.127 34.7125H344.752L346.102 36.9625L344.752 39.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.252 32.2374H333.127L332.602 31.3374L333.127 30.3624H334.252L334.777 31.3374L334.252 32.2374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.325 80.9124H233.3L230.75 76.5625L233.3 72.1375H238.325L240.8 76.5625L238.325 80.9124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.749 85.1875H224.299L222.574 82.1875L224.299 79.1875H227.749L229.474 82.1875L227.749 85.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.223 91.3375H214.173L212.148 87.8125L214.173 84.2875H218.223L220.323 87.8125L218.223 91.3375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 98.0125H203.824L201.199 93.5125L203.824 88.9375H208.999L211.624 93.5125L208.999 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 103.637H193.999L191.449 99.1375L193.999 94.6375H199.249L201.874 99.1375L199.249 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 109.337H184.25L181.625 104.762L184.25 100.262H189.425L192.05 104.762L189.425 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 114.962H174.425L171.875 110.462L174.425 105.887H179.675L182.3 110.462L179.675 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 120.588H164.676L162.051 116.088L164.676 111.588H169.851L172.476 116.088L169.851 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 126.288H154.852L152.227 121.713L154.852 117.213H160.102L162.727 121.713L160.102 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.824 131.087H145.549L143.449 127.412L145.549 123.737H149.824L151.924 127.412L149.824 131.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.951 150.737H108.126L107.676 149.987L108.126 149.237H108.951L109.401 149.987L108.951 150.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 159.512H96.5L94.25 155.612L96.5 151.787H101L103.175 155.612L101 159.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 165.812H86.375L83.75 161.312L86.375 156.812H91.55L94.175 161.312L91.55 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 171.438H76.5508L73.9258 166.938L76.5508 162.438H81.8008L84.4258 166.938L81.8008 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 182.762H76.5508L73.9258 178.262L76.5508 173.762H81.8008L84.4258 178.262L81.8008 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 194.087H76.5508L73.9258 189.587L76.5508 185.012H81.8008L84.4258 189.587L81.8008 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 205.412H76.5508L73.9258 200.837L76.5508 196.337H81.8008L84.4258 200.837L81.8008 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 216.662H76.5508L73.9258 212.162L76.5508 207.662H81.8008L84.4258 212.162L81.8008 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3742 225.588H77.9742L76.6992 223.488L77.9742 221.312H80.3742L81.6492 223.488L80.3742 225.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7 235.637H78.65L78.125 234.737L78.65 233.912H79.7L80.225 234.737L79.7 235.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6758 327.812H77.6758L76.1758 325.188L77.6758 322.562H80.6758L82.1758 325.188L80.6758 327.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.925 349.038H78.425L77.75 347.838L78.425 346.562H79.925L80.6 347.838L79.925 349.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 363.662H76.5508L73.9258 359.087L76.5508 354.587H81.8008L84.4258 359.087L81.8008 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 374.912H76.5508L73.9258 370.412L76.5508 365.912H81.8008L84.4258 370.412L81.8008 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 386.237H76.5508L73.9258 381.737L76.5508 377.162H81.8008L84.4258 381.737L81.8008 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 397.562H76.5508L73.9258 392.987L76.5508 388.487H81.8008L84.4258 392.987L81.8008 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 408.812H76.5508L73.9258 404.312L76.5508 399.812H81.8008L84.4258 404.312L81.8008 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 420.137H76.5508L73.9258 415.637L76.5508 411.062H81.8008L84.4258 415.637L81.8008 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 431.462H76.5508L73.9258 426.888L76.5508 422.388H81.8008L84.4258 426.888L81.8008 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 442.713H76.5508L73.9258 438.213L76.5508 433.713H81.8008L84.4258 438.213L81.8008 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 459.738H66.8008L64.1758 455.162L66.8008 450.662H71.9758L74.6008 455.162L71.9758 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 465.363H76.5508L73.9258 460.863L76.5508 456.287H81.8008L84.4258 460.863L81.8008 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 470.987H86.375L83.75 466.487L86.375 461.987H91.55L94.175 466.487L91.55 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 476.687H96.125L93.5 472.112L96.125 467.612H101.375L104 472.112L101.375 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 482.312H105.949L103.324 477.812L105.949 473.237H111.124L113.749 477.812L111.124 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 487.937H115.699L113.074 483.437L115.699 478.937H120.949L123.574 483.437L120.949 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 493.637H125.523L122.898 489.062L125.523 484.562H130.698L133.323 489.062L130.698 493.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 499.262H135.273L132.648 494.762L135.273 490.187H140.523L143.148 494.762L140.523 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 312.737H575.824L573.199 308.237L575.824 303.737H580.999L583.624 308.237L580.999 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 301.487H575.824L573.199 296.912L575.824 292.412H580.999L583.624 296.912L580.999 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 290.163H575.824L573.199 285.663L575.824 281.088H580.999L583.624 285.663L580.999 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 278.838H575.824L573.199 274.338L575.824 269.838H580.999L583.624 274.338L580.999 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 267.512H575.824L573.199 263.012L575.824 258.512H580.999L583.624 263.012L580.999 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 256.263H575.824L573.199 251.763L575.824 247.188H580.999L583.624 251.763L580.999 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 244.938H575.824L573.199 240.438L575.824 235.938H580.999L583.624 240.438L580.999 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 233.612H575.824L573.199 229.112L575.824 224.612H580.999L583.624 229.112L580.999 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 222.362H575.824L573.199 217.787L575.824 213.287H580.999L583.624 217.787L580.999 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 211.038H575.824L573.199 206.538L575.824 201.963H580.999L583.624 206.538L580.999 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 199.713H575.824L573.199 195.213L575.824 190.713H580.999L583.624 195.213L580.999 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 188.462H575.824L573.199 183.887L575.824 179.387H580.999L583.624 183.887L580.999 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 177.137H575.824L573.199 172.637L575.824 168.062H580.999L583.624 172.637L580.999 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 165.812H575.824L573.199 161.312L575.824 156.812H580.999L583.624 161.312L580.999 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 160.188H566L563.375 155.613L566 151.113H571.25L573.8 155.613L571.25 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 154.488H556.175L553.625 149.988L556.175 145.488H561.425L564.05 149.988L561.425 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 148.862H546.426L543.801 144.362L546.426 139.787H551.676L554.226 144.362L551.676 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 143.237H536.601L534.051 138.662L536.601 134.162H541.851L544.476 138.662L541.851 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 137.537H526.852L524.227 133.037L526.852 128.537H532.102L534.652 133.037L532.102 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 131.913H517.027L514.477 127.413L517.027 122.838H522.277L524.902 127.413L522.277 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 126.288H507.273L504.648 121.713L507.273 117.213H512.523L515.073 121.713L512.523 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 120.588H497.448L494.898 116.088L497.448 111.588H502.698L505.323 116.088L502.698 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 114.962H487.699L485.074 110.462L487.699 105.887H492.874L495.499 110.462L492.874 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.124 109.337H477.874L475.324 104.762L477.874 100.262H483.124L485.749 104.762L483.124 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.3 103.637H468.125L465.5 99.1375L468.125 94.6375H473.3L475.925 99.1375L473.3 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.599 94.7125H460.249L459.574 93.5125L460.249 92.3125H461.599L462.349 93.5125L461.599 94.7125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.351 91.7124H448.926L446.676 87.8124L448.926 83.9874H453.351L455.601 87.8124L453.351 91.7124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.173 83.5374H440.523L439.773 82.1875L440.523 80.7625H442.173L442.923 82.1875L442.173 83.5374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.224 40.7125H360.874L358.699 36.9625L360.874 33.2125H365.224L367.399 36.9625L365.224 40.7125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.476 35.1625H351.051L348.801 31.3375L351.051 27.5125H355.476L357.651 31.3375L355.476 35.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.127 60.5125H245.002L244.477 59.5375L245.002 58.5625H246.127L246.727 59.5375L246.127 60.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.402 69.6624H233.227L230.602 65.2374L233.227 60.7374H238.402L240.952 65.2374L238.402 69.6624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.648 75.3624H223.398L220.773 70.8624L223.398 66.3624H228.648L231.198 70.8624L228.648 75.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 81.0624H213.573L211.023 76.5624L213.573 71.9874H218.823L221.448 76.5624L218.823 81.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 86.6875H203.824L201.199 82.1875L203.824 77.6875H208.999L211.624 82.1875L208.999 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 92.3875H193.999L191.449 87.8125L193.999 83.3125H199.249L201.874 87.8125L199.249 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 98.0125H184.25L181.625 93.5125L184.25 88.9375H189.425L192.05 93.5125L189.425 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 103.637H174.425L171.875 99.1375L174.425 94.6375H179.675L182.3 99.1375L179.675 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 109.337H164.676L162.051 104.762L164.676 100.262H169.851L172.476 104.762L169.851 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 114.962H154.852L152.227 110.462L154.852 105.887H160.102L162.727 110.462L160.102 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 120.588H145.102L142.477 116.088L145.102 111.588H150.277L152.902 116.088L150.277 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2508 153.887H86.6758L84.4258 149.987L86.6758 146.087H91.2508L93.5008 149.987L91.2508 153.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 160.187H76.5508L73.9258 155.612L76.5508 151.112H81.8008L84.4258 155.612L81.8008 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 165.812H66.8008L64.1758 161.312L66.8008 156.812H71.9758L74.6008 161.312L71.9758 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 177.137H66.8008L64.1758 172.637L66.8008 168.062H71.9758L74.6008 172.637L71.9758 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 188.462H66.8008L64.1758 183.887L66.8008 179.387H71.9758L74.6008 183.887L71.9758 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 199.712H66.8008L64.1758 195.212L66.8008 190.712H71.9758L74.6008 195.212L71.9758 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 211.037H66.8008L64.1758 206.537L66.8008 201.962H71.9758L74.6008 206.537L71.9758 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 222.362H66.8008L64.1758 217.787L66.8008 213.287H71.9758L74.6008 217.787L71.9758 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 233.612H66.8008L64.1758 229.112L66.8008 224.612H71.9758L74.6008 229.112L71.9758 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1766 309.587H68.6016L67.8516 308.237L68.6016 306.887H70.1766L70.9266 308.237L70.1766 309.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6734 323.537H67.0984L64.7734 319.562L67.0984 315.512H71.6734L73.9984 319.562L71.6734 323.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 357.962H66.8008L64.1758 353.462L66.8008 348.962H71.9758L74.6008 353.462L71.9758 357.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 369.287H66.8008L64.1758 364.787L66.8008 360.212H71.9758L74.6008 364.787L71.9758 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 380.612H66.8008L64.1758 376.037L66.8008 371.537H71.9758L74.6008 376.037L71.9758 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 391.862H66.8008L64.1758 387.362L66.8008 382.862H71.9758L74.6008 387.362L71.9758 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 403.187H66.8008L64.1758 398.687L66.8008 394.112H71.9758L74.6008 398.687L71.9758 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 414.512H66.8008L64.1758 409.937L66.8008 405.437H71.9758L74.6008 409.937L71.9758 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 425.763H66.8008L64.1758 421.263L66.8008 416.763H71.9758L74.6008 421.263L71.9758 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 437.088H66.8008L64.1758 432.588L66.8008 428.088H71.9758L74.6008 432.588L71.9758 437.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 448.413H66.8008L64.1758 443.913L66.8008 439.338H71.9758L74.6008 443.913L71.9758 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6766 470.388H67.1016L64.8516 466.488L67.1016 462.588H71.6766L73.9266 466.488L71.6766 470.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 476.687H76.5508L73.9258 472.112L76.5508 467.612H81.8008L84.4258 472.112L81.8008 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 482.312H86.375L83.75 477.812L86.375 473.237H91.55L94.175 477.812L91.55 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 487.938H96.125L93.5 483.438L96.125 478.938H101.375L104 483.438L101.375 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 493.637H105.949L103.324 489.062L105.949 484.562H111.124L113.749 489.062L111.124 493.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 499.262H115.699L113.074 494.762L115.699 490.187H120.949L123.574 494.762L120.949 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 504.888H125.523L122.898 500.388L125.523 495.888H130.698L133.323 500.388L130.698 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.023 507.962H136.773L135.648 506.012L136.773 504.062H139.023L140.148 506.012L139.023 507.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.776 316.712H586.552L584.977 313.862L586.552 311.087H589.776L591.427 313.862L589.776 316.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 307.112H585.574L582.949 302.612L585.574 298.037H590.824L593.374 302.612L590.824 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 295.787H585.574L582.949 291.287L585.574 286.787H590.824L593.374 291.287L590.824 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 284.538H585.574L582.949 279.963L585.574 275.463H590.824L593.374 279.963L590.824 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 273.212H585.574L582.949 268.712L585.574 264.137H590.824L593.374 268.712L590.824 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 261.887H585.574L582.949 257.387L585.574 252.887H590.824L593.374 257.387L590.824 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 250.562H585.574L582.949 246.062L585.574 241.562H590.824L593.374 246.062L590.824 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 239.312H585.574L582.949 234.737L585.574 230.237H590.824L593.374 234.737L590.824 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 227.987H585.574L582.949 223.487L585.574 218.912H590.824L593.374 223.487L590.824 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 216.662H585.574L582.949 212.162L585.574 207.662H590.824L593.374 212.162L590.824 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 205.413H585.574L582.949 200.838L585.574 196.338H590.824L593.374 200.838L590.824 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 194.087H585.574L582.949 189.587L585.574 185.012H590.824L593.374 189.587L590.824 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 182.762H585.574L582.949 178.262L585.574 173.762H590.824L593.374 178.262L590.824 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 171.438H585.574L582.949 166.938L585.574 162.438H590.824L593.374 166.938L590.824 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 160.188H585.574L582.949 155.613L585.574 151.113H590.824L593.374 155.613L590.824 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 154.488H575.824L573.199 149.988L575.824 145.488H580.999L583.624 149.988L580.999 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 148.862H566L563.375 144.362L566 139.787H571.25L573.8 144.362L571.25 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 143.237H556.175L553.625 138.662L556.175 134.162H561.425L564.05 138.662L561.425 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 137.537H546.426L543.801 133.037L546.426 128.537H551.676L554.226 133.037L551.676 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 131.913H536.601L534.051 127.413L536.601 122.838H541.851L544.476 127.413L541.851 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 126.288H526.852L524.227 121.713L526.852 117.213H532.102L534.652 121.713L532.102 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 120.588H517.027L514.477 116.088L517.027 111.588H522.277L524.902 116.088L522.277 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.523 114.962H507.273L504.648 110.462L507.273 105.887H512.523L515.073 110.462L512.523 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.698 109.337H497.448L494.898 104.762L497.448 100.262H502.698L505.323 104.762L502.698 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.874 103.637H487.699L485.074 99.1375L487.699 94.6375H492.874L495.499 99.1375L492.874 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.702 95.5375H479.302L478.102 93.5125L479.302 91.4125H481.702L482.902 93.5125L481.702 95.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.898 79.4875H449.448L447.648 76.5625L449.448 73.5625H452.898L454.623 76.5625L452.898 79.4875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.226 38.0125H382.026L381.426 36.9625L382.026 35.9125H383.226L383.826 36.9625L383.226 38.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.127 35.3125H370.552L368.227 31.3375L370.552 27.2875H375.127L377.452 31.3375L375.127 35.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.652 26.6875H362.452L361.852 25.6375L362.452 24.5875H363.652L364.252 25.6375L363.652 26.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.348 49.6375H244.773L244.023 48.2875L244.773 46.9375H246.348L247.173 48.2875L246.348 49.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.402 58.4125H233.152L230.602 53.9125L233.152 49.4125H238.402L241.027 53.9125L238.402 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.648 64.1125H223.398L220.773 59.5375L223.398 55.0375H228.648L231.198 59.5375L228.648 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 69.7374H213.573L211.023 65.2374L213.573 60.7374H218.823L221.448 65.2374L218.823 69.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 75.3624H203.824L201.199 70.8624L203.824 66.3624H208.999L211.624 70.8624L208.999 75.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 81.0624H193.999L191.449 76.5624L193.999 71.9874H199.249L201.874 76.5624L199.249 81.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 86.6875H184.25L181.625 82.1875L184.25 77.6875H189.425L192.05 82.1875L189.425 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 92.3875H174.425L171.875 87.8125L174.425 83.3125H179.675L182.3 87.8125L179.675 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 98.0125H164.676L162.051 93.5125L164.676 88.9375H169.851L172.476 93.5125L169.851 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 103.637H154.852L152.227 99.1375L154.852 94.6375H160.102L162.727 99.1375L160.102 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.301 107.612H146.076L144.426 104.762L146.076 101.987H149.301L150.951 104.762L149.301 107.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.176 128.462H107.901L107.301 127.412L107.901 126.362H109.176L109.776 127.412L109.176 128.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 137.537H96.125L93.5 133.037L96.125 128.537H101.375L104 133.037L101.375 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9766 140.387H87.9516L86.9766 138.662L87.9516 137.012H89.9766L90.9516 138.662L89.9766 140.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 148.862H76.5508L73.9258 144.362L76.5508 139.787H81.8008L84.4258 144.362L81.8008 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 154.487H66.8008L64.1758 149.987L66.8008 145.487H71.9758L74.6008 149.987L71.9758 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4008 170.087H57.8008L55.9258 166.937L57.8008 163.787H61.4008L63.2758 166.937L61.4008 170.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0734 182.537H57.1234L54.6484 178.262L57.1234 173.987H62.0734L64.5484 178.262L62.0734 182.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 194.087H56.9766L54.3516 189.587L56.9766 185.012H62.2266L64.8516 189.587L62.2266 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 205.412H56.9766L54.3516 200.837L56.9766 196.337H62.2266L64.8516 200.837L62.2266 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 216.662H56.9766L54.3516 212.162L56.9766 207.662H62.2266L64.8516 212.162L62.2266 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 227.987H56.9766L54.3516 223.487L56.9766 218.912H62.2266L64.8516 223.487L62.2266 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 239.312H56.9766L54.3516 234.737L56.9766 230.237H62.2266L64.8516 234.737L62.2266 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.15 250.488H57.05L54.5 246.063L57.05 241.713H62.15L64.625 246.063L62.15 250.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0492 258.137H59.1492L58.6992 257.387L59.1492 256.637H60.0492L60.4992 257.387L60.0492 258.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5734 304.262H58.6234L57.6484 302.612L58.6234 300.887H60.5734L61.5484 302.612L60.5734 304.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2758 315.137H58.8508L58.1758 313.862L58.8508 312.662H60.2758L61.0258 313.862L60.2758 315.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0258 327.737H58.1758L56.6758 325.187L58.1758 322.712H61.0258L62.5258 325.187L61.0258 327.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0734 352.112H57.1234L54.6484 347.837L57.1234 343.487H62.0734L64.5484 347.837L62.0734 352.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 363.662H56.9766L54.3516 359.087L56.9766 354.587H62.2266L64.8516 359.087L62.2266 363.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 374.912H56.9766L54.3516 370.412L56.9766 365.912H62.2266L64.8516 370.412L62.2266 374.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 386.237H56.9766L54.3516 381.737L56.9766 377.162H62.2266L64.8516 381.737L62.2266 386.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 397.562H56.9766L54.3516 392.987L56.9766 388.487H62.2266L64.8516 392.987L62.2266 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 408.812H56.9766L54.3516 404.312L56.9766 399.812H62.2266L64.8516 404.312L62.2266 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 420.137H56.9766L54.3516 415.637L56.9766 411.062H62.2266L64.8516 415.637L62.2266 420.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 431.462H56.9766L54.3516 426.888L56.9766 422.388H62.2266L64.8516 426.888L62.2266 431.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 442.713H56.9766L54.3516 438.213L56.9766 433.713H62.2266L64.8516 438.213L62.2266 442.713Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 454.037H56.9766L54.3516 449.537L56.9766 445.037H62.2266L64.8516 449.537L62.2266 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5234 481.488H67.2484L65.1484 477.812L67.2484 474.138H71.5234L73.6234 477.812L71.5234 481.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 487.937H76.5508L73.9258 483.437L76.5508 478.937H81.8008L84.4258 483.437L81.8008 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 493.638H86.375L83.75 489.062L86.375 484.562H91.55L94.175 489.062L91.55 493.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 499.263H96.125L93.5 494.763L96.125 490.188H101.375L104 494.763L101.375 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 504.888H105.949L103.324 500.388L105.949 495.888H111.124L113.749 500.388L111.124 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.949 510.587H115.699L113.074 506.013L115.699 501.513H120.949L123.574 506.013L120.949 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.702 516.138H125.527L122.977 511.713L125.527 507.213H130.702L133.252 511.713L130.702 516.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.127 334.638H595.776L593.602 330.812L595.776 327.062H600.127L602.302 330.812L600.127 334.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 324.062H595.398L592.773 319.562L595.398 314.987H600.573L603.198 319.562L600.573 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 312.737H595.398L592.773 308.237L595.398 303.737H600.573L603.198 308.237L600.573 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 301.487H595.398L592.773 296.912L595.398 292.412H600.573L603.198 296.912L600.573 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 290.162H595.398L592.773 285.662L595.398 281.087H600.573L603.198 285.662L600.573 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 278.837H595.398L592.773 274.337L595.398 269.837H600.573L603.198 274.337L600.573 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 267.512H595.398L592.773 263.012L595.398 258.512H600.573L603.198 263.012L600.573 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 256.263H595.398L592.773 251.763L595.398 247.188H600.573L603.198 251.763L600.573 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 244.938H595.398L592.773 240.438L595.398 235.938H600.573L603.198 240.438L600.573 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 233.612H595.398L592.773 229.112L595.398 224.612H600.573L603.198 229.112L600.573 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 222.362H595.398L592.773 217.787L595.398 213.287H600.573L603.198 217.787L600.573 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 211.037H595.398L592.773 206.537L595.398 201.962H600.573L603.198 206.537L600.573 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 199.712H595.398L592.773 195.212L595.398 190.712H600.573L603.198 195.212L600.573 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 188.462H595.398L592.773 183.887L595.398 179.387H600.573L603.198 183.887L600.573 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 177.137H595.398L592.773 172.637L595.398 168.062H600.573L603.198 172.637L600.573 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 165.812H595.398L592.773 161.312L595.398 156.812H600.573L603.198 161.312L600.573 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 154.487H595.398L592.773 149.987L595.398 145.487H600.573L603.198 149.987L600.573 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 148.862H585.574L582.949 144.362L585.574 139.787H590.824L593.374 144.362L590.824 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 143.237H575.824L573.199 138.662L575.824 134.162H580.999L583.624 138.662L580.999 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 137.537H566L563.375 133.037L566 128.537H571.25L573.8 133.037L571.25 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 131.913H556.175L553.625 127.413L556.175 122.838H561.425L564.05 127.413L561.425 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 126.288H546.426L543.801 121.713L546.426 117.213H551.676L554.226 121.713L551.676 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 120.588H536.601L534.051 116.088L536.601 111.588H541.851L544.476 116.088L541.851 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 114.962H526.852L524.227 110.462L526.852 105.887H532.102L534.652 110.462L532.102 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 109.337H517.027L514.477 104.762L517.027 100.262H522.277L524.902 104.762L522.277 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.374 103.412H507.424L504.949 99.1374L507.424 94.8624H512.374L514.774 99.1374L512.374 103.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.626 97.8625H497.601L495.051 93.5125L497.601 89.1625H502.626L505.101 93.5125L502.626 97.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.652 91.9375H487.927L485.602 87.8125L487.927 83.7625H492.652L495.052 87.8125L492.652 91.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.175 74.6875H458.75L456.5 70.8625L458.75 67.0375H463.175L465.35 70.8625L463.175 74.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.548 65.9874H450.723L450.273 65.2374L450.723 64.4874H451.548L451.998 65.2374L451.548 65.9874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.823 35.6124H252.873L250.398 31.3374L252.873 26.9874H257.823L260.373 31.3374L257.823 35.6124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.998 41.2375H243.123L240.648 36.9625L243.123 32.6875H247.998L250.473 36.9625L247.998 41.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.402 47.1625H233.152L230.602 42.5875L233.152 38.0875H238.402L241.027 42.5875L238.402 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.648 52.7875H223.398L220.773 48.2875L223.398 43.7125H228.648L231.198 48.2875L228.648 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 58.4125H213.573L211.023 53.9125L213.573 49.4125H218.823L221.448 53.9125L218.823 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 64.1125H203.824L201.199 59.5375L203.824 55.0375H208.999L211.624 59.5375L208.999 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 69.7374H193.999L191.449 65.2374L193.999 60.7374H199.249L201.874 65.2374L199.249 69.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 75.3625H184.25L181.625 70.8625L184.25 66.3625H189.425L192.05 70.8625L189.425 75.3625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 81.0626H174.425L171.875 76.5626L174.425 71.9875H179.675L182.3 76.5626L179.675 81.0626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 86.6875H164.676L162.051 82.1875L164.676 77.6875H169.851L172.476 82.1875L169.851 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 92.3875H154.852L152.227 87.8125L154.852 83.3125H160.102L162.727 87.8125L160.102 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.05 97.5625H145.325L143 93.5125L145.325 89.3875H150.05L152.375 93.5125L150.05 97.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.823 112.937H116.823L115.398 110.462L116.823 107.912H119.823L121.248 110.462L119.823 112.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 120.588H105.949L103.324 116.088L105.949 111.588H111.124L113.749 116.088L111.124 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 126.288H96.125L93.5 121.713L96.125 117.213H101.375L104 121.713L101.375 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 131.912H86.375L83.75 127.412L86.375 122.912H91.55L94.175 127.412L91.55 131.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.975 143.163H66.8L64.25 138.663L66.8 134.238H71.975L74.525 138.663L71.975 143.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4984 175.562H48.1234L46.3984 172.637L48.1234 169.637H51.4984L53.2234 172.637L51.4984 175.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3242 188.237H47.2992L44.8242 183.887L47.2992 179.612H52.3242L54.7992 183.887L52.3242 188.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 199.712H47.2266L44.6016 195.212L47.2266 190.712H52.4016L55.0266 195.212L52.4016 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 211.037H47.2266L44.6016 206.537L47.2266 201.962H52.4016L55.0266 206.537L52.4016 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 222.362H47.2266L44.6016 217.787L47.2266 213.287H52.4016L55.0266 217.787L52.4016 222.362Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 233.612H47.2266L44.6016 229.112L47.2266 224.612H52.4016L55.0266 229.112L52.4016 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 244.938H47.2266L44.6016 240.438L47.2266 235.938H52.4016L55.0266 240.438L52.4016 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 256.263H47.2266L44.6016 251.763L47.2266 247.188H52.4016L55.0266 251.763L52.4016 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9492 266.687H47.6742L45.5742 263.012L47.6742 259.337H51.9492L54.0492 263.012L51.9492 266.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9008 310.112H48.7258L47.6758 308.237L48.7258 306.362H50.9008L51.9508 308.237L50.9008 310.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7516 321.137H48.8766L47.9766 319.562L48.8766 317.912H50.7516L51.6516 319.562L50.7516 321.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8734 357.062H47.7484L45.6484 353.462L47.7484 349.862H51.8734L53.9734 353.462L51.8734 357.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 369.287H47.2266L44.6016 364.787L47.2266 360.212H52.4016L55.0266 364.787L52.4016 369.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 380.612H47.2266L44.6016 376.037L47.2266 371.537H52.4016L55.0266 376.037L52.4016 380.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 391.862H47.2266L44.6016 387.362L47.2266 382.862H52.4016L55.0266 387.362L52.4016 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 403.187H47.2266L44.6016 398.687L47.2266 394.112H52.4016L55.0266 398.687L52.4016 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 414.512H47.2266L44.6016 409.937L47.2266 405.437H52.4016L55.0266 409.937L52.4016 414.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 425.763H47.2266L44.6016 421.263L47.2266 416.763H52.4016L55.0266 421.263L52.4016 425.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4008 437.013H47.2258L44.6758 432.588L47.2258 428.088H52.4008L54.9508 432.588L52.4008 437.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3492 446.538H48.2742L46.6992 443.913L48.2742 441.213H51.3492L52.8492 443.913L51.3492 446.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2984 492.437H67.3984L65.5234 489.062L67.3984 485.687H71.2984L73.2484 489.062L71.2984 492.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 499.262H76.5508L73.9258 494.762L76.5508 490.187H81.8008L84.4258 494.762L81.8008 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 504.888H86.375L83.75 500.388L86.375 495.888H91.55L94.175 500.388L91.55 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 510.587H96.125L93.5 506.013L96.125 501.513H101.375L104 506.013L101.375 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 516.213H105.949L103.324 511.713L105.949 507.213H111.124L113.749 511.713L111.124 516.213Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.948 521.838H115.698L113.148 517.338L115.698 512.838H120.948L123.498 517.338L120.948 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.648 384.962H605.898L604.023 381.737L605.898 378.512H609.648L611.523 381.737L609.648 384.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.35 373.113H606.2L604.625 370.413L606.2 367.713H609.35L610.85 370.413L609.35 373.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.951 340.263H605.601L603.426 336.513L605.601 332.688H609.951L612.126 336.513L609.951 340.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 329.688H605.148L602.523 325.188L605.148 320.688H610.398L612.948 325.188L610.398 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 318.437H605.148L602.523 313.862L605.148 309.362H610.398L612.948 313.862L610.398 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 307.112H605.148L602.523 302.612L605.148 298.037H610.398L612.948 302.612L610.398 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 295.787H605.148L602.523 291.287L605.148 286.787H610.398L612.948 291.287L610.398 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 284.537H605.148L602.523 279.962L605.148 275.462H610.398L612.948 279.962L610.398 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 273.212H605.148L602.523 268.712L605.148 264.137H610.398L612.948 268.712L610.398 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 261.887H605.148L602.523 257.387L605.148 252.887H610.398L612.948 257.387L610.398 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 250.562H605.148L602.523 246.062L605.148 241.562H610.398L612.948 246.062L610.398 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 239.312H605.148L602.523 234.737L605.148 230.237H610.398L612.948 234.737L610.398 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 227.987H605.148L602.523 223.487L605.148 218.912H610.398L612.948 223.487L610.398 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 216.662H605.148L602.523 212.162L605.148 207.662H610.398L612.948 212.162L610.398 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 205.412H605.148L602.523 200.837L605.148 196.337H610.398L612.948 200.837L610.398 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 194.087H605.148L602.523 189.587L605.148 185.012H610.398L612.948 189.587L610.398 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 182.762H605.148L602.523 178.262L605.148 173.762H610.398L612.948 178.262L610.398 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 171.438H605.148L602.523 166.938L605.148 162.438H610.398L612.948 166.938L610.398 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 160.187H605.148L602.523 155.612L605.148 151.112H610.398L612.948 155.612L610.398 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 148.862H605.148L602.523 144.362L605.148 139.787H610.398L612.948 144.362L610.398 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 143.237H595.398L592.773 138.662L595.398 134.162H600.573L603.198 138.662L600.573 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 137.537H585.574L582.949 133.037L585.574 128.537H590.824L593.374 133.037L590.824 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 131.913H575.824L573.199 127.413L575.824 122.838H580.999L583.624 127.413L580.999 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 126.288H566L563.375 121.713L566 117.213H571.25L573.8 121.713L571.25 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 120.588H556.175L553.625 116.088L556.175 111.588H561.425L564.05 116.088L561.425 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 114.962H546.426L543.801 110.462L546.426 105.887H551.676L554.226 110.462L551.676 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 109.337H536.601L534.051 104.762L536.601 100.262H541.851L544.476 104.762L541.851 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.102 103.637H526.852L524.227 99.1375L526.852 94.6375H532.102L534.652 99.1375L532.102 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.277 98.0125H517.027L514.477 93.5125L517.027 88.9375H522.277L524.902 93.5125L522.277 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.326 90.2875H508.476L507.051 87.8125L508.476 85.4125H511.326L512.676 87.8125L511.326 90.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.75 83.2375H499.475L498.875 82.1875L499.475 81.0625H500.75L501.35 82.1875L500.75 83.2375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.548 68.3125H468.948L467.148 65.2375L468.948 62.0875H472.548L474.273 65.2375L472.548 68.3125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.324 28.7125H243.874L242.074 25.6375L243.874 22.6375H247.324L249.049 25.6375L247.324 28.7125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.402 35.8375H233.152L230.602 31.3375L233.152 26.7625H238.402L241.027 31.3375L238.402 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.648 41.4625H223.398L220.773 36.9625L223.398 32.4625H228.648L231.198 36.9625L228.648 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 47.1625H213.573L211.023 42.5875L213.573 38.0875H218.823L221.448 42.5875L218.823 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 52.7875H203.824L201.199 48.2875L203.824 43.7125H208.999L211.624 48.2875L208.999 52.7875Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 58.4125H193.999L191.449 53.9125L193.999 49.4125H199.249L201.874 53.9125L199.249 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 64.1125H184.25L181.625 59.5375L184.25 55.0375H189.425L192.05 59.5375L189.425 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 69.7375H174.425L171.875 65.2375L174.425 60.7375H179.675L182.3 65.2375L179.675 69.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 75.3624H164.676L162.051 70.8624L164.676 66.3624H169.851L172.476 70.8624L169.851 75.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 81.0624H154.852L152.227 76.5624L154.852 71.9874H160.102L162.727 76.5624L160.102 81.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.276 86.6125H145.101L142.551 82.1875L145.101 77.6875H150.276L152.826 82.1875L150.276 86.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.498 88.7875H137.298L136.773 87.8125L137.298 86.8375H138.498L139.023 87.8125L138.498 88.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.152 107.537H106.927L105.352 104.762L106.927 101.987H110.152L111.727 104.762L110.152 107.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 114.962H96.125L93.5 110.462L96.125 105.887H101.375L104 110.462L101.375 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 120.588H86.375L83.75 116.088L86.375 111.588H91.55L94.175 116.088L91.55 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.725 126.212H76.55L74 121.712L76.55 117.287H81.725L84.35 121.712L81.725 126.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9516 128.387H68.8266L68.2266 127.412L68.8266 126.362H69.9516L70.5516 127.412L69.9516 128.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7992 135.137H58.3992L57.1992 133.038L58.3992 130.938H60.7992L61.9992 133.038L60.7992 135.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7742 168.287H39.1992L38.4492 166.937L39.1992 165.587H40.7742L41.5992 166.937L40.7742 168.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 182.762H37.3984L34.7734 178.262L37.3984 173.762H42.6484L45.1984 178.262L42.6484 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 194.087H37.3984L34.7734 189.587L37.3984 185.012H42.6484L45.1984 189.587L42.6484 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 205.412H37.3984L34.7734 200.837L37.3984 196.337H42.6484L45.1984 200.837L42.6484 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 216.662H37.3984L34.7734 212.162L37.3984 207.662H42.6484L45.1984 212.162L42.6484 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 227.987H37.3984L34.7734 223.487L37.3984 218.912H42.6484L45.1984 223.487L42.6484 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 239.312H37.3984L34.7734 234.737L37.3984 230.237H42.6484L45.1984 234.737L42.6484 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 250.562H37.3984L34.7734 246.062L37.3984 241.562H42.6484L45.1984 246.062L42.6484 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 261.887H37.3984L34.7734 257.387L37.3984 252.887H42.6484L45.1984 257.387L42.6484 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5758 273.062H37.4758L34.9258 268.712L37.4758 264.287H42.5758L45.1258 268.712L42.5758 273.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8508 281.462H39.2008L38.3008 279.962L39.2008 278.537H40.8508L41.6758 279.962L40.8508 281.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2016 295.112H37.8516L35.6016 291.287L37.8516 287.462H42.2016L44.3766 291.287L42.2016 295.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7016 315.062H39.3516L38.6016 313.862L39.3516 312.662H40.7016L41.3766 313.862L40.7016 315.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4992 363.438H37.5492L35.0742 359.088L37.5492 354.812H42.4992L44.9742 359.088L42.4992 363.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7734 371.687H39.2734L38.5234 370.412L39.2734 369.137H40.7734L41.5234 370.412L40.7734 371.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6 384.438H38.45L36.875 381.738L38.45 378.963H41.6L43.175 381.738L41.6 384.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 397.562H37.3984L34.7734 392.987L37.3984 388.487H42.6484L45.1984 392.987L42.6484 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5766 408.812H37.4016L34.8516 404.312L37.4016 399.812H42.5766L45.2016 404.312L42.5766 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.075 417.363H38.975L38 415.638L38.975 413.838H41.075L42.05 415.638L41.075 417.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2742 430.862H37.6992L35.4492 426.887L37.6992 422.987H42.2742L44.5992 426.887L42.2742 430.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8508 502.938H67.9258L66.4258 500.388L67.9258 497.838H70.8508L72.3508 500.388L70.8508 502.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 510.587H76.5508L73.9258 506.013L76.5508 501.513H81.8008L84.4258 506.013L81.8008 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 516.213H86.375L83.75 511.713L86.375 507.213H91.55L94.175 511.713L91.55 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 521.838H96.125L93.5 517.338L96.125 512.838H101.375L104 517.338L101.375 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 527.538H105.949L103.324 522.963L105.949 518.463H111.124L113.749 522.963L111.124 527.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.675 530.988H116.975L115.625 528.663L116.975 526.338H119.675L121.025 528.663L119.675 530.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.248 401.612H615.873L614.148 398.687L615.873 395.687H619.248L620.974 398.687L619.248 401.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.998 391.637H615.123L612.648 387.362L615.123 383.087H619.998L622.474 387.362L619.998 391.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.349 377.463H616.774L615.949 376.038L616.774 374.688H618.349L619.174 376.038L618.349 377.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.074 369.062H615.049L612.574 364.788L615.049 360.438H620.074L622.549 364.788L620.074 369.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.349 354.812H616.774L615.949 353.462L616.774 352.112H618.349L619.099 353.462L618.349 354.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.998 346.412H615.048L612.648 342.137L615.048 337.862H619.998L622.474 342.137L619.998 346.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 335.388H614.977L612.352 330.812L614.977 326.312H620.151L622.776 330.812L620.151 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 324.062H614.977L612.352 319.562L614.977 314.987H620.151L622.776 319.562L620.151 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 312.737H614.977L612.352 308.237L614.977 303.737H620.151L622.776 308.237L620.151 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 301.487H614.977L612.352 296.912L614.977 292.412H620.151L622.776 296.912L620.151 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 290.162H614.977L612.352 285.662L614.977 281.087H620.151L622.776 285.662L620.151 290.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 278.837H614.977L612.352 274.337L614.977 269.837H620.151L622.776 274.337L620.151 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 267.512H614.977L612.352 263.012L614.977 258.512H620.151L622.776 263.012L620.151 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 256.263H614.977L612.352 251.763L614.977 247.188H620.151L622.776 251.763L620.151 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 244.938H614.977L612.352 240.438L614.977 235.938H620.151L622.776 240.438L620.151 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 233.612H614.977L612.352 229.112L614.977 224.612H620.151L622.776 229.112L620.151 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 222.362H614.977L612.352 217.787L614.977 213.287H620.151L622.776 217.787L620.151 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 211.037H614.977L612.352 206.537L614.977 201.962H620.151L622.776 206.537L620.151 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 199.712H614.977L612.352 195.212L614.977 190.712H620.151L622.776 195.212L620.151 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 188.462H614.977L612.352 183.887L614.977 179.387H620.151L622.776 183.887L620.151 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 177.137H614.977L612.352 172.637L614.977 168.062H620.151L622.776 172.637L620.151 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 165.812H614.977L612.352 161.312L614.977 156.812H620.151L622.776 161.312L620.151 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 154.487H614.977L612.352 149.987L614.977 145.487H620.151L622.776 149.987L620.151 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 143.237H614.977L612.352 138.662L614.977 134.162H620.151L622.776 138.662L620.151 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 137.537H605.148L602.523 133.037L605.148 128.537H610.398L612.948 133.037L610.398 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 131.913H595.398L592.773 127.413L595.398 122.838H600.573L603.198 127.413L600.573 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 126.288H585.574L582.949 121.713L585.574 117.213H590.824L593.374 121.713L590.824 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 120.588H575.824L573.199 116.088L575.824 111.588H580.999L583.624 116.088L580.999 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 114.962H566L563.375 110.462L566 105.887H571.25L573.8 110.462L571.25 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 109.337H556.175L553.625 104.762L556.175 100.262H561.425L564.05 104.762L561.425 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 103.637H546.426L543.801 99.1375L546.426 94.6375H551.676L554.226 99.1375L551.676 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 98.0125H536.601L534.051 93.5125L536.601 88.9375H541.851L544.476 93.5125L541.851 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.95 92.2375H526.925L524.375 87.8125L526.925 83.4625H531.95L534.5 87.8125L531.95 92.2375Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.926 84.2875H518.451L517.176 82.1875L518.451 80.0875H520.926L522.126 82.1875L520.926 84.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.826 63.5125H478.251L475.926 59.5374L478.251 55.6375H482.826L485.076 59.5374L482.826 63.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.325 17.4625H243.8L242 14.3875L243.8 11.2375H247.325L249.125 14.3875L247.325 17.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.176 24.1375H233.451L231.051 20.0125L233.451 15.8875H238.176L240.501 20.0125L238.176 24.1375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.149 27.6624H224.824L223.699 25.6374L224.824 23.6124H227.149L228.349 25.6374L227.149 27.6624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.823 35.8375H213.573L211.023 31.3375L213.573 26.7625H218.823L221.448 31.3375L218.823 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 41.4625H203.824L201.199 36.9625L203.824 32.4625H208.999L211.624 36.9625L208.999 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 47.1625H193.999L191.449 42.5875L193.999 38.0875H199.249L201.874 42.5875L199.249 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 52.7875H184.25L181.625 48.2875L184.25 43.7125H189.425L192.05 48.2875L189.425 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 58.4125H174.425L171.875 53.9125L174.425 49.4125H179.675L182.3 53.9125L179.675 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 64.1125H164.676L162.051 59.5375L164.676 55.0375H169.851L172.476 59.5375L169.851 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 69.7374H154.852L152.227 65.2374L154.852 60.7374H160.102L162.727 65.2374L160.102 69.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 75.3624H145.102L142.477 70.8624L145.102 66.3624H150.277L152.902 70.8624L150.277 75.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.874 78.2125H136.924L135.949 76.5625L136.924 74.8375H138.874L139.849 76.5625L138.874 78.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 103.637H96.125L93.5 99.1375L96.125 94.6375H101.375L104 99.1375L101.375 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4008 109.037H86.5258L84.0508 104.762L86.5258 100.487H91.4008L93.8758 104.762L91.4008 109.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8008 130.863H47.8258L45.8008 127.413L47.8258 123.963H51.8008L53.8258 127.413L51.8008 130.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3234 140.612H29.1484L28.0234 138.662L29.1484 136.787H31.3234L32.4484 138.662L31.3234 140.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.025 162.662H29.45L28.625 161.312L29.45 159.887H31.025L31.85 161.312L31.025 162.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 177.137H27.6484L25.0234 172.637L27.6484 168.062H32.8234L35.4484 172.637L32.8234 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 188.462H27.6484L25.0234 183.887L27.6484 179.387H32.8234L35.4484 183.887L32.8234 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 199.712H27.6484L25.0234 195.212L27.6484 190.712H32.8234L35.4484 195.212L32.8234 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 211.037H27.6484L25.0234 206.537L27.6484 201.962H32.8234L35.4484 206.537L32.8234 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 222.362H27.6484L25.0234 217.787L27.6484 213.287H32.8234L35.4484 217.787L32.8234 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 233.612H27.6484L25.0234 229.112L27.6484 224.612H32.8234L35.4484 229.112L32.8234 233.612Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 244.938H27.6484L25.0234 240.438L27.6484 235.938H32.8234L35.4484 240.438L32.8234 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 256.263H27.6484L25.0234 251.763L27.6484 247.188H32.8234L35.4484 251.763L32.8234 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 267.512H27.6484L25.0234 263.012L27.6484 258.512H32.8234L35.4484 263.012L32.8234 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 278.837H27.6484L25.0234 274.337L27.6484 269.837H32.8234L35.4484 274.337L32.8234 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.175 287.312H29.225L28.25 285.663L29.225 283.938H31.175L32.225 285.663L31.175 287.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5242 312.212H27.9492L25.6992 308.237L27.9492 304.337H32.5242L34.7742 308.237L32.5242 312.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8 343.188H29.6L29 342.138L29.6 341.088H30.8L31.4 342.138L30.8 343.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.025 354.812H29.45L28.625 353.462L29.45 352.037H31.025L31.85 353.462L31.025 354.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3266 366.587H29.1516L28.1016 364.787L29.1516 362.912H31.3266L32.3766 364.787L31.3266 366.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6742 515.687H67.0242L64.6992 511.712L67.0242 507.662H71.6742L73.9992 511.712L71.6742 515.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 521.838H76.5508L73.9258 517.338L76.5508 512.838H81.8008L84.4258 517.338L81.8008 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 527.538H86.375L83.75 522.963L86.375 518.463H91.55L94.175 522.963L91.55 527.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 533.162H96.125L93.5 528.662L96.125 524.162H101.375L104 528.662L101.375 533.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 538.787H105.949L103.324 534.287L105.949 529.787H111.124L113.749 534.287L111.124 538.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.823 408.587H624.873L622.398 404.312L624.873 400.037H629.823L632.224 404.312L629.823 408.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.751 397.187H624.951L622.551 392.987L624.951 388.862H629.751L632.151 392.987L629.751 397.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.477 383.612H626.227L625.102 381.737L626.227 379.787H628.477L629.602 381.737L628.477 383.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.626 372.662H626.076L624.801 370.412L626.076 368.162H628.626L629.901 370.412L628.626 372.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 352.337H624.727L622.102 347.837L624.727 343.262H629.977L632.602 347.837L629.977 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 341.012H624.727L622.102 336.512L624.727 332.012H629.977L632.602 336.512L629.977 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 329.688H624.727L622.102 325.188L624.727 320.688H629.977L632.602 325.188L629.977 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 318.437H624.727L622.102 313.862L624.727 309.362H629.977L632.602 313.862L629.977 318.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 307.112H624.727L622.102 302.612L624.727 298.037H629.977L632.602 302.612L629.977 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 295.787H624.727L622.102 291.287L624.727 286.787H629.977L632.602 291.287L629.977 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 284.537H624.727L622.102 279.962L624.727 275.462H629.977L632.602 279.962L629.977 284.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 273.212H624.727L622.102 268.712L624.727 264.137H629.977L632.602 268.712L629.977 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 261.887H624.727L622.102 257.387L624.727 252.887H629.977L632.602 257.387L629.977 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 250.562H624.727L622.102 246.062L624.727 241.562H629.977L632.602 246.062L629.977 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 239.312H624.727L622.102 234.737L624.727 230.237H629.977L632.602 234.737L629.977 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 227.987H624.727L622.102 223.487L624.727 218.912H629.977L632.602 223.487L629.977 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 216.662H624.727L622.102 212.162L624.727 207.662H629.977L632.602 212.162L629.977 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 205.412H624.727L622.102 200.837L624.727 196.337H629.977L632.602 200.837L629.977 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 194.087H624.727L622.102 189.587L624.727 185.012H629.977L632.602 189.587L629.977 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 182.762H624.727L622.102 178.262L624.727 173.762H629.977L632.602 178.262L629.977 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 171.438H624.727L622.102 166.938L624.727 162.438H629.977L632.602 166.938L629.977 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 160.187H624.727L622.102 155.612L624.727 151.112H629.977L632.602 155.612L629.977 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 148.862H624.727L622.102 144.362L624.727 139.787H629.977L632.602 144.362L629.977 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 137.537H624.727L622.102 133.037L624.727 128.537H629.977L632.602 133.037L629.977 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 131.913H614.977L612.352 127.413L614.977 122.838H620.151L622.776 127.413L620.151 131.913Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 126.288H605.148L602.523 121.713L605.148 117.213H610.398L612.948 121.713L610.398 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 120.588H595.398L592.773 116.088L595.398 111.588H600.573L603.198 116.088L600.573 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 114.962H585.574L582.949 110.462L585.574 105.887H590.824L593.374 110.462L590.824 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 109.337H575.824L573.199 104.762L575.824 100.262H580.999L583.624 104.762L580.999 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 103.637H566L563.375 99.1375L566 94.6375H571.25L573.8 99.1375L571.25 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 98.0125H556.175L553.625 93.5125L556.175 88.9375H561.425L564.05 93.5125L561.425 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 92.3875H546.426L543.801 87.8125L546.426 83.3125H551.676L554.226 87.8125L551.676 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.851 86.6875H536.601L534.051 82.1875L536.601 77.6875H541.851L544.476 82.1875L541.851 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.352 79.7874H527.602L525.727 76.5625L527.602 73.2625H531.352L533.227 76.5625L531.352 79.7874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.901 38.6125H459.951L459.051 36.9625L459.951 35.3125H461.901L462.876 36.9625L461.901 38.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.501 18.7375H223.476L220.926 14.3875L223.476 9.96252H228.501L231.051 14.3875L228.501 18.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.675 24.2875H213.725L211.25 20.0125L213.725 15.7375H218.675L221.15 20.0125L218.675 24.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.999 30.2125H203.824L201.199 25.6375L203.824 21.1375H208.999L211.624 25.6375L208.999 30.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 35.8375H193.999L191.449 31.3375L193.999 26.7625H199.249L201.874 31.3375L199.249 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 41.4625H184.25L181.625 36.9625L184.25 32.4625H189.425L192.05 36.9625L189.425 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 47.1625H174.425L171.875 42.5875L174.425 38.0875H179.675L182.3 42.5875L179.675 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 52.7875H164.676L162.051 48.2875L164.676 43.7125H169.851L172.476 48.2875L169.851 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 58.4125H154.852L152.227 53.9125L154.852 49.4125H160.102L162.727 53.9125L160.102 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 64.1125H145.102L142.477 59.5375L145.102 55.0375H150.277L152.902 59.5375L150.277 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45 69.5875H135.35L132.875 65.2375L135.35 60.8125H140.45L142.925 65.2375L140.45 69.5875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.251 90.4375H97.2508L95.6758 87.8125L97.2508 85.1875H100.251L101.826 87.8125L100.251 90.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 98.0125H86.375L83.75 93.5125L86.375 88.9375H91.55L94.175 93.5125L91.55 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1234 102.512H77.2234L75.2734 99.1375L77.2234 95.7625H81.1234L83.0734 99.1375L81.1234 102.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 114.962H56.9766L54.3516 110.462L56.9766 105.887H62.2266L64.8516 110.462L62.2266 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3242 120.362H47.2992L44.8242 116.087L47.2992 111.812H52.3242L54.7992 116.087L52.3242 120.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 126.288H37.3984L34.7734 121.713L37.3984 117.213H42.6484L45.1984 121.713L42.6484 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 131.913H27.6484L25.0234 127.413L27.6484 122.838H32.8234L35.4484 127.413L32.8234 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 137.537H17.8242L15.1992 133.037L17.8242 128.537H23.0742L25.6242 133.037L23.0742 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9258 148.712H17.9008L15.4258 144.362L17.9008 140.012H22.9258L25.4758 144.362L22.9258 148.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7758 159.662H18.1258L15.8008 155.612L18.1258 151.637H22.7758L25.0258 155.612L22.7758 159.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 171.438H17.8242L15.1992 166.938L17.8242 162.438H23.0742L25.6242 166.938L23.0742 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 182.762H17.8242L15.1992 178.262L17.8242 173.762H23.0742L25.6242 178.262L23.0742 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 194.087H17.8242L15.1992 189.587L17.8242 185.012H23.0742L25.6242 189.587L23.0742 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 205.412H17.8242L15.1992 200.837L17.8242 196.337H23.0742L25.6242 200.837L23.0742 205.412Z",
    fill: "#ACA7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 216.662H17.8242L15.1992 212.162L17.8242 207.662H23.0742L25.6242 212.162L23.0742 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 227.987H17.8242L15.1992 223.487L17.8242 218.912H23.0742L25.6242 223.487L23.0742 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 239.312H17.8242L15.1992 234.737L17.8242 230.237H23.0742L25.6242 234.737L23.0742 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 250.562H17.8242L15.1992 246.062L17.8242 241.562H23.0742L25.6242 246.062L23.0742 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 261.887H17.8242L15.1992 257.387L17.8242 252.887H23.0742L25.6242 257.387L23.0742 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 273.212H17.8242L15.1992 268.712L17.8242 264.137H23.0742L25.6242 268.712L23.0742 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9258 284.312H17.9008L15.4258 279.962L17.9008 275.612H22.9258L25.4758 279.962L22.9258 284.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 341.012H17.8242L15.1992 336.512L17.8242 332.012H23.0742L25.6242 336.512L23.0742 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 352.337H17.8242L15.1992 347.837L17.8242 343.262H23.0742L25.6242 347.837L23.0742 352.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.825 359.837H20L19.625 359.087L20 358.412H20.825L21.275 359.087L20.825 359.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 527.538H66.8008L64.1758 522.963L66.8008 518.463H71.9758L74.6008 522.963L71.9758 527.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 533.162H76.5508L73.9258 528.662L76.5508 524.162H81.8008L84.4258 528.662L81.8008 533.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 538.787H86.375L83.75 534.287L86.375 529.787H91.55L94.175 534.287L91.55 538.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.374 544.412H96.1242L93.5742 539.987L96.1242 535.487H101.374L103.924 539.987L101.374 544.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.451 412.187H635.826L634.551 409.937L635.826 407.763H638.451L639.726 409.937L638.451 412.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.576 357.587H634.701L632.301 353.462L634.701 349.262H639.576L641.976 353.462L639.576 357.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 346.637H634.551L631.926 342.137L634.551 337.637H639.726L642.351 342.137L639.726 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 335.388H634.551L631.926 330.812L634.551 326.312H639.726L642.351 330.812L639.726 335.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.148 321.287H636.123L635.148 319.562L636.123 317.837H638.148L639.123 319.562L638.148 321.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 312.737H634.551L631.926 308.237L634.551 303.737H639.726L642.351 308.237L639.726 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 301.487H634.551L631.926 296.912L634.551 292.412H639.726L642.351 296.912L639.726 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 290.163H634.551L631.926 285.663L634.551 281.088H639.726L642.351 285.663L639.726 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 278.838H634.551L631.926 274.338L634.551 269.838H639.726L642.351 274.338L639.726 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 267.512H634.551L631.926 263.012L634.551 258.512H639.726L642.351 263.012L639.726 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 256.263H634.551L631.926 251.763L634.551 247.188H639.726L642.351 251.763L639.726 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 244.938H634.551L631.926 240.438L634.551 235.938H639.726L642.351 240.438L639.726 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 233.612H634.551L631.926 229.112L634.551 224.612H639.726L642.351 229.112L639.726 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 222.362H634.551L631.926 217.787L634.551 213.287H639.726L642.351 217.787L639.726 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 211.038H634.551L631.926 206.538L634.551 201.963H639.726L642.351 206.538L639.726 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 199.713H634.551L631.926 195.213L634.551 190.713H639.726L642.351 195.213L639.726 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 188.462H634.551L631.926 183.887L634.551 179.387H639.726L642.351 183.887L639.726 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 177.137H634.551L631.926 172.637L634.551 168.062H639.726L642.351 172.637L639.726 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 165.812H634.551L631.926 161.312L634.551 156.812H639.726L642.351 161.312L639.726 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 154.488H634.551L631.926 149.988L634.551 145.488H639.726L642.351 149.988L639.726 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 143.237H634.551L631.926 138.662L634.551 134.162H639.726L642.351 138.662L639.726 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 131.913H634.551L631.926 127.413L634.551 122.838H639.726L642.351 127.413L639.726 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 126.288H624.727L622.102 121.713L624.727 117.213H629.977L632.602 121.713L629.977 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 120.588H614.977L612.352 116.088L614.977 111.588H620.151L622.776 116.088L620.151 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 114.962H605.148L602.523 110.462L605.148 105.887H610.398L612.948 110.462L610.398 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 109.337H595.398L592.773 104.762L595.398 100.262H600.573L603.198 104.762L600.573 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 103.637H585.574L582.949 99.1375L585.574 94.6375H590.824L593.374 99.1375L590.824 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 98.0125H575.824L573.199 93.5125L575.824 88.9375H580.999L583.624 93.5125L580.999 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 92.3875H566L563.375 87.8125L566 83.3125H571.25L573.8 87.8125L571.25 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 86.6875H556.175L553.625 82.1875L556.175 77.6875H561.425L564.05 82.1875L561.425 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.676 81.0624H546.426L543.801 76.5624L546.426 71.9874H551.676L554.226 76.5624L551.676 81.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.774 75.2874H536.674L534.199 70.8624L536.674 66.5125H541.774L544.324 70.8624L541.774 75.2874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.002 18.7375H203.902L201.352 14.3875L203.902 9.96252H209.002L211.477 14.3875L209.002 18.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.249 24.5125H193.999L191.449 20.0125L193.999 15.5125H199.249L201.874 20.0125L199.249 24.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.425 30.2125H184.25L181.625 25.6375L184.25 21.1375H189.425L192.05 25.6375L189.425 30.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.675 35.8375H174.425L171.875 31.3375L174.425 26.7625H179.675L182.3 31.3375L179.675 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.851 41.4625H164.676L162.051 36.9625L164.676 32.4625H169.851L172.476 36.9625L169.851 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 47.1625H154.852L152.227 42.5875L154.852 38.0875H160.102L162.727 42.5875L160.102 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 52.7875H145.102L142.477 48.2875L145.102 43.7125H150.277L152.902 48.2875L150.277 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 58.4125H135.273L132.648 53.9125L135.273 49.4125H140.523L143.148 53.9125L140.523 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 64.1125H125.523L122.898 59.5375L125.523 55.0375H130.698L133.323 59.5375L130.698 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3 66.9625H117.35L116.375 65.2374L117.35 63.5125H119.3L120.275 65.2374L119.3 66.9625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4492 83.0125H88.4742L87.9492 82.1875L88.4742 81.2875H89.4492L89.9742 82.1875L89.4492 83.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 92.3875H76.5508L73.9258 87.8125L76.5508 83.3125H81.8008L84.4258 87.8125L81.8008 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 98.0125H66.8008L64.1758 93.5125L66.8008 88.9375H71.9758L74.6008 93.5125L71.9758 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6266 102.662H57.5766L55.4766 99.1374L57.5766 95.6124H61.6266L63.7266 99.1374L61.6266 102.662Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2734 107.388H48.2734L46.7734 104.763L48.2734 102.213H51.2734L52.8484 104.763L51.2734 107.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6484 114.962H37.3984L34.7734 110.462L37.3984 105.887H42.6484L45.1984 110.462L42.6484 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8234 120.588H27.6484L25.0234 116.088L27.6484 111.588H32.8234L35.4484 116.088L32.8234 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 126.288H17.8242L15.1992 121.713L17.8242 117.213H23.0742L25.6242 121.713L23.0742 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 131.913H8.07422L5.44922 127.413L8.07422 122.838H13.2492L15.8742 127.413L13.2492 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 143.237H8.07422L5.44922 138.662L8.07422 134.162H13.2492L15.8742 138.662L13.2492 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 154.487H8.07422L5.44922 149.987L8.07422 145.487H13.2492L15.8742 149.987L13.2492 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 165.812H8.07422L5.44922 161.312L8.07422 156.812H13.2492L15.8742 161.312L13.2492 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 177.137H8.07422L5.44922 172.637L8.07422 168.062H13.2492L15.8742 172.637L13.2492 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 188.462H8.07422L5.44922 183.887L8.07422 179.387H13.2492L15.8742 183.887L13.2492 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 199.712H8.07422L5.44922 195.212L8.07422 190.712H13.2492L15.8742 195.212L13.2492 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 211.037H8.07422L5.44922 206.537L8.07422 201.962H13.2492L15.8742 206.537L13.2492 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 222.362H8.07422L5.44922 217.787L8.07422 213.287H13.2492L15.8742 217.787L13.2492 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 233.612H8.07422L5.44922 229.112L8.07422 224.612H13.2492L15.8742 229.112L13.2492 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 244.938H8.07422L5.44922 240.438L8.07422 235.938H13.2492L15.8742 240.438L13.2492 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 256.263H8.07422L5.44922 251.763L8.07422 247.188H13.2492L15.8742 251.763L13.2492 256.263Z",
    fill: "#F0CB55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 267.512H8.07422L5.44922 263.012L8.07422 258.512H13.2492L15.8742 263.012L13.2492 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 278.837H8.07422L5.44922 274.337L8.07422 269.837H13.2492L15.8742 274.337L13.2492 278.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4266 288.662H8.90158L7.10156 285.662L8.90158 282.587H12.4266L14.1516 285.662L12.4266 288.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 324.062H8.07422L5.44922 319.562L8.07422 314.987H13.2492L15.8742 319.562L13.2492 324.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0234 334.937H8.29842L5.89844 330.812L8.29842 326.762H13.0234L15.3484 330.812L13.0234 334.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 346.637H8.07422L5.44922 342.137L8.07422 337.637H13.2492L15.8742 342.137L13.2492 346.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8984 538.637H66.8734L64.3984 534.287L66.8734 529.937H71.8984L74.3734 534.287L71.8984 538.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 544.488H76.5508L73.9258 539.988L76.5508 535.412H81.8008L84.4258 539.988L81.8008 544.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 550.112H86.375L83.75 545.612L86.375 541.112H91.55L94.175 545.612L91.55 550.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5 552.513H98L97.25 551.238L98 549.963H99.5L100.25 551.238L99.5 552.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.398 419.988H644.448L641.898 415.638L644.448 411.287H649.398L651.948 415.638L649.398 419.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.724 396.137H645.124L643.324 392.987L645.124 389.912H648.724L650.524 392.987L648.724 396.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.451 348.812H646.326L645.801 347.837L646.326 346.862H647.451L648.051 347.837L647.451 348.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.826 338.087H646.026L645.051 336.512L646.026 334.862H647.826L648.801 336.512L647.826 338.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.873 328.562H644.974L643.023 325.188L644.974 321.812H648.873L650.823 325.188L648.873 328.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.401 318.212H644.452L641.977 313.862L644.452 309.587H649.401L651.877 313.862L649.401 318.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 307.112H644.301L641.676 302.612L644.301 298.037H649.551L652.176 302.612L649.551 307.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 295.787H644.301L641.676 291.287L644.301 286.787H649.551L652.176 291.287L649.551 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 284.538H644.301L641.676 279.963L644.301 275.463H649.551L652.176 279.963L649.551 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 273.212H644.301L641.676 268.712L644.301 264.137H649.551L652.176 268.712L649.551 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 261.887H644.301L641.676 257.387L644.301 252.887H649.551L652.176 257.387L649.551 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 250.562H644.301L641.676 246.062L644.301 241.562H649.551L652.176 246.062L649.551 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 239.312H644.301L641.676 234.737L644.301 230.237H649.551L652.176 234.737L649.551 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 227.987H644.301L641.676 223.487L644.301 218.912H649.551L652.176 223.487L649.551 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 216.662H644.301L641.676 212.162L644.301 207.662H649.551L652.176 212.162L649.551 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 205.413H644.301L641.676 200.838L644.301 196.338H649.551L652.176 200.838L649.551 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 194.087H644.301L641.676 189.587L644.301 185.012H649.551L652.176 189.587L649.551 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 182.762H644.301L641.676 178.262L644.301 173.762H649.551L652.176 178.262L649.551 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 171.438H644.301L641.676 166.938L644.301 162.438H649.551L652.176 166.938L649.551 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 160.188H644.301L641.676 155.613L644.301 151.113H649.551L652.176 155.613L649.551 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 148.862H644.301L641.676 144.362L644.301 139.787H649.551L652.176 144.362L649.551 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 137.537H644.301L641.676 133.037L644.301 128.537H649.551L652.176 133.037L649.551 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 126.288H644.301L641.676 121.713L644.301 117.213H649.551L652.176 121.713L649.551 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 120.588H634.551L631.926 116.088L634.551 111.588H639.726L642.351 116.088L639.726 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 114.962H624.727L622.102 110.462L624.727 105.887H629.977L632.602 110.462L629.977 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 109.337H614.977L612.352 104.762L614.977 100.262H620.151L622.776 104.762L620.151 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 103.637H605.148L602.523 99.1375L605.148 94.6375H610.398L612.948 99.1375L610.398 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 98.0125H595.398L592.773 93.5125L595.398 88.9375H600.573L603.198 93.5125L600.573 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 92.3875H585.574L582.949 87.8125L585.574 83.3125H590.824L593.374 87.8125L590.824 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 86.6875H575.824L573.199 82.1875L575.824 77.6875H580.999L583.624 82.1875L580.999 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.25 81.0626H566L563.375 76.5626L566 71.9875H571.25L573.8 76.5626L571.25 81.0626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.425 75.3625H556.175L553.625 70.8625L556.175 66.3625H561.425L564.05 70.8625L561.425 75.3625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.398 67.5625H547.623L546.273 65.2375L547.623 62.8375H550.398L551.748 65.2375L550.398 67.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.976 17.9875H184.776L182.676 14.3875L184.776 10.7125H188.976L191.076 14.3875L188.976 17.9875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.151 23.6125H175.026L172.926 20.0125L175.026 16.4125H179.151L181.176 20.0125L179.151 23.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.25 29.1625H165.275L163.25 25.6375L165.275 22.1875H169.25L171.275 25.6375L169.25 29.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.102 35.8375H154.852L152.227 31.3375L154.852 26.7625H160.102L162.727 31.3375L160.102 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.277 41.4625H145.102L142.477 36.9625L145.102 32.4625H150.277L152.902 36.9625L150.277 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.523 47.1625H135.273L132.648 42.5875L135.273 38.0875H140.523L143.148 42.5875L140.523 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 52.7875H125.523L122.898 48.2875L125.523 43.7125H130.698L133.323 48.2875L130.698 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.526 56.0125H117.126L115.926 53.9124L117.126 51.8875H119.526L120.726 53.9124L119.526 56.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.975 63.8125H106.1L103.625 59.5375L106.1 55.3375H110.975L113.45 59.5375L110.975 63.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8984 86.5375H66.8734L64.3984 82.1875L66.8734 77.8375H71.8984L74.3734 82.1875L71.8984 86.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2266 92.3875H56.9766L54.3516 87.8125L56.9766 83.3125H62.2266L64.8516 87.8125L62.2266 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 98.0125H47.2266L44.6016 93.5125L47.2266 88.9375H52.4016L55.0266 93.5125L52.4016 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6516 103.637H37.4016L34.8516 99.1375L37.4016 94.6375H42.6516L45.2016 99.1375L42.6516 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6008 108.813H27.8758L25.5508 104.763L27.8758 100.713H32.6008L34.9258 104.763L32.6008 108.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 114.962H17.8242L15.1992 110.462L17.8242 105.887H23.0742L25.6242 110.462L23.0742 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2492 120.588H8.07422L5.44922 116.088L8.07422 111.588H13.2492L15.8742 116.088L13.2492 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 126.288H-1.75L-4.375 121.713L-1.75 117.213H3.5L6.05 121.713L3.5 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 137.537H-1.75L-4.375 133.037L-1.75 128.537H3.5L6.05 133.037L3.5 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 148.862H-1.75L-4.375 144.362L-1.75 139.787H3.5L6.05 144.362L3.5 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 160.188H-1.75L-4.375 155.613L-1.75 151.113H3.5L6.05 155.613L3.5 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 171.438H-1.75L-4.375 166.938L-1.75 162.438H3.5L6.05 166.938L3.5 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 182.762H-1.75L-4.375 178.262L-1.75 173.762H3.5L6.05 178.262L3.5 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 194.087H-1.75L-4.375 189.587L-1.75 185.012H3.5L6.05 189.587L3.5 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 205.413H-1.75L-4.375 200.838L-1.75 196.338H3.5L6.05 200.838L3.5 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 216.662H-1.75L-4.375 212.162L-1.75 207.662H3.5L6.05 212.162L3.5 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 227.987H-1.75L-4.375 223.487L-1.75 218.912H3.5L6.05 223.487L3.5 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 239.312H-1.75L-4.375 234.737L-1.75 230.237H3.5L6.05 234.737L3.5 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 250.562H-1.75L-4.375 246.062L-1.75 241.562H3.5L6.05 246.062L3.5 250.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 261.887H-1.75L-4.375 257.387L-1.75 252.887H3.5L6.05 257.387L3.5 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 273.212H-1.75L-4.375 268.712L-1.75 264.137H3.5L6.05 268.712L3.5 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35155 284.312H-1.67344L-4.14844 279.962L-1.67344 275.612H3.35155L5.90157 279.962L3.35155 284.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54842 315.062H0.198433L-0.476562 313.862L0.198433 312.737H1.54842L2.22342 313.862L1.54842 315.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42421 329.688H-1.75079L-4.30078 325.188L-1.75079 320.688H3.42421L6.04921 325.188L3.42421 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.425 341.012H-1.75L-4.375 336.512L-1.75 332.012H3.425L6.05 336.512L3.425 341.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.75 549.737H67.025L64.625 545.612L67.025 541.487H71.75L74.075 545.612L71.75 549.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 555.812H76.5508L73.9258 551.237L76.5508 546.737H81.8008L84.4258 551.237L81.8008 555.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 561.437H86.375L83.75 556.937L86.375 552.362H91.55L94.175 556.937L91.55 561.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.15 504.587H654.275L651.875 500.388L654.275 496.263H659.15L661.55 500.388L659.15 504.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.299 493.562H654.124L651.574 489.062L654.124 484.638H659.299L661.849 489.062L659.299 493.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.948 479.912H655.474L654.273 477.812L655.474 475.638H657.948L659.148 477.812L657.948 479.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.849 425.013H654.573L652.398 421.263L654.573 417.588H658.849L661.023 421.263L658.849 425.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 403.187H654.125L651.5 398.687L654.125 394.112H659.3L661.925 398.687L659.3 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 391.862H654.125L651.5 387.362L654.125 382.862H659.3L661.925 387.362L659.3 391.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.352 377.087H656.077L655.477 376.037L656.077 374.987H657.352L657.952 376.037L657.352 377.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 312.737H654.125L651.5 308.237L654.125 303.737H659.3L661.925 308.237L659.3 312.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 301.487H654.125L651.5 296.912L654.125 292.412H659.3L661.925 296.912L659.3 301.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 290.163H654.125L651.5 285.663L654.125 281.088H659.3L661.925 285.663L659.3 290.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 278.838H654.125L651.5 274.338L654.125 269.838H659.3L661.925 274.338L659.3 278.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 267.512H654.125L651.5 263.012L654.125 258.512H659.3L661.925 263.012L659.3 267.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 256.263H654.125L651.5 251.763L654.125 247.188H659.3L661.925 251.763L659.3 256.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 244.938H654.125L651.5 240.438L654.125 235.938H659.3L661.925 240.438L659.3 244.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 233.612H654.125L651.5 229.112L654.125 224.612H659.3L661.925 229.112L659.3 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 222.362H654.125L651.5 217.787L654.125 213.287H659.3L661.925 217.787L659.3 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 211.038H654.125L651.5 206.538L654.125 201.963H659.3L661.925 206.538L659.3 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 199.713H654.125L651.5 195.213L654.125 190.713H659.3L661.925 195.213L659.3 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 188.462H654.125L651.5 183.887L654.125 179.387H659.3L661.925 183.887L659.3 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 177.137H654.125L651.5 172.637L654.125 168.062H659.3L661.925 172.637L659.3 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 165.812H654.125L651.5 161.312L654.125 156.812H659.3L661.925 161.312L659.3 165.812Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 154.488H654.125L651.5 149.988L654.125 145.488H659.3L661.925 149.988L659.3 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 143.237H654.125L651.5 138.662L654.125 134.162H659.3L661.925 138.662L659.3 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 131.913H654.125L651.5 127.413L654.125 122.838H659.3L661.925 127.413L659.3 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 120.588H654.125L651.5 116.088L654.125 111.588H659.3L661.925 116.088L659.3 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 114.962H644.301L641.676 110.462L644.301 105.887H649.551L652.176 110.462L649.551 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 109.337H634.551L631.926 104.762L634.551 100.262H639.726L642.351 104.762L639.726 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 103.637H624.727L622.102 99.1375L624.727 94.6375H629.977L632.602 99.1375L629.977 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 98.0125H614.977L612.352 93.5125L614.977 88.9375H620.151L622.776 93.5125L620.151 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.398 92.3875H605.148L602.523 87.8125L605.148 83.3125H610.398L612.948 87.8125L610.398 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 86.6875H595.398L592.773 82.1875L595.398 77.6875H600.573L603.198 82.1875L600.573 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 81.0626H585.574L582.949 76.5626L585.574 71.9875H590.824L593.374 76.5626L590.824 81.0626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 75.3625H575.824L573.199 70.8625L575.824 66.3625H580.999L583.624 70.8625L580.999 75.3625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.174 69.6624H565.999L563.449 65.2374L565.999 60.7374H571.174L573.799 65.2374L571.174 69.6624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.55 60.8125H558.05L557.375 59.5374L558.05 58.2625H559.55L560.3 59.5374L559.55 60.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.602 28.9375H145.852L143.977 25.6375L145.852 22.4125H149.602L151.477 25.6375L149.602 28.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.374 35.6125H135.424L132.949 31.3375L135.424 27.0625H140.374L142.849 31.3375L140.374 35.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.698 41.4625H125.523L122.898 36.9625L125.523 32.4625H130.698L133.323 36.9625L130.698 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.151 44.0875H117.501L116.676 42.5875L117.501 41.1625H119.151L119.976 42.5875L119.151 44.0875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.374 51.5125H106.699L104.824 48.2875L106.699 45.0625H110.374L112.249 48.2875L110.374 51.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2 68.6875H77.15L75.125 65.2375L77.15 61.7125H81.2L83.15 65.2375L81.2 68.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6766 74.7625H67.1016L64.8516 70.8625L67.1016 66.9625H71.6766L73.9266 70.8625L71.6766 74.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.175 79.3375H57.95L56.375 76.5625L57.95 73.7125H61.175L62.825 76.5625L61.175 79.3375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.325 86.5375H47.3L44.75 82.1875L47.3 77.8375H52.325L54.875 82.1875L52.325 86.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7508 97.8625H27.7258L25.1758 93.5125L27.7258 89.1625H32.7508L35.2258 93.5125L32.7508 97.8625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.45 106.113H9.875L9.125 104.763L9.875 103.488H11.45L12.2 104.763L11.45 106.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 114.962H-1.75L-4.375 110.462L-1.75 105.887H3.5L6.05 110.462L3.5 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 561.437H66.8008L64.1758 556.937L66.8008 552.362H71.9758L74.6008 556.937L71.9758 561.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 567.062H76.5508L73.9258 562.562L76.5508 558.062H81.8008L84.4258 562.562L81.8008 567.062Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 572.688H86.375L83.75 568.188L86.375 563.688H91.55L94.175 568.188L91.55 572.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.026 513.962H655.401L654.051 511.712L655.401 509.388H658.026L659.376 511.712L658.026 513.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 510.587H663.875L661.25 506.013L663.875 501.513H669.125L671.75 506.013L669.125 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 499.263H663.875L661.25 494.763L663.875 490.188H669.125L671.75 494.763L669.125 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 487.938H663.875L661.25 483.438L663.875 478.938H669.125L671.75 483.438L669.125 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.375 475.412H664.625L662.75 472.113L664.625 468.888H668.375L670.25 472.113L668.375 475.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.976 408.587H664.026L661.551 404.312L664.026 400.037H668.976L671.451 404.312L668.976 408.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 397.562H663.875L661.25 392.987L663.875 388.487H669.125L671.75 392.987L669.125 397.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 386.237H663.875L661.25 381.737L663.875 377.162H669.125L671.75 381.737L669.125 386.237Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.677 374.162H664.327L662.227 370.412L664.327 366.662H668.677L670.776 370.412L668.677 374.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.898 306.662H664.099L661.773 302.612L664.099 298.487H668.898L671.224 302.612L668.898 306.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 295.787H663.875L661.25 291.287L663.875 286.787H669.125L671.75 291.287L669.125 295.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 284.538H663.875L661.25 279.963L663.875 275.463H669.125L671.75 279.963L669.125 284.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 273.212H663.875L661.25 268.712L663.875 264.137H669.125L671.75 268.712L669.125 273.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 261.887H663.875L661.25 257.387L663.875 252.887H669.125L671.75 257.387L669.125 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.923 248.537H665.073L663.648 246.062L665.073 243.662H667.923L669.349 246.062L667.923 248.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 239.312H663.875L661.25 234.737L663.875 230.237H669.125L671.75 234.737L669.125 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 227.987H663.875L661.25 223.487L663.875 218.912H669.125L671.75 223.487L669.125 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 216.662H663.875L661.25 212.162L663.875 207.662H669.125L671.75 212.162L669.125 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 205.413H663.875L661.25 200.838L663.875 196.338H669.125L671.75 200.838L669.125 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 194.087H663.875L661.25 189.587L663.875 185.012H669.125L671.75 189.587L669.125 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 182.762H663.875L661.25 178.262L663.875 173.762H669.125L671.75 178.262L669.125 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 171.438H663.875L661.25 166.938L663.875 162.438H669.125L671.75 166.938L669.125 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 160.188H663.875L661.25 155.613L663.875 151.113H669.125L671.75 155.613L669.125 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 148.862H663.875L661.25 144.362L663.875 139.787H669.125L671.75 144.362L669.125 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 137.537H663.875L661.25 133.037L663.875 128.537H669.125L671.75 133.037L669.125 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 126.288H663.875L661.25 121.713L663.875 117.213H669.125L671.75 121.713L669.125 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 114.962H663.875L661.25 110.462L663.875 105.887H669.125L671.75 110.462L669.125 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 109.337H654.125L651.5 104.762L654.125 100.262H659.3L661.925 104.762L659.3 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 103.637H644.301L641.676 99.1375L644.301 94.6375H649.551L652.176 99.1375L649.551 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 98.0125H634.551L631.926 93.5125L634.551 88.9375H639.726L642.351 93.5125L639.726 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.977 92.3875H624.727L622.102 87.8125L624.727 83.3125H629.977L632.602 87.8125L629.977 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.151 86.6875H614.977L612.352 82.1875L614.977 77.6875H620.151L622.776 82.1875L620.151 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.326 80.9875H605.226L602.676 76.5625L605.226 72.0625H610.326L612.876 76.5625L610.326 80.9875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.577 75.3625H595.401L592.852 70.8625L595.401 66.4375H600.577L603.127 70.8625L600.577 75.3625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.824 69.7375H585.574L582.949 65.2375L585.574 60.7375H590.824L593.374 65.2375L590.824 69.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.999 64.1125H575.824L573.199 59.5375L575.824 55.0375H580.999L583.624 59.5375L580.999 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.927 45.8875H547.102L545.227 42.5875L547.102 39.2875H550.927L552.877 42.5875L550.927 45.8875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.5 39.0625H538.025L536.75 36.9625L538.025 34.8625H540.5L541.7 36.9625L540.5 39.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.952 28.7875H126.352L124.477 25.6375L126.352 22.5625H129.952L131.752 25.6375L129.952 28.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.752 33.8125H116.902L115.477 31.3375L116.902 28.7875H119.752L121.252 31.3375L119.752 33.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.826 40.9374H106.251L103.926 36.9624L106.251 32.9874H110.826L113.151 36.9624L110.826 40.9374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.326 45.2875H97.1758L95.6758 42.5875L97.1758 39.9625H100.326L101.826 42.5875L100.326 45.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4766 52.5625H86.4516L83.9766 48.2875L86.4516 43.9375H91.4766L93.9516 48.2875L91.4766 52.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 58.4125H76.5508L73.9258 53.9125L76.5508 49.4125H81.8008L84.4258 53.9125L81.8008 58.4125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 64.1125H66.8008L64.1758 59.5375L66.8008 55.0375H71.9758L74.6008 59.5375L71.9758 64.1125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7258 67.1124H58.4758L57.4258 65.2374L58.4758 63.3624H60.7258L61.7758 65.2374L60.7258 67.1124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0508 73.0375H48.5008L47.3008 70.8625L48.5008 68.6875H51.0508L52.3258 70.8625L51.0508 73.0375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6516 89.9875H19.1766L17.9766 87.8125L19.1766 85.7125H21.6516L22.9266 87.8125L21.6516 89.9875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2016 96.2124H9.05157L7.47656 93.5124L9.05157 90.7374H12.2016L13.7766 93.5124L12.2016 96.2124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44843 101.912H-0.776581L-2.35156 99.1374L-0.776581 96.3624H2.44843L4.09842 99.1374L2.44843 101.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 572.687H66.8008L64.1758 568.187L66.8008 563.687H71.9758L74.6008 568.187L71.9758 572.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 578.387H76.5508L73.9258 573.887L76.5508 569.312H81.8008L84.4258 573.887L81.8008 578.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5492 583.938H86.3742L83.8242 579.513L86.3742 575.088H91.5492L94.0992 579.513L91.5492 583.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.573 524.462H655.849L655.023 522.962L655.849 521.537H657.573L658.398 522.962L657.573 524.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 521.838H663.875L661.25 517.338L663.875 512.838H669.125L671.75 517.338L669.125 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 516.213H673.699L671.074 511.713L673.699 507.213H678.874L681.499 511.713L678.874 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 504.888H673.699L671.074 500.388L673.699 495.888H678.874L681.499 500.388L678.874 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 493.638H673.699L671.074 489.062L673.699 484.562H678.874L681.499 489.062L678.874 493.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 482.312H673.699L671.074 477.812L673.699 473.237H678.874L681.499 477.812L678.874 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.801 470.837H673.776L671.301 466.488L673.776 462.138H678.801L681.276 466.488L678.801 470.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.776 455.988H675.802L675.352 455.162L675.802 454.412H676.776L677.227 455.162L676.776 455.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.901 401.462H674.677L673.102 398.687L674.677 395.912H677.901L679.477 398.687L677.901 401.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.151 388.788H675.427L674.602 387.363L675.427 385.938H677.151L677.977 387.363L677.151 388.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.901 378.812H674.677L673.102 376.037L674.677 373.262H677.901L679.477 376.037L677.901 378.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.599 310.487H674.974L673.699 308.237L674.974 305.987H677.599L678.874 308.237L677.599 310.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.076 298.338H675.501L674.676 296.913L675.501 295.562H677.076L677.901 296.913L677.076 298.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.648 289.712H673.923L671.523 285.662L673.923 281.537H678.648L681.048 285.662L678.648 289.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.802 278.687H673.776L671.227 274.337L673.776 269.987H678.802L681.352 274.337L678.802 278.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.701 263.762H675.876L675.426 263.012L675.876 262.262H676.701L677.151 263.012L676.701 263.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.373 253.562H675.198L674.148 251.762L675.198 249.887H677.373L678.423 251.762L677.373 253.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.575 244.413H674L671.75 240.438L674 236.463H678.575L680.825 240.438L678.575 244.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 233.612H673.699L671.074 229.112L673.699 224.612H678.874L681.499 229.112L678.874 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 222.362H673.699L671.074 217.787L673.699 213.287H678.874L681.499 217.787L678.874 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 211.038H673.699L671.074 206.538L673.699 201.963H678.874L681.499 206.538L678.874 211.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 199.713H673.699L671.074 195.213L673.699 190.713H678.874L681.499 195.213L678.874 199.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 188.462H673.699L671.074 183.887L673.699 179.387H678.874L681.499 183.887L678.874 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 177.137H673.699L671.074 172.637L673.699 168.062H678.874L681.499 172.637L678.874 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 165.812H673.699L671.074 161.312L673.699 156.812H678.874L681.499 161.312L678.874 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 154.488H673.699L671.074 149.988L673.699 145.488H678.874L681.499 149.988L678.874 154.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 143.237H673.699L671.074 138.662L673.699 134.162H678.874L681.499 138.662L678.874 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 131.913H673.699L671.074 127.413L673.699 122.838H678.874L681.499 127.413L678.874 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 120.588H673.699L671.074 116.088L673.699 111.588H678.874L681.499 116.088L678.874 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 109.337H673.699L671.074 104.762L673.699 100.262H678.874L681.499 104.762L678.874 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 103.637H663.875L661.25 99.1375L663.875 94.6375H669.125L671.75 99.1375L669.125 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.3 98.0125H654.125L651.5 93.5125L654.125 88.9375H659.3L661.925 93.5125L659.3 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.551 92.3875H644.301L641.676 87.8125L644.301 83.3125H649.551L652.176 87.8125L649.551 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.726 86.6875H634.551L631.926 82.1875L634.551 77.6875H639.726L642.276 82.1875L639.726 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.474 78.5125H626.148L625.023 76.5625L626.148 74.5375H628.474L629.673 76.5625L628.474 78.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.975 67.2625H606.575L605.375 65.2374L606.575 63.1375H608.975L610.175 65.2374L608.975 67.2625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.573 64.0374H595.398L592.773 59.5374L595.398 55.1124H600.573L603.123 59.5374L600.573 64.0374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.073 39.0624H557.598L556.398 36.9624L557.598 34.8624H560.073L561.273 36.9624L560.073 39.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.123 23.1624H116.523L114.648 20.0124L116.523 16.8624H120.123L121.998 20.0124L120.123 23.1624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.124 30.2125H105.949L103.324 25.6375L105.949 21.1375H111.124L113.749 25.6375L111.124 30.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 35.8375H96.125L93.5 31.3375L96.125 26.7625H101.375L104 31.3375L101.375 35.8375Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 41.4625H86.375L83.75 36.9625L86.375 32.4625H91.55L94.175 36.9625L91.55 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 47.1625H76.5508L73.9258 42.5875L76.5508 38.0875H81.8008L84.4258 42.5875L81.8008 47.1625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 52.7875H66.8008L64.1758 48.2875L66.8008 43.7125H71.9758L74.6008 48.2875L71.9758 52.7875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8516 57.8124H57.3516L55.1016 53.9124L57.3516 50.0125H61.8516L64.1016 53.9124L61.8516 57.8124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8734 63.2125H47.7484L45.6484 59.5375L47.7484 55.9375H51.8734L53.9734 59.5375L51.8734 63.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7008 66.3624H39.3508L38.6758 65.2374L39.3508 64.1124H40.7008L41.3008 65.2374L40.7008 66.3624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0742 81.0624H17.8242L15.1992 76.5624L17.8242 71.9874H23.0742L25.6242 76.5624L23.0742 81.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5266 83.6125H9.80157L8.97656 82.1875L9.80157 80.6875H11.5266L12.3516 82.1875L11.5266 83.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 92.3875H-1.75L-4.375 87.8125L-1.75 83.3125H3.5L6.05 87.8125L3.5 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6766 583.412H67.1016L64.8516 579.512L67.1016 575.612H71.6766L73.9266 579.512L71.6766 583.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 589.712H76.5508L73.9258 585.138L76.5508 580.638H81.8008L84.4258 585.138L81.8008 589.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7508 592.112H88.1758L87.4258 590.837L88.1758 589.487H89.7508L90.5008 590.837L89.7508 592.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.349 519.588H684.799L683.449 517.338L684.799 515.088H687.349L688.699 517.338L687.349 519.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 510.587H683.449L680.824 506.013L683.449 501.513H688.699L691.324 506.013L688.699 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 499.263H683.449L680.824 494.763L683.449 490.188H688.699L691.324 494.763L688.699 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 487.938H683.449L680.824 483.438L683.449 478.938H688.699L691.324 483.438L688.699 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 476.687H683.449L680.824 472.112L683.449 467.612H688.699L691.324 472.112L688.699 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 465.363H683.449L680.824 460.863L683.449 456.287H688.699L691.324 460.863L688.699 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.127 406.187H685.026L683.977 404.312L685.026 402.437H687.127L688.177 404.312L687.127 406.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.474 397.262H683.674L681.199 392.987L683.674 388.787H688.474L690.949 392.987L688.474 397.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 329.688H683.449L680.824 325.188L683.449 320.688H688.699L691.324 325.188L688.699 329.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.877 249.212H684.276L682.477 246.062L684.276 242.987H687.877L689.677 246.062L687.877 249.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 239.312H683.449L680.824 234.737L683.449 230.237H688.699L691.324 234.737L688.699 239.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 227.987H683.449L680.824 223.487L683.449 218.912H688.699L691.324 223.487L688.699 227.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 216.662H683.449L680.824 212.162L683.449 207.662H688.699L691.324 212.162L688.699 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 205.413H683.449L680.824 200.838L683.449 196.338H688.699L691.324 200.838L688.699 205.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 194.087H683.449L680.824 189.587L683.449 185.012H688.699L691.324 189.587L688.699 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 182.762H683.449L680.824 178.262L683.449 173.762H688.699L691.324 178.262L688.699 182.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 171.438H683.449L680.824 166.938L683.449 162.438H688.699L691.324 166.938L688.699 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 160.188H683.449L680.824 155.613L683.449 151.113H688.699L691.324 155.613L688.699 160.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 148.862H683.449L680.824 144.362L683.449 139.787H688.699L691.324 144.362L688.699 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 137.537H683.449L680.824 133.037L683.449 128.537H688.699L691.324 133.037L688.699 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 126.288H683.449L680.824 121.713L683.449 117.213H688.699L691.324 121.713L688.699 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 114.962H683.449L680.824 110.462L683.449 105.887H688.699L691.324 110.462L688.699 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 103.637H683.449L680.824 99.1375L683.449 94.6375H688.699L691.324 99.1375L688.699 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.874 98.0125H673.699L671.074 93.5125L673.699 88.9375H678.874L681.499 93.5125L678.874 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.125 92.3875H663.875L661.25 87.8125L663.875 83.3125H669.125L671.75 87.8125L669.125 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.174 84.6625H655.249L653.824 82.1875L655.249 79.7125H658.174L659.599 82.1875L658.174 84.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.775 23.5375H96.725L94.625 20.0125L96.725 16.4875H100.775L102.875 20.0125L100.775 23.5375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.55 30.2125H86.375L83.75 25.6375L86.375 21.1375H91.55L94.175 25.6375L91.55 30.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 35.8375H76.5508L73.9258 31.3375L76.5508 26.7625H81.8008L84.4258 31.3375L81.8008 35.8375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 41.4625H66.8008L64.1758 36.9625L66.8008 32.4625H71.9758L74.6008 36.9625L71.9758 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1734 45.2875H58.0234L56.5234 42.5875L58.0234 39.9625H61.1734L62.6734 42.5875L61.1734 45.2875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8734 51.8875H47.7484L45.6484 48.2875L47.7484 44.6875H51.8734L53.9734 48.2875L51.8734 51.8875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9516 60.8125H29.5266L28.8516 59.5375L29.5266 58.3375H30.9516L31.6266 59.5375L30.9516 60.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6234 68.9875H18.2734L16.0234 65.2375L18.2734 61.4125H22.6234L24.7984 65.2375L22.6234 68.9875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7492 72.7374H9.57422L8.44922 70.8624L9.57422 68.9874H11.7492L12.8742 70.8624L11.7492 72.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04921 80.3875H-1.37579L-3.55078 76.5625L-1.37579 72.6625H3.04921L5.29921 76.5625L3.04921 80.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.775 593.312H67.925L66.5 590.837L67.925 588.362H70.775L72.2 590.837L70.775 593.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8008 600.963H76.5508L73.9258 596.463L76.5508 591.963H81.8008L84.4258 596.463L81.8008 600.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4 606.287H86.525L84.125 602.087L86.525 597.888H91.4L93.8 602.087L91.4 606.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8758 609.738H97.6258L96.4258 607.787L97.6258 605.763H99.8758L101.076 607.787L99.8758 609.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.852 515.162H693.877L691.852 511.712L693.877 508.263H697.852L699.877 511.712L697.852 515.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 504.888H693.273L690.648 500.388L693.273 495.888H698.448L701.073 500.388L698.448 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 493.637H693.273L690.648 489.062L693.273 484.562H698.448L701.073 489.062L698.448 493.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 482.312H693.273L690.648 477.812L693.273 473.237H698.448L701.073 477.812L698.448 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 470.987H693.273L690.648 466.487L693.273 461.987H698.448L701.073 466.487L698.448 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 459.738H693.273L690.648 455.162L693.273 450.662H698.448L701.073 455.162L698.448 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.775 447.212H693.95L692 443.912L693.95 440.537H697.775L699.725 443.912L697.775 447.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.875 355.187H694.85L693.875 353.462L694.85 351.737H696.875L697.85 353.462L696.875 355.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.65 343.563H695.075L694.25 342.138L695.075 340.713H696.65L697.475 342.138L696.65 343.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.375 256.037H693.425L690.875 251.762L693.425 247.412H698.375L700.85 251.762L698.375 256.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.775 243.738H693.95L692 240.438L693.95 237.062H697.775L699.725 240.438L697.775 243.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 233.612H693.273L690.648 229.112L693.273 224.612H698.448L701.073 229.112L698.448 233.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 222.362H693.273L690.648 217.787L693.273 213.287H698.448L701.073 217.787L698.448 222.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 211.037H693.273L690.648 206.537L693.273 201.962H698.448L701.073 206.537L698.448 211.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 199.712H693.273L690.648 195.212L693.273 190.712H698.448L701.073 195.212L698.448 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 188.462H693.273L690.648 183.887L693.273 179.387H698.448L701.073 183.887L698.448 188.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 177.137H693.273L690.648 172.637L693.273 168.062H698.448L701.073 172.637L698.448 177.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 165.812H693.273L690.648 161.312L693.273 156.812H698.448L701.073 161.312L698.448 165.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 154.487H693.273L690.648 149.987L693.273 145.487H698.448L701.073 149.987L698.448 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 143.237H693.273L690.648 138.662L693.273 134.162H698.448L701.073 138.662L698.448 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 131.913H693.273L690.648 127.413L693.273 122.838H698.448L701.073 127.413L698.448 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 120.588H693.273L690.648 116.088L693.273 111.588H698.448L701.073 116.088L698.448 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 109.337H693.273L690.648 104.762L693.273 100.262H698.448L701.073 104.762L698.448 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 98.0125H693.273L690.648 93.5125L693.273 88.9375H698.448L701.073 93.5125L698.448 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.699 92.3875H683.449L680.824 87.8125L683.449 83.3125H688.699L691.324 87.8125L688.699 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.748 84.6625H674.823L673.398 82.1875L674.823 79.7125H677.748L679.173 82.1875L677.748 84.6625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7484 22.7125H77.5984L76.0234 20.0125L77.5984 17.3125H80.7484L82.3234 20.0125L80.7484 22.7125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9758 30.2125H66.8008L64.1758 25.6375L66.8008 21.1375H71.9758L74.6008 25.6375L71.9758 30.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4734 34.5625H57.7234L55.7734 31.3375L57.7234 28.0375H61.4734L63.3484 31.3375L61.4734 34.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4016 41.4625H47.2266L44.6016 36.9625L47.2266 32.4625H52.4016L55.0266 36.9625L52.4016 41.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4516 61.0374H9.80157L8.97656 59.5374L9.80157 58.1124H11.4516L12.2766 59.5374L11.4516 61.0374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35078 69.5125H-1.59921L-4.07422 65.2375L-1.59921 60.9625H3.35078L5.75079 65.2375L3.35078 69.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 510.587H703.023L700.398 506.013L703.023 501.513H708.273L710.898 506.013L708.273 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 499.262H703.023L700.398 494.762L703.023 490.187H708.273L710.898 494.762L708.273 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 487.937H703.023L700.398 483.437L703.023 478.937H708.273L710.898 483.437L708.273 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 476.687H703.023L700.398 472.112L703.023 467.612H708.273L710.898 472.112L708.273 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 465.363H703.023L700.398 460.863L703.023 456.287H708.273L710.898 460.863L708.273 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 454.037H703.023L700.398 449.537L703.023 445.037H708.273L710.898 449.537L708.273 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.399 439.562H704.899L704.074 438.212L704.899 436.862H706.399L707.224 438.212L706.399 439.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.2 352.187H703.1L700.625 347.837L703.1 343.412H708.2L710.675 347.837L708.2 352.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.6 272.087H703.7L701.75 268.712L703.7 265.262H707.6L709.55 268.712L707.6 272.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.024 258.063H705.274L704.824 257.388L705.274 256.713H706.024L706.474 257.388L706.024 258.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.124 227.763H703.174L700.699 223.488L703.174 219.213H708.124L710.599 223.488L708.124 227.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 216.662H703.023L700.398 212.162L703.023 207.662H708.273L710.898 212.162L708.273 216.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 205.412H703.023L700.398 200.837L703.023 196.337H708.273L710.898 200.837L708.273 205.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 194.087H703.023L700.398 189.587L703.023 185.012H708.273L710.898 189.587L708.273 194.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.201 182.688H703.101L700.551 178.263L703.101 173.838H708.201L710.751 178.263L708.201 182.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.374 169.937H703.924L702.199 166.937L703.924 164.012H707.374L709.099 166.937L707.374 169.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 160.187H703.023L700.398 155.612L703.023 151.112H708.273L710.898 155.612L708.273 160.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 148.862H703.023L700.398 144.362L703.023 139.787H708.273L710.898 144.362L708.273 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 137.537H703.023L700.398 133.037L703.023 128.537H708.273L710.898 133.037L708.273 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 126.288H703.023L700.398 121.713L703.023 117.213H708.273L710.898 121.713L708.273 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 114.962H703.023L700.398 110.462L703.023 105.887H708.273L710.898 110.462L708.273 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 103.637H703.023L700.398 99.1375L703.023 94.6375H708.273L710.898 99.1375L708.273 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.273 92.3875H703.023L700.398 87.8125L703.023 83.3125H708.273L710.898 87.8125L708.273 92.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.448 86.6875H693.273L690.648 82.1875L693.273 77.6875H698.448L701.073 82.1875L698.448 86.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.349 78.7375H684.798L683.523 76.5625L684.798 74.3125H687.349L688.623 76.5625L687.349 78.7375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0492 20.7625H59.1492L58.6992 20.0125L59.1492 19.2625H60.0492L60.4992 20.0125L60.0492 20.7625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2242 26.4625H49.3992L48.9492 25.6375L49.3992 24.8875H50.2242L50.6742 25.6375L50.2242 26.4625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85156 55.6375H-0.0984192L-1.14844 53.9125L-0.0984192 52.1875H1.85156L2.82658 53.9125L1.85156 55.6375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.449 524.762H714.424L713.449 522.962L714.424 521.237H716.449L717.424 522.962L716.449 524.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 516.213H712.852L710.227 511.713L712.852 507.213H718.026L720.651 511.713L718.026 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 504.888H712.852L710.227 500.388L712.852 495.888H718.026L720.651 500.388L718.026 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 493.637H712.852L710.227 489.062L712.852 484.562H718.026L720.651 489.062L718.026 493.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 482.312H712.852L710.227 477.812L712.852 473.237H718.026L720.651 477.812L718.026 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 470.987H712.852L710.227 466.487L712.852 461.987H718.026L720.651 466.487L718.026 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 459.738H712.852L710.227 455.162L712.852 450.662H718.026L720.651 455.162L718.026 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 448.413H712.852L710.227 443.913L712.852 439.338H718.026L720.651 443.913L718.026 448.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.675 434.687H714.2L713 432.587L714.2 430.487H716.675L717.875 432.587L716.675 434.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.901 401.162H713.976L712.551 398.687L713.976 396.138H716.901L718.326 398.687L716.901 401.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.949 391.638H712.924L710.449 387.363L712.924 383.088H717.949L720.424 387.363L717.949 391.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.877 267.213H713.002L710.602 263.013L713.002 258.812H717.877L720.276 263.013L717.877 267.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.926 218.688H714.951L714.426 217.788L714.951 216.963H715.926L716.451 217.788L715.926 218.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 210.962H712.851L710.301 206.537L712.851 202.037H718.026L720.651 206.537L718.026 210.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 199.712H712.852L710.227 195.212L712.852 190.712H718.026L720.651 195.212L718.026 199.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 188.388H712.851L710.301 183.888L712.851 179.463H718.026L720.576 183.888L718.026 188.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.526 174.512H714.352L713.227 172.637L714.352 170.688H716.526L717.651 172.637L716.526 174.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.95 154.337H712.925L710.375 149.987L712.925 145.637H717.95L720.5 149.987L717.95 154.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 143.237H712.852L710.227 138.662L712.852 134.162H718.026L720.651 138.662L718.026 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 131.913H712.852L710.227 127.413L712.852 122.838H718.026L720.651 127.413L718.026 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 120.588H712.852L710.227 116.088L712.852 111.588H718.026L720.651 116.088L718.026 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 109.337H712.852L710.227 104.762L712.852 100.262H718.026L720.651 104.762L718.026 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.026 98.0125H712.852L710.227 93.5125L712.852 88.9375H718.026L720.651 93.5125L718.026 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.401 69.2125H683.751L681.426 65.2375L683.751 61.1875H688.401L690.726 65.2375L688.401 69.2125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.35 63.1375H674.225L672.125 59.5374L674.225 56.0125H678.35L680.45 59.5374L678.35 63.1375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.976 529.937H724.476L723.801 528.662L724.476 527.388H725.976L726.651 528.662L725.976 529.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 521.838H722.602L719.977 517.338L722.602 512.838H727.852L730.477 517.338L727.852 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 510.587H722.602L719.977 506.013L722.602 501.513H727.852L730.477 506.013L727.852 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 499.262H722.602L719.977 494.762L722.602 490.187H727.852L730.477 494.762L727.852 499.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 487.937H722.602L719.977 483.437L722.602 478.937H727.852L730.477 483.437L727.852 487.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 476.687H722.602L719.977 472.112L722.602 467.612H727.852L730.477 472.112L727.852 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 465.363H722.602L719.977 460.863L722.602 456.287H727.852L730.477 460.863L727.852 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 454.037H722.602L719.977 449.537L722.602 445.037H727.852L730.477 449.537L727.852 454.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 442.713H722.602L719.977 438.213L722.602 433.713H727.852L730.477 438.213L727.852 442.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 261.887H722.602L719.977 257.387L722.602 252.887H727.852L730.477 257.387L727.852 261.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.573 225.812H723.873L722.523 223.487L723.873 221.087H726.573L727.923 223.487L726.573 225.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.049 202.262H724.399L723.574 200.837L724.399 199.412H726.049L726.874 200.837L726.049 202.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.877 192.437H723.577L721.852 189.587L723.577 186.662H726.877L728.602 189.587L726.877 192.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.175 181.712H723.275L721.25 178.262L723.275 174.812H727.175L729.2 178.262L727.175 181.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 148.862H722.602L719.977 144.362L722.602 139.787H727.852L730.477 144.362L727.852 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 137.537H722.602L719.977 133.037L722.602 128.537H727.852L730.477 133.037L727.852 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 126.288H722.602L719.977 121.713L722.602 117.213H727.852L730.477 121.713L727.852 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 114.962H722.602L719.977 110.462L722.602 105.887H727.852L730.477 110.462L727.852 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.852 103.637H722.602L719.977 99.1375L722.602 94.6375H727.852L730.477 99.1375L727.852 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.9 89.0125H724.55L723.875 87.8125L724.55 86.6875H725.9L726.575 87.8125L725.9 89.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.625 548.462H733.4L731.75 545.613L733.4 542.763H736.625L738.275 545.613L736.625 548.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 538.787H732.426L729.801 534.287L732.426 529.787H737.601L740.226 534.287L737.601 538.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 527.538H732.426L729.801 522.963L732.426 518.463H737.601L740.226 522.963L737.601 527.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 516.213H732.426L729.801 511.713L732.426 507.213H737.601L740.226 511.713L737.601 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 504.888H732.426L729.801 500.388L732.426 495.888H737.601L740.226 500.388L737.601 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 493.638H732.426L729.801 489.062L732.426 484.562H737.601L740.226 489.062L737.601 493.638Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 482.312H732.426L729.801 477.812L732.426 473.237H737.601L740.226 477.812L737.601 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 470.987H732.426L729.801 466.487L732.426 461.987H737.601L740.226 466.487L737.601 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 459.738H732.426L729.801 455.162L732.426 450.662H737.601L740.226 455.162L737.601 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.648 411.062H734.373L733.773 409.937L734.373 408.888H735.648L736.248 409.937L735.648 411.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 403.187H732.426L729.801 398.687L732.426 394.112H737.601L740.226 398.687L737.601 403.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.298 255.737H732.724L730.398 251.762L732.724 247.712H737.298L739.623 251.762L737.298 255.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.552 243.062H733.477L731.977 240.438L733.477 237.812H736.552L738.052 240.438L736.552 243.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.95 230.687H734.15L733.25 229.112L734.15 227.537H735.95L736.85 229.112L735.95 230.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.374 221.913H732.649L730.324 217.788L732.649 213.738H737.374L739.699 217.788L737.374 221.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.1 197.088H733.925L732.875 195.213L733.925 193.338H736.1L737.15 195.213L736.1 197.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.524 154.337H732.499L729.949 149.987L732.499 145.637H737.524L740.074 149.987L737.524 154.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 143.237H732.426L729.801 138.662L732.426 134.162H737.601L740.226 138.662L737.601 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 131.913H732.426L729.801 127.413L732.426 122.838H737.601L740.226 127.413L737.601 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 120.588H732.426L729.801 116.088L732.426 111.588H737.601L740.226 116.088L737.601 120.588Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 109.337H732.426L729.801 104.762L732.426 100.262H737.601L740.226 104.762L737.601 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.601 98.0125H732.426L729.801 93.5125L732.426 88.9375H737.601L740.226 93.5125L737.601 98.0125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 555.737H742.175L739.625 551.237L742.175 546.737H747.425L749.975 551.237L747.425 555.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.075 542.162H743.525L742.25 539.987L743.525 537.737H746.075L747.35 539.987L746.075 542.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 533.162H742.175L739.625 528.662L742.175 524.162H747.425L750.05 528.662L747.425 533.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 521.838H742.175L739.625 517.338L742.175 512.838H747.425L750.05 517.338L747.425 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 510.587H742.175L739.625 506.013L742.175 501.513H747.425L750.05 506.013L747.425 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 499.263H742.175L739.625 494.763L742.175 490.188H747.425L750.05 494.763L747.425 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 487.938H742.175L739.625 483.438L742.175 478.938H747.425L750.05 483.438L747.425 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 476.687H742.175L739.625 472.112L742.175 467.612H747.425L750.05 472.112L747.425 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 465.363H742.175L739.625 460.863L742.175 456.287H747.425L750.05 460.863L747.425 465.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.849 451.337H743.748L742.773 449.537L743.748 447.737H745.849L746.898 449.537L745.849 451.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.349 419.988H742.248L739.773 415.638L742.248 411.213H747.349L749.898 415.638L747.349 419.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 408.812H742.175L739.625 404.312L742.175 399.812H747.425L750.05 404.312L747.425 408.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.398 394.113H744.198L743.523 392.988L744.198 391.938H745.398L746.073 392.988L745.398 394.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.45 158.537H743.15L741.5 155.612L743.15 152.762H746.45L748.1 155.612L746.45 158.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 148.862H742.175L739.625 144.362L742.175 139.787H747.425L750.05 144.362L747.425 148.862Z",
    fill: "#392DCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 137.537H742.175L739.625 133.037L742.175 128.537H747.425L750.05 133.037L747.425 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 126.288H742.175L739.625 121.713L742.175 117.213H747.425L750.05 121.713L747.425 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.425 114.962H742.175L739.625 110.462L742.175 105.887H747.425L750.05 110.462L747.425 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.349 103.563H742.249L739.699 99.1375L742.249 94.7125H747.349L749.899 99.1375L747.349 103.563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.226 546.662H754.026L753.426 545.613L754.026 544.562H755.226L755.826 545.613L755.226 546.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.101 538.562H752.151L749.676 534.287L752.151 530.013H757.101L759.501 534.287L757.101 538.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 527.538H752L749.375 522.963L752 518.463H757.175L759.8 522.963L757.175 527.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 516.213H752L749.375 511.713L752 507.213H757.175L759.8 511.713L757.175 516.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 504.888H752L749.375 500.388L752 495.888H757.175L759.8 500.388L757.175 504.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 493.638H752L749.375 489.062L752 484.562H757.175L759.8 489.062L757.175 493.638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 482.312H752L749.375 477.812L752 473.237H757.175L759.8 477.812L757.175 482.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 470.987H752L749.375 466.487L752 461.987H757.175L759.8 466.487L757.175 470.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 459.738H752L749.375 455.162L752 450.662H757.175L759.8 455.162L757.175 459.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.948 447.887H752.298L749.898 443.912L752.298 439.862H756.948L759.273 443.912L756.948 447.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.448 434.013H753.724L752.898 432.588L753.724 431.088H755.448L756.273 432.588L755.448 434.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.025 425.462H752.225L749.75 421.263L752.225 417.138H757.025L759.425 421.263L757.025 425.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 414.513H752L749.375 409.938L752 405.438H757.175L759.8 409.938L757.175 414.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 143.162H752L749.375 138.662L752 134.162H757.175L759.8 138.662L757.175 143.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 131.913H752L749.375 127.413L752 122.838H757.175L759.8 127.413L757.175 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 120.588H752L749.375 116.088L752 111.588H757.175L759.8 116.088L757.175 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.175 109.337H752L749.375 104.762L752 100.262H757.175L759.8 104.762L757.175 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.952 531.363H762.802L761.227 528.663L762.802 525.963H765.952L767.526 528.663L765.952 531.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 521.838H761.749L759.199 517.338L761.749 512.838H766.999L769.624 517.338L766.999 521.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 510.587H761.749L759.199 506.013L761.749 501.513H766.999L769.624 506.013L766.999 510.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 499.263H761.749L759.199 494.763L761.749 490.188H766.999L769.624 494.763L766.999 499.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 487.938H761.749L759.199 483.438L761.749 478.938H766.999L769.624 483.438L766.999 487.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 476.687H761.749L759.199 472.112L761.749 467.612H766.999L769.624 472.112L766.999 476.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.625 464.763H762.125L759.875 460.863L762.125 456.888H766.625L768.875 460.863L766.625 464.763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.923 419.988H761.823L759.273 415.638L761.823 411.213H766.923L769.474 415.638L766.923 419.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.898 190.413H763.923L763.398 189.587L763.923 188.688H764.898L765.349 189.587L764.898 190.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.775 182.462H761.975L759.5 178.262L761.975 174.062H766.775L769.25 178.262L766.775 182.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 171.438H761.749L759.199 166.938L761.749 162.438H766.999L769.624 166.938L766.999 171.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.927 160.037H761.827L759.352 155.612L761.827 151.262H766.927L769.477 155.612L766.927 160.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.648 146.538H763.099L761.898 144.362L763.099 142.188H765.648L766.923 144.362L765.648 146.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 137.537H761.749L759.199 133.037L761.749 128.537H766.999L769.624 133.037L766.999 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 126.288H761.749L759.199 121.713L761.749 117.213H766.999L769.624 121.713L766.999 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.999 114.962H761.749L759.199 110.462L761.749 105.887H766.999L769.624 110.462L766.999 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.927 103.487H761.901L759.352 99.1375L761.901 94.7875H766.927L769.401 99.1375L766.927 103.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.151 515.162H772.177L770.227 511.712L772.177 508.263H776.151L778.177 511.712L776.151 515.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.749 504.888H771.574L768.949 500.388L771.574 495.888H776.749L779.374 500.388L776.749 504.888Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.748 493.488H771.648L769.023 489.062L771.648 484.638H776.748L779.298 489.062L776.748 493.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.925 480.738H772.475L770.75 477.812L772.475 474.812H775.925L777.65 477.812L775.925 480.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.176 422.988H773.151L772.176 421.263L773.151 419.537H775.176L776.151 421.263L775.176 422.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.675 176.912H771.725L769.25 172.637L771.725 168.287H776.675L779.15 172.637L776.675 176.912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.752 165.737H771.651L769.102 161.312L771.651 156.887H776.752L779.302 161.312L776.752 165.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.748 154.487H771.573L769.023 149.987L771.573 145.562H776.748L779.298 149.987L776.748 154.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.749 143.237H771.574L768.949 138.662L771.574 134.162H776.749L779.374 138.662L776.749 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.749 131.913H771.574L768.949 127.413L771.574 122.838H776.749L779.374 127.413L776.749 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.749 120.588H771.574L768.949 116.088L771.574 111.588H776.749L779.374 116.088L776.749 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.749 109.337H771.574L768.949 104.762L771.574 100.262H776.749L779.374 104.762L776.749 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.325 95.4626H773L771.875 93.5126L773 91.4875H775.325L776.45 93.5126L775.325 95.4626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.924 473.838H782.974L782.074 472.113L782.974 470.463H784.924L785.899 472.113L784.924 473.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.627 461.988H783.276L782.602 460.863L783.276 459.662H784.627L785.302 460.863L784.627 461.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.573 148.862H781.398L778.773 144.362L781.398 139.862H786.573L789.198 144.362L786.573 148.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.573 137.537H781.323L778.773 133.037L781.323 128.537H786.573L789.198 133.037L786.573 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.573 126.288H781.323L778.773 121.713L781.323 117.213H786.573L789.198 121.713L786.573 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.573 114.962H781.323L778.773 110.462L781.323 105.887H786.573L789.198 110.462L786.573 114.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.573 103.637H781.398L778.773 99.1375L781.398 94.6375H786.573L789.198 99.1375L786.573 103.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.523 151.337H793.023L792.273 149.987L793.023 148.712H794.523L795.273 149.987L794.523 151.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.398 143.237H791.148L788.523 138.662L791.148 134.162H796.398L798.948 138.662L796.398 143.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.398 131.913H791.148L788.523 127.413L791.148 122.838H796.398L798.948 127.413L796.398 131.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.398 120.588H791.148L788.523 116.088L791.148 111.588H796.398L798.948 116.088L796.398 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.398 109.337H791.148L788.523 104.762L791.148 100.262H796.398L798.948 104.762L796.398 109.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.975 574.713H803.075L802.625 573.888L803.075 573.062H803.975L804.5 573.888L803.975 574.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.151 137.537H800.901L798.352 133.037L800.901 128.537H806.151L808.776 133.037L806.151 137.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.151 126.288H800.901L798.352 121.713L800.901 117.213H806.151L808.776 121.713L806.151 126.288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.151 114.962H800.901L798.352 110.462L800.901 105.887H806.151L808.776 110.462L806.151 114.962Z",
    fill: "#B95BA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.124 100.188H802.924L802.324 99.1375L802.924 98.0875H804.124L804.724 99.1375L804.124 100.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.824 572.538H810.799L808.324 568.188L810.799 563.838H815.824L818.374 568.188L815.824 572.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.175 558.363H812.45L811.625 556.938L812.45 555.438H814.175L815.075 556.938L814.175 558.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.102 139.937H812.602L811.852 138.662L812.602 137.387H814.102L814.776 138.662L814.102 139.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.925 130.112H811.775L810.125 127.412L811.775 124.637H814.925L816.5 127.412L814.925 130.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.977 120.588H810.727L808.102 116.088L810.727 111.588H815.977L818.526 116.088L815.977 120.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.449 108.438H811.174L809.074 104.763L811.174 101.088H815.449L817.549 104.763L815.449 108.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.673 565.262H821.599L820.023 562.562L821.599 559.862H824.673L826.173 562.562L824.673 565.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.501 555.437H820.701L818.301 551.237L820.701 547.112H825.501L827.901 551.237L825.501 555.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.9 124.862H821.3L819.5 121.712L821.3 118.637H824.9L826.775 121.712L824.9 124.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.827 113.387H821.452L819.727 110.462L821.452 107.537H824.827L826.477 110.462L824.827 113.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.45 557.837H832.4L831.875 556.937L832.4 556.037H833.45L833.975 556.937L833.45 557.837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.499 548.388H831.274L829.699 545.613L831.274 542.838H834.499L836.149 545.613L834.499 548.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.749 535.787H832.024L831.199 534.287L832.024 532.862H833.749L834.574 534.287L833.749 535.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.35 129.888H831.5L830 127.413L831.5 124.863H834.35L835.775 127.413L834.35 129.888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.427 118.713H831.427L829.852 116.088L831.427 113.463H834.427L835.927 116.088L834.427 118.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.849 543.738H840.499L838.324 539.988L840.499 536.162H844.849L847.099 539.988L844.849 543.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.299 533.087H840.124L837.574 528.662L840.124 524.162H845.299L847.849 528.662L845.299 533.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.199 518.238H842.149L841.699 517.338L842.149 516.438H843.199L843.724 517.338L843.199 518.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.25 524.312H851.75L851 522.963L851.75 521.688H853.25L854 522.963L853.25 524.312Z",
    fill: "#EBECF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_23473_20656",
    x: -256,
    y: 0.807373,
    width: 1170,
    height: 758.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.04195
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.382515
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0313726 0 0 0 0 0.262745 0 0 0 0.0414311 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23473_20656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.1755
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.21508
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.252036 0 0 0 0 0.19566 0 0 0 0 0.670833 0 0 0 0.0458509 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23473_20656",
    result: "effect2_dropShadow_23473_20656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26.9063
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.0307
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.209938 0 0 0 0 0.141163 0 0 0 0 0.720833 0 0 0 0.0469633 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_23473_20656",
    result: "effect3_dropShadow_23473_20656"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 89.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.220859 0 0 0 0 0.148507 0 0 0 0 0.758333 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_23473_20656",
    result: "effect4_dropShadow_23473_20656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_23473_20656",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMap);
export default __webpack_public_path__ + "static/media/empty_map.3a4f982c81d0535825470dc227449907.svg";
export { ForwardRef as ReactComponent };